import React, { useContext, useState, useCallback, useEffect, Component, createContext, useRef } from 'react';
import { Link, useMediaQuery, makeStyles, DialogContent, DialogContentText, Typography, TextField, DialogActions, Button, ButtonBase, Box, Dialog, CircularProgress, DialogTitle, useTheme, InputAdornment, withStyles, Switch, FormControlLabel, lighten, FormControl, InputLabel, Select, MenuItem, List, ListItem } from '@material-ui/core';
import Cookies from 'universal-cookie';
import ChevronRight$1 from '@material-ui/icons/ChevronRight';
import { makeStyles as makeStyles$1 } from '@material-ui/core/styles';
import clsx from 'clsx';
import { ProductTypeTableNames } from '@themaven-net/tundra-types';
import fetch$1 from 'isomorphic-unfetch';
import cloneDeep from 'lodash/cloneDeep';
import merge from 'lodash/merge';
import CheckCircle from '@material-ui/icons/CheckCircle';
import Error$1 from '@material-ui/icons/Error';
import Check from '@material-ui/icons/Check';
import { useCookies } from 'react-cookie';
import TimeAgo from 'javascript-time-ago';
import en from 'javascript-time-ago/locale/en';
import { partition } from 'lodash';
import RemoveCircleOutlineIcon from '@material-ui/icons/RemoveCircleOutline';
import { ToggleButtonGroup, ToggleButton } from '@material-ui/lab';

const getLinkRel = (target) => (target === '_blank' ? 'noopener' : undefined);
const windowExists = () => typeof window !== 'undefined';
const enter = (func) => (e) => {
    if (e.key === 'Enter') {
        func(e);
    }
};
const isValidUrl = (url) => {
    if (!url) {
        return false;
    }
    return /^(http|https)?:\/\//i.test(url);
};
const validEmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
const isValidEmail = (email) => {
    if (!email)
        return false;
    return Boolean(email.match(validEmailRegex));
};

const BasicLink = props => {
    return (React.createElement(Link, { href: props.to, className: props.className, underline: props.underline, onClick: props.trackClickHandler, "track-breadcrumb": "item", rel: getLinkRel(props === null || props === void 0 ? void 0 : props.target), target: props.target }, props.children));
};
const DefaultProviderValue = {
    Link: BasicLink,
    isMobile: false,
    isTablet: false,
    isServer: false,
    touchScreen: false,
    mavenApi: 'https://maven.io/api',
    imageProxyOrigin: 'https://imageproxy.themaven.net/',
    currentUser: undefined
};
const SodoContext = React.createContext(DefaultProviderValue);

function useMobile() {
    const sodoContext = useContext(SodoContext);
    const mqResult = useMediaQuery(theme => theme.breakpoints.down('xs'));
    if (sodoContext.isServer) {
        return sodoContext.isMobile;
    }
    return mqResult;
}
function useTablet() {
    const sodoContext = useContext(SodoContext);
    const mqResult = useMediaQuery(theme => theme.breakpoints.between('sm', 'md'));
    if (sodoContext.isServer) {
        return sodoContext.isTablet;
    }
    return mqResult;
}
function useDesktopOrHD() {
    const sodoContext = useContext(SodoContext);
    const mqResult = useMediaQuery(theme => theme.breakpoints.up('lg'));
    if (sodoContext.isServer) {
        return !sodoContext.isTablet && !sodoContext.isMobile;
    }
    return mqResult;
}

const useToggle = (initialValue) => {
    const [value, setValue] = useState(initialValue);
    const toggle = useCallback((nextValue) => (nextValue ? setValue(Boolean(nextValue)) : setValue(currentValue => !currentValue)), [setValue]);
    return [value, toggle];
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

var TaigaValidationFailureReason;
(function (TaigaValidationFailureReason) {
    TaigaValidationFailureReason["NotAvailable"] = "That username is not available";
    TaigaValidationFailureReason["TooShort"] = "Username too short";
    TaigaValidationFailureReason["TooLong"] = "Username too long";
    TaigaValidationFailureReason["ProhibitedCharacter"] = "Username can contain only letters, numbers, and the characters -_.$*'";
    TaigaValidationFailureReason["UserHasExistingDisplayName"] = "You already have a username";
})(TaigaValidationFailureReason || (TaigaValidationFailureReason = {}));
const validateUsername = (username, taigaApiBase) => {
    const [usernameError, setUsernameError] = useState(undefined);
    useEffect(() => {
        const validate = () => __awaiter(void 0, void 0, void 0, function* () {
            const validResp = yield fetch(taigaApiBase + '/api/user/validate/displayName', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ displayName: username })
            }).then(r => r.json());
            if (validResp.isValid) {
                setUsernameError('');
            }
            else {
                const reason = validResp.reason;
                const errorMessage = TaigaValidationFailureReason[reason];
                setUsernameError(errorMessage);
            }
        });
        if (username) {
            validate();
        }
    }, [username]);
    return usernameError;
};

var Priority;
(function (Priority) {
    Priority[Priority["HIGH"] = 1] = "HIGH";
    Priority[Priority["MEDIUM"] = 10] = "MEDIUM";
    Priority[Priority["LOW"] = 100] = "LOW";
})(Priority || (Priority = {}));
var TimeUnit;
(function (TimeUnit) {
    TimeUnit["FRAME"] = "FRAME";
    TimeUnit["MS"] = "MS";
})(TimeUnit || (TimeUnit = {}));
class Scheduler {
    constructor(isClient, debug) {
        this.getHighPriorityTasks = () => this.tasks.filter(t => t.priority <= Priority.MEDIUM);
        this.getLowPriorityTasks = () => this.tasks.filter(t => t.priority > Priority.MEDIUM);
        this.isClient = isClient;
        this.debug = debug;
        this.frameNum = 0;
        this.lowPrioFrameNum = 0;
        this.taskCount = 0;
        this.paused = false;
        this.tasks = [];
        this.durations = [];
        this.framePending = false;
        this.lowPriorityFramePending = false;
        Scheduler.defaultScheduler = this;
    }
    pause() {
        this.paused = true;
    }
    play() {
        this.paused = false;
        this.maybeRequest();
    }
    cancel(key) {
        this.tasks = this.tasks.filter(t => t.task.key !== key);
    }
    schedule(task) {
        if (task.key && this.tasks.find(t => t.task.key === task.key)) {
            if (task.cancelExisting) {
                this.cancel(task.key);
            }
            else {
                return false;
            }
        }
        let deadline = 0;
        let ticks = 0;
        if (task.delayUnits === TimeUnit.MS) {
            deadline = this.now() + (task.delay || 0);
        }
        else if (task.delayUnits === TimeUnit.FRAME) {
            ticks = task.delay || 0;
        }
        const taskInfo = {
            id: ++this.taskCount,
            task,
            deadline,
            ticks,
            priority: task.priority || Priority.MEDIUM
        };
        this.tasks.push(taskInfo);
        this.maybeRequest();
        return true;
    }
    remove(idOrKey) {
        this.tasks = this.tasks.filter(t => t.id !== idOrKey && t.task.key !== idOrKey);
    }
    maybeRequest() {
        if (this.getHighPriorityTasks().length > 0 && !this.framePending) {
            this.framePending = true;
            this.frame(tasks => this.runFrame(tasks));
        }
        if (this.getLowPriorityTasks().length > 0 && !this.lowPriorityFramePending) {
            this.lowPriorityFramePending = true;
            this.lowPriorityFrame(tasks => this.runFrame(tasks));
        }
    }
    updateHud() {
        if (!this.hudEl) {
            this.hudEl = document.createElement('div');
            this.hudEl.style.cssText =
                'font-size: 11px; border:1px solid red; position: fixed; top: 0; right: 0; padding:5px; background: black; color: red; font-family: monospace; width: 100px';
            document.body.appendChild(this.hudEl);
        }
        this.hudEl.innerHTML = `<div>
      <div>#: ${this.tasks.length}</div>
      <div>FPS ${'TODO'}</div>
    </div>`;
    }
    runFrame(tasks) {
        if (this.paused) {
            console.log('paused');
            return;
        }
        const now = this.now();
        const runMustEndBy = this.now() + Scheduler.NewFrameBudget;
        const taskKeys = tasks.map(t => t.task.key);
        try {
            tasks.sort((a, b) => a.priority - b.priority);
            while (tasks.length && this.now() < runMustEndBy) {
                const ti = tasks.shift();
                if (!ti) {
                    continue;
                }
                if (ti.deadline > now) {
                    continue;
                }
                if (--ti.ticks > 0) {
                    continue;
                }
                this.tasks = this.tasks.filter(t => t !== ti);
                ti.task.task();
                ti.complete = true;
            }
            if (tasks.length && this.debug) {
                console.warn('frame over budget', this.now() - now, taskKeys, tasks);
            }
        }
        catch (e) {
            console.error('error in scheduler', e);
        }
        this.durations.unshift(this.now() - now);
        this.durations = this.durations.slice(0, 1000);
        this.maybeRequest();
    }
    now() {
        return this.isClient ? window.performance.now() : ~~new Date();
    }
    requestIdleCallback(callback, options) {
        if (this.isClient && window.requestIdleCallback) {
            return window.requestIdleCallback(callback, options);
        }
        setTimeout(callback, 1000);
    }
    frame(callback) {
        requestAnimationFrame(() => {
            this.framePending = false;
            this.frameNum++;
            callback(this.getHighPriorityTasks());
            if (this.debug && this.frameNum % 10 === 0) {
                this.updateHud();
            }
        });
    }
    lowPriorityFrame(callback) {
        this.requestIdleCallback(() => {
            this.lowPriorityFramePending = false;
            this.lowPrioFrameNum++;
            callback(this.getLowPriorityTasks());
            if (this.debug && this.lowPrioFrameNum % 10 === 0) {
                this.updateHud();
            }
        }, { timeout: 500 });
    }
}
Scheduler.NewFrameBudget = 16;
new Scheduler(true, false);

let intersectionObserverIsPresent = false;
if (typeof window === 'object') {
    if (typeof IntersectionObserver !== 'function') {
        require('intersection-observer');
    }
    intersectionObserverIsPresent = true;
}
else {
    intersectionObserverIsPresent = false;
}
class IntersectionObserverHelper {
    constructor(options = { threshold: [0.9] }) {
        this.callbacks = new Map();
        this.unobserveCallbacks = new Map();
        this.observed = (entries) => {
            entries.forEach(entry => {
                const min = Math.min(...this.threshold);
                if (entry.intersectionRatio < min && this.unobserveCallbacks.has(entry.target)) {
                    this.unobserveCallbacks.get(entry.target)(entry);
                }
                if (entry.intersectionRatio > min && this.callbacks.has(entry.target)) {
                    if (this.callbacks.get(entry.target)(entry)) {
                        if (this.observer && this.observer.unobserve) {
                            this.observer.unobserve(entry.target);
                        }
                        this.callbacks.delete(entry.target);
                    }
                }
            });
        };
        this.threshold = typeof options.threshold === 'number' ? [options.threshold] : options.threshold;
        this.callbacks = new Map();
        this.unobserveCallbacks = new Map();
        this.enqueueForIntersectionObserver(() => {
            this.observer = new IntersectionObserver(this.observed, options);
        });
    }
    remove(element) {
        while (this.callbacks.has(element)) {
            this.callbacks.delete(element);
        }
        while (this.unobserveCallbacks.has(element)) {
            this.unobserveCallbacks.delete(element);
        }
    }
    addObservable(element, callback, unobserveCallback) {
        this.callbacks.set(element, callback);
        if (unobserveCallback) {
            this.unobserveCallbacks.set(element, unobserveCallback);
        }
        this.enqueueForIntersectionObserver(() => { var _a; return (_a = this === null || this === void 0 ? void 0 : this.observer) === null || _a === void 0 ? void 0 : _a.observe(element); });
    }
    enqueueForIntersectionObserver(callback) {
        if (intersectionObserverIsPresent) {
            callback();
            return;
        }
    }
}
const partialIntersectionObserverHelper = new IntersectionObserverHelper({ threshold: [0.1] });
const enterExitObserver = new IntersectionObserverHelper({ threshold: [0.01, 0.99] });
const halfPlusOne = new IntersectionObserverHelper({ threshold: 0.51 });
const quarterObserver = new IntersectionObserverHelper({ threshold: 0.25 });
const tenthsObserver = new IntersectionObserverHelper({
    threshold: Array(10)
        .fill(0)
        .map((_, i) => (i + 1) / 10)
});
var intersectionObserverHelper = new IntersectionObserverHelper();

var Type;
(function (Type) {
    Type[Type["View"] = 0] = "View";
    Type[Type["Navigation"] = 1] = "Navigation";
    Type[Type["UserRegistered"] = 2] = "UserRegistered";
    Type[Type["RescoreUser"] = 3] = "RescoreUser";
    Type[Type["Preview"] = 4] = "Preview";
    Type[Type["EnteredText"] = 5] = "EnteredText";
    Type[Type["ClearedText"] = 6] = "ClearedText";
    Type[Type["SentMessage"] = 7] = "SentMessage";
    Type[Type["ReadMore"] = 8] = "ReadMore";
})(Type || (Type = {}));
var ObserveAmount;
(function (ObserveAmount) {
    ObserveAmount[ObserveAmount["Most"] = 0] = "Most";
    ObserveAmount[ObserveAmount["Quarter"] = 1] = "Quarter";
    ObserveAmount[ObserveAmount["HalfPlusOne"] = 2] = "HalfPlusOne";
    ObserveAmount[ObserveAmount["ABit"] = 3] = "ABit";
    ObserveAmount[ObserveAmount["Tenths"] = 4] = "Tenths";
    ObserveAmount[ObserveAmount["EnterExit"] = 5] = "EnterExit";
})(ObserveAmount || (ObserveAmount = {}));
class Observable extends Component {
    constructor() {
        super(...arguments);
        this.observed = (o) => {
            const { flags, user, once } = this.props;
            const observedResponse = this.props.onObserved(o);
            if (!observedResponse) {
                return once;
            }
            const event = Object.assign({ loginToken: user && user.loginToken, flags, userAgent: navigator.userAgent, screenWidth: window.innerWidth }, observedResponse);
            if (this.props.appendUserEvent) {
                this.props.appendUserEvent(event);
            }
            return once;
        };
    }
    componentDidMount() {
        this.initObserver();
    }
    componentWillUnmount() {
        if (this.child) {
            this.getHelper(this.props.amount).remove(this.child);
        }
        if (this.props.onUnobserved) {
            this.props.onUnobserved();
        }
    }
    render() {
        return (React.createElement("div", { className: `observable ${this.props.className || ''}`, ref: child => {
                this.child = child;
            } }, this.props.children && React.cloneElement(this.props.children)));
    }
    getHelper(amount) {
        switch (amount) {
            case ObserveAmount.Quarter:
                return quarterObserver;
            case ObserveAmount.ABit:
                return partialIntersectionObserverHelper;
            case ObserveAmount.HalfPlusOne:
                return halfPlusOne;
            case ObserveAmount.Tenths:
                return tenthsObserver;
            case ObserveAmount.EnterExit:
                return enterExitObserver;
            default:
                return intersectionObserverHelper;
        }
    }
    initObserver() {
        const { once, amount } = this.props;
        let objectVisible = false;
        const boundingRect = this.child && this.child.getBoundingClientRect();
        if (boundingRect &&
            boundingRect.height > 0 &&
            boundingRect.bottom >= 0 &&
            boundingRect.top <= window.innerHeight &&
            boundingRect.right >= 0 &&
            boundingRect.left <= window.innerWidth) {
            objectVisible = true;
        }
        if (objectVisible) {
            Scheduler.defaultScheduler.schedule({
                task: () => this.observed(this.child),
                priority: Priority.MEDIUM
            });
            if (once) {
                return;
            }
        }
        if (this.child) {
            this.getHelper(amount).addObservable(this.child, this.observed, this.props.onUnobserved);
        }
    }
}

var BackgroundColor;
(function (BackgroundColor) {
    BackgroundColor["Default"] = "#fff";
    BackgroundColor["Paper"] = "#fff";
    BackgroundColor["Dark"] = "rgba(0, 0, 0, 0.8)";
})(BackgroundColor || (BackgroundColor = {}));
var CommonColor;
(function (CommonColor) {
    CommonColor["Black"] = "rgba(0, 0, 0, 1)";
    CommonColor["White"] = "#fff";
})(CommonColor || (CommonColor = {}));
var DividerColor;
(function (DividerColor) {
    DividerColor["Dark"] = "rgba(255, 255, 255, 0.3)";
    DividerColor["Light"] = "rgba(0, 0, 0, 0.12)";
})(DividerColor || (DividerColor = {}));
var ErrorColor;
(function (ErrorColor) {
    ErrorColor["ContrastText"] = "#fff";
    ErrorColor["Dark"] = "#d32f2f";
    ErrorColor["Light"] = "#e57373";
    ErrorColor["Main"] = "rgba(255, 70, 70, 1)";
})(ErrorColor || (ErrorColor = {}));
var FontFamily;
(function (FontFamily) {
    FontFamily["IbmPlexMono"] = "IBM Plex Mono";
    FontFamily["IbmPlexSans"] = "IBM Plex Sans";
    FontFamily["IbmPlexSerif"] = "IBM Plex Serif";
    FontFamily["Oswald"] = "Oswald";
    FontFamily["TitilliumWeb"] = "Titillium Web";
    FontFamily["HelveticaNeue"] = "Helvetica Neue";
    FontFamily["Arial"] = "Arial";
    FontFamily["SansSerif"] = "sans-serif";
    FontFamily["Serif"] = "serif";
    FontFamily["Roboto"] = "Roboto";
    FontFamily["Helvetica"] = "Helvetic";
    FontFamily["FreeSans"] = "FreeSans";
})(FontFamily || (FontFamily = {}));
var FontSize;
(function (FontSize) {
    FontSize[FontSize["H1"] = 46] = "H1";
    FontSize[FontSize["H2"] = 36] = "H2";
    FontSize[FontSize["H3"] = 22] = "H3";
    FontSize[FontSize["H4"] = 20] = "H4";
    FontSize[FontSize["H5"] = 18] = "H5";
    FontSize[FontSize["H6"] = 16] = "H6";
    FontSize[FontSize["Subtitle1"] = 20] = "Subtitle1";
    FontSize[FontSize["Subtitle2"] = 18] = "Subtitle2";
    FontSize[FontSize["Body1"] = 16] = "Body1";
    FontSize[FontSize["Body2"] = 14] = "Body2";
    FontSize[FontSize["Paragraph"] = 16] = "Paragraph";
    FontSize[FontSize["ParagraphLarge"] = 18] = "ParagraphLarge";
    FontSize[FontSize["ParagraphXLarge"] = 22] = "ParagraphXLarge";
})(FontSize || (FontSize = {}));
var MobileFontSize;
(function (MobileFontSize) {
    MobileFontSize[MobileFontSize["H1"] = 40] = "H1";
    MobileFontSize[MobileFontSize["H2"] = 28] = "H2";
})(MobileFontSize || (MobileFontSize = {}));
var FontWeight;
(function (FontWeight) {
    FontWeight[FontWeight["Normal"] = 400] = "Normal";
    FontWeight[FontWeight["Medium"] = 500] = "Medium";
    FontWeight["Bold"] = "bold";
})(FontWeight || (FontWeight = {}));
var LineHeight;
(function (LineHeight) {
    LineHeight[LineHeight["H1"] = 64] = "H1";
    LineHeight[LineHeight["H2"] = 40] = "H2";
    LineHeight[LineHeight["H3"] = 26] = "H3";
    LineHeight[LineHeight["H4"] = 24] = "H4";
    LineHeight[LineHeight["H5"] = 24] = "H5";
    LineHeight[LineHeight["H6"] = 21] = "H6";
    LineHeight[LineHeight["Subtitle1"] = 34] = "Subtitle1";
    LineHeight[LineHeight["Subtitle2"] = 32] = "Subtitle2";
    LineHeight[LineHeight["Body1"] = 21] = "Body1";
    LineHeight[LineHeight["Body2"] = 19] = "Body2";
    LineHeight[LineHeight["Paragraph"] = 28] = "Paragraph";
    LineHeight[LineHeight["ParagraphLarge"] = 32] = "ParagraphLarge";
    LineHeight[LineHeight["ParagraphXLarge"] = 36] = "ParagraphXLarge";
})(LineHeight || (LineHeight = {}));
var MobileLineHeight;
(function (MobileLineHeight) {
    MobileLineHeight[MobileLineHeight["H1"] = 50] = "H1";
    MobileLineHeight[MobileLineHeight["H2"] = 32] = "H2";
})(MobileLineHeight || (MobileLineHeight = {}));
var PaletteType;
(function (PaletteType) {
    PaletteType["Dark"] = "dark";
    PaletteType["Light"] = "light";
})(PaletteType || (PaletteType = {}));
var PrimaryColor;
(function (PrimaryColor) {
    PrimaryColor["ContrastText"] = "#fff";
    PrimaryColor["Dark"] = "#303f9f";
    PrimaryColor["Light"] = "#7986cb";
    PrimaryColor["Main"] = "rgba(0, 69, 255, 1)";
})(PrimaryColor || (PrimaryColor = {}));
var RelativeSize;
(function (RelativeSize) {
    RelativeSize[RelativeSize["Full"] = 0] = "Full";
    RelativeSize[RelativeSize["Large"] = 1] = "Large";
    RelativeSize[RelativeSize["Medium"] = 2] = "Medium";
    RelativeSize[RelativeSize["Small"] = 3] = "Small";
})(RelativeSize || (RelativeSize = {}));
var SecondaryColor;
(function (SecondaryColor) {
    SecondaryColor["ContrastText"] = "#fff";
    SecondaryColor["Dark"] = "#c51162";
    SecondaryColor["Light"] = "#ff4081";
    SecondaryColor["Main"] = "rgba(255, 70, 70, 1)";
})(SecondaryColor || (SecondaryColor = {}));
var TextColor;
(function (TextColor) {
    TextColor["Disabled"] = "rgba(0, 0, 0, 0.27)";
    TextColor["Hint"] = "rgba(0, 0, 0, 0.38)";
    TextColor["Primary"] = "rgba(0, 0, 0, 1)";
    TextColor["Secondary"] = "rgba(0, 0, 0, 0.72)";
})(TextColor || (TextColor = {}));
var TextColorDark;
(function (TextColorDark) {
    TextColorDark["Disabled"] = "rgba(255, 255, 255, 0.5)";
    TextColorDark["Hint"] = "rgba(255, 255, 255, 0.4)";
    TextColorDark["Primary"] = "rgba(255, 255, 255, 1)";
    TextColorDark["Secondary"] = "rgba(255, 255, 255, 0.65)";
})(TextColorDark || (TextColorDark = {}));
var QuoteColor;
(function (QuoteColor) {
    QuoteColor["Default"] = "#F5F8FD";
    QuoteColor["Active"] = "#000";
    QuoteColor["Link"] = "rgba(0, 69, 255, 1)";
    QuoteColor["Grey"] = "rgba(255, 255, 255, 0.65)";
})(QuoteColor || (QuoteColor = {}));
[
    FontFamily.IbmPlexSans,
    FontFamily.HelveticaNeue,
    FontFamily.Arial,
    FontFamily.SansSerif
].join();
[FontFamily.IbmPlexSerif, FontFamily.Serif].join();
[
    FontFamily.Roboto,
    FontFamily.HelveticaNeue,
    FontFamily.Helvetica,
    FontFamily.FreeSans,
    FontFamily.Arial,
    FontFamily.SansSerif
].join();
[
    FontFamily.IbmPlexMono,
    FontFamily.HelveticaNeue,
    FontFamily.Arial,
    FontFamily.SansSerif
].join();

const TheStreetLogo = props => (React.createElement("svg", { width: "100", height: "23", viewBox: "0 0 100 23", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { d: "M11.4682 0.461917H0.871239C0.756183 0.461614 0.642214 0.484307 0.535943 0.528679C0.429672 0.57305 0.333215 0.638218 0.25217 0.720399C0.171125 0.80258 0.107105 0.90014 0.0638246 1.00742C0.0205442 1.11469 -0.00113471 1.22955 4.57404e-05 1.34533V3.08299C0.00297997 3.31335 0.0961306 3.53323 0.259257 3.69487C0.422384 3.85651 0.642307 3.94683 0.871239 3.94622H3.45585C3.5252 3.9471 3.5937 3.96172 3.65743 3.98923C3.72116 4.01675 3.77889 4.05664 3.8273 4.10661C3.87572 4.15658 3.91388 4.21565 3.9396 4.28047C3.96533 4.34528 3.97811 4.41455 3.97723 4.48434V21.6637C3.97723 21.8962 4.06902 22.1192 4.2324 22.2836C4.39578 22.448 4.61737 22.5404 4.84842 22.5404H7.46423C7.6949 22.5398 7.91592 22.4472 8.07882 22.2828C8.24171 22.1185 8.33319 21.8958 8.33319 21.6637V4.48434C8.33377 4.34555 8.38851 4.21254 8.48562 4.11398C8.58273 4.01542 8.71443 3.9592 8.85234 3.95743H11.4682C11.6982 3.95743 11.9189 3.86561 12.0818 3.70211C12.2447 3.5386 12.3365 3.31676 12.3371 3.08524V1.34533C12.3383 1.22974 12.3167 1.11507 12.2735 1.00794C12.2304 0.900807 12.1666 0.803349 12.0858 0.721197C12.005 0.639046 11.9088 0.573832 11.8028 0.529327C11.6967 0.484823 11.583 0.461911 11.4682 0.461917Z", fill: "white" }),
    React.createElement("path", { d: "M23.5847 8.39447C23.1034 6.95052 21.8356 6.12093 20.3584 6.12317C19.3142 6.12029 18.309 6.5217 17.5509 7.24425C17.5026 7.2955 17.442 7.33335 17.3749 7.35411C17.351 7.2991 17.3403 7.23918 17.3437 7.17922L17.3237 1.34514C17.3231 1.11302 17.231 0.890609 17.0677 0.726684C16.9044 0.562759 16.6831 0.470702 16.4525 0.470703H14.26C14.0303 0.471888 13.8104 0.56454 13.6484 0.728401C13.4864 0.892261 13.3955 1.114 13.3955 1.34514V21.6635C13.3961 21.8945 13.4872 22.1159 13.6491 22.2796C13.811 22.4434 14.0305 22.5362 14.26 22.538H16.5126C16.7425 22.5368 16.9626 22.4442 17.125 22.2804C17.2874 22.1166 17.3788 21.8949 17.3794 21.6635V10.946C17.3682 10.7426 17.387 10.5386 17.4351 10.3407C17.4924 10.0653 17.6451 9.8195 17.8659 9.647C18.0867 9.47451 18.3612 9.38659 18.6405 9.39895C18.8569 9.38715 19.0722 9.43787 19.2609 9.54513C19.4496 9.6524 19.6039 9.81173 19.7055 10.0043C19.8102 10.2644 19.8147 10.5088 19.8125 11.1613V21.6635C19.8122 21.7785 19.8344 21.8925 19.878 21.9988C19.9215 22.1052 19.9855 22.2019 20.0662 22.2833C20.1469 22.3647 20.2428 22.4293 20.3484 22.4734C20.454 22.5175 20.5671 22.5402 20.6814 22.5402H22.9296C23.0439 22.5402 23.1571 22.5175 23.2627 22.4734C23.3682 22.4293 23.4641 22.3647 23.5448 22.2833C23.6256 22.2019 23.6895 22.1052 23.7331 21.9988C23.7766 21.8925 23.7989 21.7785 23.7986 21.6635V10.0223C23.8213 9.47131 23.7489 8.92055 23.5847 8.39447Z", fill: "white" }),
    React.createElement("path", { d: "M29.4115 15.4706H34.2287C34.4597 15.4706 34.6813 15.3782 34.8447 15.2138C35.0081 15.0494 35.0999 14.8264 35.0999 14.5939V10.7912C35.0999 9.58045 34.9372 9.03784 34.6542 8.4661C34.1663 7.45264 32.6957 6.12529 30.0978 6.12305C28.2261 6.12305 26.125 6.80915 25.3162 8.75309C25.0451 9.45198 24.9061 10.1957 24.9063 10.9459V17.5939C24.9237 18.3048 25.0148 19.0119 25.1781 19.7038C25.6059 21.1634 26.7756 22.8428 30.0131 22.8428H30.0554C32.1565 22.8428 34.2331 22.2038 34.8704 19.8831C35.0019 19.4078 35.0553 18.914 35.0286 18.4213V17.7957C35.0187 17.573 34.9219 17.3633 34.7592 17.2122C34.5964 17.061 34.3809 16.9806 34.1596 16.9885H32.0407C31.8116 16.9936 31.5933 17.0873 31.431 17.2502C31.2688 17.413 31.1751 17.6325 31.1695 17.863C31.176 18.2085 31.1393 18.5535 31.0603 18.8899C31.0061 19.1115 30.8768 19.3072 30.6945 19.4431C30.5123 19.579 30.2886 19.6466 30.0621 19.6343C29.8195 19.6516 29.5784 19.5848 29.3789 19.4448C29.1793 19.3048 29.0336 19.1003 28.9659 18.8652C28.8857 18.6163 28.8812 18.428 28.8857 17.8719V15.9818C28.8897 15.8444 28.947 15.714 29.0452 15.6185C29.1435 15.523 29.2749 15.4699 29.4115 15.4706ZM28.8879 10.7621C28.8783 10.4677 28.9347 10.175 29.0528 9.90556C29.2043 9.61184 29.4538 9.37417 30.0621 9.36744C30.6124 9.36744 30.8442 9.58045 30.9868 9.84054C31.0994 10.0964 31.152 10.3749 31.1405 10.6544V11.9997C31.1405 12.0685 31.127 12.1366 31.1008 12.2002C31.0746 12.2637 31.0361 12.3214 30.9877 12.3699C30.9392 12.4185 30.8817 12.4569 30.8185 12.483C30.7552 12.5092 30.6875 12.5224 30.6191 12.5221H29.4115C29.2734 12.5222 29.1409 12.4673 29.0428 12.3694C28.9447 12.2716 28.8891 12.1387 28.8879 11.9997V10.7621Z", fill: "white" }),
    React.createElement("path", { d: "M47.8904 12.4417C47.377 11.7729 46.7636 11.1883 46.0722 10.7085L42.2243 8.0314C41.9315 7.84706 41.6673 7.62042 41.44 7.35875C41.0902 6.861 41.0367 5.93499 41.0367 5.54934C41.0367 5.45068 41.0367 5.39239 41.0367 5.36324C41.0701 3.60987 41.7653 3.41705 42.641 3.38118C44.0803 3.40584 44.2006 4.16817 44.2363 4.77804V6.29149C44.236 6.40662 44.2582 6.52067 44.3017 6.62715C44.3453 6.73363 44.4092 6.83044 44.4899 6.91205C44.5706 6.99367 44.6664 7.05849 44.772 7.10282C44.8776 7.14715 44.9908 7.17012 45.1052 7.17041H47.6921C47.8065 7.17012 47.9197 7.14715 48.0253 7.10282C48.1309 7.05849 48.2268 6.99367 48.3075 6.91205C48.3882 6.83044 48.4521 6.73363 48.4956 6.62715C48.5391 6.52067 48.5613 6.40662 48.561 6.29149V4.85427C48.6028 4.20882 48.4841 3.56308 48.2157 2.97535C47.0125 -0.0179274 43.4698 9.74625e-06 42.8281 9.74625e-06C42.3936 9.74625e-06 38.6214 -0.026896 37.3158 2.74665C36.8011 3.8184 36.781 5.18611 36.781 5.67938C36.781 5.73544 36.781 5.77804 36.781 5.80494C36.781 7.66593 37.0974 8.55158 37.5698 9.34306C38.1313 10.2579 38.6014 10.6301 39.4302 11.1839L43.1935 13.7377C43.5295 13.9532 43.8239 14.2282 44.0625 14.5493C44.419 15.083 44.4636 15.8005 44.4613 16.2085V16.4529C44.4613 17.9395 44.4301 18.8475 43.9444 19.2063C43.6993 19.4305 43.3562 19.5718 42.6766 19.5718C42.2789 19.5926 41.8843 19.4917 41.5447 19.2825C40.9721 18.917 40.9209 18.2668 40.9209 17.5538V15.4014C40.9209 15.2865 40.8984 15.1728 40.8547 15.0667C40.811 14.9606 40.747 14.8642 40.6663 14.783C40.5856 14.7018 40.4899 14.6374 40.3844 14.5935C40.279 14.5495 40.166 14.5269 40.0519 14.5269H37.4985C37.2678 14.5269 37.0465 14.619 36.8832 14.7829C36.7199 14.9468 36.6279 15.1692 36.6273 15.4014V17.8677C36.5911 18.6622 36.7439 19.454 37.0729 20.1771C37.3308 20.7878 37.7396 21.3219 38.2605 21.7287C39.5974 22.7825 41.2595 22.9955 42.8014 22.9955C46.5201 23.0135 48.0709 21.3655 48.5655 19.5449C48.7883 18.6839 48.7883 17.9552 48.7883 16.2982C48.7883 16.0493 48.7883 15.8139 48.7883 15.5875C48.795 14.444 48.7126 13.5269 47.8904 12.4417Z", fill: "white" }),
    React.createElement("path", { d: "M56.9795 19.8429C56.9532 19.7641 56.905 19.6946 56.8406 19.6426C56.7762 19.5905 56.6984 19.5581 56.6163 19.5492C56.6023 19.5476 56.5881 19.5476 56.574 19.5492C56.4808 19.56 56.3871 19.5653 56.2932 19.5649C55.6582 19.5649 55.0767 19.4505 54.9029 18.8294C54.8182 18.6052 54.8182 18.52 54.8182 18.0178V9.72182C54.8194 9.58244 54.8749 9.4491 54.9729 9.35054C55.0708 9.25198 55.2033 9.19609 55.3418 9.19492H56.1195C56.2337 9.19521 56.3468 9.1728 56.4523 9.12896C56.5579 9.08512 56.6538 9.02072 56.7346 8.93946C56.8153 8.8582 56.8793 8.76169 56.9229 8.65546C56.9664 8.54924 56.9887 8.4354 56.9884 8.32048V7.30703C56.9887 7.192 56.9665 7.07805 56.9229 6.9717C56.8794 6.86535 56.8154 6.76869 56.7347 6.68725C56.654 6.60582 56.5581 6.54121 56.4525 6.49712C56.3469 6.45304 56.2338 6.43034 56.1195 6.43034H55.3418C55.2726 6.43154 55.2039 6.41884 55.1396 6.39301C55.0753 6.36718 55.0168 6.32872 54.9674 6.27988C54.918 6.23104 54.8788 6.1728 54.8521 6.10855C54.8253 6.04431 54.8115 5.97534 54.8116 5.90568V2.84514C54.811 2.61341 54.7192 2.39134 54.5564 2.22747C54.3936 2.06361 54.1729 1.9713 53.9426 1.9707H51.7145C51.484 1.9707 51.263 2.06283 51.1 2.22682C50.9371 2.39081 50.8455 2.61323 50.8455 2.84514V5.90568C50.8452 5.97458 50.8314 6.04275 50.805 6.10629C50.7785 6.16983 50.7399 6.22751 50.6912 6.27602C50.6426 6.32453 50.585 6.36293 50.5216 6.38902C50.4582 6.41512 50.3904 6.4284 50.3219 6.4281H49.7537C49.6394 6.4281 49.5263 6.45079 49.4207 6.49488C49.3151 6.53896 49.2192 6.60358 49.1385 6.68501C49.0578 6.76645 48.9938 6.86311 48.9503 6.96946C48.9067 7.07581 48.8845 7.18976 48.8848 7.30478V8.33393C48.8848 8.56585 48.9763 8.78826 49.1393 8.95225C49.3022 9.11624 49.5233 9.20837 49.7537 9.20837H50.3531C50.491 9.21013 50.6227 9.26635 50.7198 9.36491C50.8169 9.46348 50.8717 9.59648 50.8722 9.73528V19.2263C50.8722 19.8451 50.9012 20.5155 51.1953 21.1164C51.6922 22.2196 52.8887 22.686 54.9831 22.686H55.0344C55.4363 22.6899 55.8381 22.669 56.2375 22.6232C56.4717 22.5821 56.684 22.4593 56.8372 22.2765C56.9903 22.0936 57.0747 21.8623 57.0753 21.6232V20.3877C57.0799 20.2015 57.0473 20.0163 56.9795 19.8429Z", fill: "white" }),
    React.createElement("path", { d: "M65.9072 6.99543C65.9056 6.78131 65.822 6.57604 65.6739 6.42235C65.5257 6.26867 65.3244 6.17839 65.1117 6.17032C65.0836 6.16719 65.0552 6.16719 65.0271 6.17032C64.5427 6.21506 64.0735 6.36344 63.6508 6.60551C63.2281 6.84758 62.8617 7.17775 62.5761 7.5739C62.4892 7.68825 62.4157 7.79812 62.3533 7.90126V7.29363C62.3516 7.06523 62.2606 6.84669 62.1001 6.68518C61.9396 6.52368 61.7225 6.43216 61.4955 6.4304H59.2518C59.1375 6.4304 59.0243 6.4531 58.9187 6.49718C58.8132 6.54127 58.7173 6.60588 58.6365 6.68731C58.5558 6.76875 58.4919 6.86541 58.4483 6.97176C58.4048 7.07812 58.3825 7.19206 58.3828 7.30709V21.6569C58.3825 21.7719 58.4048 21.8858 58.4483 21.9922C58.4919 22.0985 58.5558 22.1952 58.6365 22.2766C58.7173 22.3581 58.8132 22.4227 58.9187 22.4668C59.0243 22.5109 59.1375 22.5335 59.2518 22.5335H61.4799C61.594 22.5332 61.7069 22.5103 61.8123 22.4661C61.9176 22.4219 62.0132 22.3572 62.0937 22.2758C62.1742 22.1944 62.2379 22.0979 62.2813 21.9917C62.3247 21.8855 62.3469 21.7717 62.3466 21.6569V12.8878C62.3466 11.8788 62.3845 10.8295 63.2535 10.2264C63.6368 9.99204 64.0797 9.87517 64.5279 9.89005C64.7206 9.88918 64.913 9.90569 65.1028 9.93937L65.1385 9.76897L65.1028 9.93937C65.1564 9.95003 65.2109 9.95529 65.2655 9.95507C65.3488 9.95596 65.4314 9.93949 65.5081 9.90669C65.5848 9.87389 65.6539 9.82548 65.7111 9.76449C65.8321 9.62702 65.8959 9.448 65.8893 9.26449L65.9094 7.00215L65.9072 6.99543Z", fill: "white" }),
    React.createElement("path", { d: "M70.9609 15.4706H75.7781C75.893 15.47 76.0066 15.4466 76.1125 15.4017C76.2184 15.3569 76.3144 15.2915 76.3952 15.2092C76.4759 15.1269 76.5397 15.0294 76.5829 14.9223C76.6261 14.8152 76.6479 14.7005 76.647 14.5849V10.7912C76.647 9.58045 76.4866 9.03784 76.2014 8.4661C75.7112 7.45264 74.2384 6.12305 71.6427 6.12305C69.7711 6.12305 67.6722 6.81363 66.8634 8.75309C66.5897 9.4513 66.4498 10.1953 66.4512 10.9459V17.5939C66.4715 18.3052 66.5664 19.0124 66.7342 19.7038C67.1642 21.1701 68.3384 22.8585 71.6115 22.8428H71.6538C73.7416 22.8428 75.7959 22.1858 76.4309 19.8831C76.5611 19.4075 76.6137 18.9138 76.5869 18.4213V17.7912C76.5776 17.5685 76.4809 17.3587 76.3179 17.2078C76.155 17.0568 75.9392 16.9772 75.7179 16.9863H73.5923C73.3626 16.9886 73.1429 17.0815 72.9804 17.245C72.8179 17.4085 72.7257 17.6295 72.7233 17.8607C72.7277 18.2063 72.6903 18.5511 72.6119 18.8876C72.5577 19.1097 72.428 19.3056 72.2453 19.4416C72.0626 19.5775 71.8384 19.6449 71.6115 19.632C71.3712 19.6478 71.1327 19.5807 70.9354 19.4417C70.7381 19.3027 70.5938 19.1001 70.5264 18.8674C70.444 18.6186 70.4395 18.4302 70.4395 17.8719V15.9818C70.4424 15.8448 70.4987 15.7144 70.5962 15.6188C70.6938 15.5232 70.8247 15.47 70.9609 15.4706ZM71.6093 9.37641C72.1641 9.37641 72.3913 9.58941 72.5339 9.8495C72.6473 10.1052 72.7006 10.3837 72.6899 10.6634V12.0087C72.6887 12.1475 72.633 12.2801 72.5348 12.3776C72.4367 12.4751 72.3042 12.5295 72.1663 12.5289H70.9609C70.8925 12.5295 70.8247 12.5165 70.7614 12.4906C70.698 12.4648 70.6403 12.4266 70.5917 12.3782C70.543 12.3299 70.5044 12.2724 70.4779 12.209C70.4514 12.1456 70.4376 12.0775 70.4373 12.0087V10.7621C70.426 10.4678 70.4817 10.1749 70.5999 9.90556C70.7537 9.61184 71.0054 9.37193 71.6115 9.36744L71.6093 9.37641Z", fill: "white" }),
    React.createElement("path", { d: "M82.2035 15.4706H87.0207C87.135 15.4706 87.2482 15.4479 87.3538 15.4038C87.4593 15.3597 87.5552 15.2951 87.6359 15.2137C87.7167 15.1322 87.7806 15.0356 87.8242 14.9292C87.8677 14.8229 87.89 14.7089 87.8897 14.5939V10.7912C87.8897 9.58045 87.727 9.03784 87.444 8.4661C86.9561 7.45264 85.4855 6.12529 82.8853 6.12305C81.0159 6.12305 78.9148 6.80915 78.106 8.75309C77.8359 9.45219 77.6976 10.1958 77.6982 10.9459V17.5939C77.7203 18.3052 77.8159 19.0123 77.9834 19.7038C78.4112 21.1701 79.5877 22.8607 82.8586 22.8428H82.8853C84.9708 22.8428 87.0252 22.1858 87.6602 19.8831C87.791 19.4076 87.8444 18.9139 87.8184 18.4213V17.7912C87.808 17.569 87.7109 17.3598 87.5482 17.2091C87.3855 17.0584 87.1704 16.9784 86.9494 16.9863H84.8238C84.5938 16.988 84.3738 17.0807 84.2113 17.2443C84.0487 17.4079 83.9566 17.6293 83.9548 17.8607C83.9592 18.2063 83.9218 18.5511 83.8434 18.8876C83.7892 19.1097 83.6595 19.3056 83.4767 19.4416C83.294 19.5775 83.0698 19.6449 82.843 19.632C82.6046 19.6446 82.369 19.5756 82.1744 19.4364C81.9798 19.2972 81.8378 19.0959 81.7712 18.8652C81.6866 18.6163 81.6843 18.428 81.6843 17.8719V15.9863C81.6867 15.8491 81.7423 15.7183 81.8394 15.6219C81.9364 15.5255 82.0671 15.4711 82.2035 15.4706ZM82.8519 9.37641C83.4045 9.37641 83.634 9.58941 83.7743 9.8495C83.8895 10.1046 83.9437 10.3834 83.9325 10.6634C83.9297 10.6992 83.9297 10.7352 83.9325 10.771V12.0109C83.9308 12.1495 83.8748 12.2818 83.7768 12.3792C83.6788 12.4765 83.5466 12.5311 83.4089 12.5311H82.2035C82.0656 12.5317 81.9331 12.4773 81.835 12.3798C81.7368 12.2823 81.6811 12.1497 81.6799 12.0109V10.7621C81.6693 10.4679 81.7249 10.1751 81.8425 9.90556C81.9941 9.61184 82.2481 9.37193 82.8519 9.36744V9.37641Z", fill: "white" }),
    React.createElement("path", { d: "M96.3241 19.8429C96.2985 19.7637 96.2506 19.6937 96.1861 19.6416C96.1215 19.5894 96.0433 19.5573 95.961 19.5492H95.9231C95.8285 19.5618 95.7333 19.5678 95.6379 19.5671C95.0006 19.5671 94.4213 19.4528 94.2453 18.8317C94.1584 18.6075 94.1629 18.5223 94.1584 18.02V9.72407C94.1602 9.58486 94.2159 9.45185 94.3137 9.35342C94.4115 9.25498 94.5437 9.1989 94.682 9.19716H95.4596C95.574 9.19746 95.6874 9.17507 95.7932 9.13129C95.899 9.0875 95.9952 9.02317 96.0763 8.94197C96.1574 8.86077 96.2218 8.76429 96.2659 8.65804C96.3099 8.55179 96.3328 8.43785 96.3331 8.32272V7.30703C96.3331 7.19171 96.3105 7.07753 96.2665 6.97102C96.2226 6.86451 96.1582 6.76776 96.0771 6.68632C95.996 6.60489 95.8997 6.54036 95.7937 6.49643C95.6878 6.45251 95.5742 6.43005 95.4596 6.43034H94.682C94.5439 6.43035 94.4114 6.37545 94.3133 6.27761C94.2153 6.17976 94.1596 6.04689 94.1584 5.90792V2.84514C94.1584 2.73031 94.1359 2.6166 94.0923 2.51051C94.0486 2.40442 93.9846 2.30802 93.9039 2.22682C93.8232 2.14562 93.7274 2.08121 93.622 2.03727C93.5166 1.99332 93.4036 1.9707 93.2895 1.9707H91.0613C90.8309 1.9707 90.6098 2.06283 90.4469 2.22682C90.2839 2.39081 90.1924 2.61323 90.1924 2.84514V5.90568C90.1921 5.97458 90.1783 6.04275 90.1518 6.10629C90.1254 6.16983 90.0867 6.22751 90.0381 6.27602C89.9895 6.32453 89.9318 6.36293 89.8685 6.38902C89.8051 6.41512 89.7372 6.4284 89.6688 6.4281H89.1251C88.894 6.4281 88.6725 6.52047 88.5091 6.68488C88.3457 6.84929 88.2539 7.07227 88.2539 7.30478V8.33393C88.2545 8.56605 88.3465 8.78847 88.5099 8.95239C88.6732 9.11632 88.8944 9.20837 89.1251 9.20837H89.72C89.8581 9.21072 89.9898 9.26743 90.0869 9.36635C90.1839 9.46527 90.2386 9.59851 90.2392 9.73752V19.2263C90.2392 19.8451 90.2659 20.5155 90.56 21.1142C91.0613 22.2196 92.2556 22.6837 94.3478 22.6837H94.379C94.781 22.6876 95.1829 22.6659 95.5822 22.6187C95.8159 22.578 96.0279 22.4556 96.1807 22.2731C96.3336 22.0906 96.4175 21.8596 96.4177 21.6209V20.3877C96.4234 20.2016 96.3915 20.0163 96.3241 19.8429Z", fill: "white" }),
    React.createElement("path", { d: "M98.9638 22.7017C98.7607 22.7012 98.5623 22.6405 98.3934 22.527C98.2245 22.4135 98.0926 22.2524 98.0143 22.0638C97.936 21.8753 97.9148 21.6677 97.9532 21.467C97.9917 21.2664 98.0882 21.0816 98.2305 20.9358C98.3729 20.7901 98.5548 20.6899 98.7535 20.6478C98.9523 20.6057 99.1589 20.6235 99.3476 20.699C99.5363 20.7746 99.6986 20.9045 99.8143 21.0725C99.9299 21.2405 99.9937 21.4391 99.9976 21.6434C100.001 21.7819 99.9771 21.9196 99.9266 22.0485C99.8761 22.1773 99.8004 22.2946 99.7039 22.3934C99.6075 22.4922 99.4922 22.5704 99.365 22.6233C99.2379 22.6763 99.1014 22.703 98.9638 22.7017ZM98.9638 20.7331C98.7814 20.7318 98.6027 20.7848 98.4501 20.8855C98.2976 20.9862 98.1781 21.13 98.1066 21.2988C98.0351 21.4677 98.0148 21.654 98.0483 21.8345C98.0818 22.0149 98.1676 22.1813 98.2949 22.3128C98.4221 22.4443 98.5852 22.535 98.7635 22.5734C98.9419 22.6119 99.1276 22.5964 99.2972 22.5289C99.4668 22.4614 99.6128 22.345 99.7168 22.1942C99.8209 22.0434 99.8782 21.8651 99.8818 21.6815C99.8863 21.5578 99.8658 21.4345 99.8216 21.319C99.7774 21.2035 99.7103 21.0982 99.6245 21.0096C99.5387 20.9209 99.4359 20.8507 99.3223 20.8032C99.2087 20.7556 99.0868 20.7318 98.9638 20.7331ZM98.9638 21.0022C99.071 20.9934 99.1787 21.0135 99.2757 21.0605C99.3316 21.0998 99.3769 21.1527 99.4072 21.2142C99.4376 21.2757 99.4521 21.3439 99.4495 21.4125C99.4537 21.487 99.4344 21.5609 99.3944 21.6237C99.3544 21.6865 99.2957 21.735 99.2267 21.7623L99.4495 22.3026H99.1509L98.9682 21.8093H98.7967V22.3026H98.5271V21.0022H98.9638ZM98.8078 21.5829H98.9749C99.1175 21.5829 99.1777 21.5313 99.1777 21.4147C99.1777 21.2981 99.1175 21.2488 98.9838 21.2488H98.8078V21.5829Z", fill: "white" })));
const Account = props => (React.createElement(Icon, Object.assign({}, props, { filled: true, viewBox: "0 0 24 24" }),
    React.createElement("path", { d: "M11.5 14C15.642 14 19 15.567 19 17.5V20H4V17.5C4 15.567 7.358 14 11.5 14ZM18 17.5C18 16.12 15.09 15 11.5 15C7.91 15 5 16.12 5 17.5V19H18V17.5ZM11.5 5C12.4283 5 13.3185 5.36875 13.9749 6.02513C14.6313 6.6815 15 7.57174 15 8.5C15 9.42826 14.6313 10.3185 13.9749 10.9749C13.3185 11.6313 12.4283 12 11.5 12C10.5717 12 9.6815 11.6313 9.02513 10.9749C8.36875 10.3185 8 9.42826 8 8.5C8 7.57174 8.36875 6.6815 9.02513 6.02513C9.6815 5.36875 10.5717 5 11.5 5ZM11.5 6C10.837 6 10.2011 6.26339 9.73223 6.73223C9.26339 7.20107 9 7.83696 9 8.5C9 9.16304 9.26339 9.79893 9.73223 10.2678C10.2011 10.7366 10.837 11 11.5 11C12.163 11 12.7989 10.7366 13.2678 10.2678C13.7366 9.79893 14 9.16304 14 8.5C14 7.83696 13.7366 7.20107 13.2678 6.73223C12.7989 6.26339 12.163 6 11.5 6Z", fill: "black" })));
const ChevronRight = props => (React.createElement(Icon, Object.assign({}, props, { filled: true, viewBox: "0 0 24 24" }),
    React.createElement("path", { d: "M8.593 18.157L14.25 12.5L8.593 6.84299L7.886 7.54999L12.836 12.5L7.886 17.45L8.593 18.157Z" })));
const ChevronLeft = props => (React.createElement(Icon, Object.assign({}, props, { filled: true, viewBox: "0 0 24 24" }),
    React.createElement("path", { d: "M14.407 18.157L8.75 12.5L14.407 6.84299L15.114 7.54999L10.164 12.5L15.114 17.45L14.407 18.157Z", fill: "black" })));
const ChevronDown = props => (React.createElement(Icon, Object.assign({}, props, { filled: true, viewBox: "0 0 24 24" }),
    React.createElement("path", { d: "M5.843 9.593L11.5 15.25L17.157 9.593L16.45 8.886L11.5 13.836L6.55 8.886L5.843 9.593Z", fill: "black" })));
const ChevronUp = props => (React.createElement(Icon, Object.assign({}, props, { filled: true, viewBox: "0 0 24 24" }),
    React.createElement("path", { d: "M5.843 15.407L11.5 9.75L17.157 15.407L16.45 16.114L11.5 11.164L6.55 16.114L5.843 15.407Z", fill: "black" })));
const WarningIcon = props => (React.createElement(Icon, Object.assign({}, props, { viewBox: "0 0 21 19" }),
    React.createElement("path", { d: "M0 19L10.5 0.813004L21 19H0ZM19.268 18L10.5 2.813L1.732 18H19.268ZM10 12V8H11V12H10ZM10 14H11V16H10V14Z", fill: "black" })));
const Checkmark = props => (React.createElement(Icon, Object.assign({}, props, { viewBox: "0 0 24 24" }),
    React.createElement("path", { d: "M18.9 8.09999L8.99999 18L4.04999 13.05L4.75699 12.343L8.99999 16.586L18.192 7.39299L18.899 8.10099L18.9 8.09999Z", fill: "black" })));
const EditIcon = props => (React.createElement(Icon, Object.assign({}, props, { viewBox: "0 0 17 18" }),
    React.createElement("path", { d: "M16.706 5.042L14.374 7.374L10.624 3.624L12.956 1.292C13.0488 1.19905 13.159 1.12531 13.2803 1.075C13.4016 1.02469 13.5317 0.998795 13.663 0.998795C13.7943 0.998795 13.9244 1.02469 14.0457 1.075C14.167 1.12531 14.2772 1.19905 14.37 1.292L16.706 3.628C16.7989 3.72078 16.8727 3.83099 16.923 3.9523C16.9733 4.07362 16.9992 4.20366 16.9992 4.335C16.9992 4.46633 16.9733 4.59637 16.923 4.71769C16.8727 4.839 16.7989 4.94921 16.706 5.042ZM-0.00100708 14.248L10.064 4.184L13.814 7.934L3.74899 17.998H-7.15256e-06V14.248H-0.00100708ZM13.621 2.044L12.081 3.583L14.418 5.918L15.956 4.379L13.621 2.044ZM12.357 7.979L10.022 5.643L0.999993 14.664V17H3.33599L12.357 7.979Z", fill: props.fill || 'black' })));
const Bell = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 12 13" }, props),
    React.createElement("path", { d: "M6 1C6 0.911595 5.96488 0.82681 5.90237 0.764298C5.83986 0.701786 5.75507 0.666667 5.66667 0.666667C5.57826 0.666667 5.49348 0.701786 5.43096 0.764298C5.36845 0.82681 5.33333 0.911595 5.33333 1V2.018C4.59987 2.1 3.92237 2.4495 3.43041 2.99964C2.93844 3.54978 2.66652 4.26197 2.66667 5V8.94267L1.60933 10H9.724L8.66667 8.94267V5C8.66681 4.26197 8.39489 3.54978 7.90293 2.99964C7.41096 2.4495 6.73346 2.1 6 2.018V1ZM5.66667 0C5.93188 0 6.18624 0.105357 6.37377 0.292893C6.56131 0.48043 6.66667 0.734784 6.66667 1V1.47133C8.206 1.90667 9.33333 3.32133 9.33333 5V8.66667L11.3333 10.6667H0L2 8.66667V5C2 4.20178 2.26039 3.42535 2.74165 2.78852C3.22291 2.1517 3.89877 1.68924 4.66667 1.47133V1C4.66667 0.734784 4.77202 0.48043 4.95956 0.292893C5.1471 0.105357 5.40145 0 5.66667 0ZM5.66667 12.6667C5.28245 12.6667 4.91 12.5341 4.61237 12.2911C4.31473 12.0481 4.11018 11.7098 4.03333 11.3333H4.72333C4.79205 11.5287 4.9197 11.6978 5.08867 11.8175C5.25765 11.9372 5.4596 12.0015 5.66667 12.0015C5.87373 12.0015 6.07569 11.9372 6.24466 11.8175C6.41363 11.6978 6.54129 11.5287 6.61 11.3333H7.3C7.22316 11.7098 7.01861 12.0481 6.72097 12.2911C6.42333 12.5341 6.05088 12.6667 5.66667 12.6667Z", color: props.fill })));
const SmallVideoIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 18 10" }, props),
    React.createElement("path", { d: "M2 0H11C11.5304 0 12.0391 0.210714 12.4142 0.585786C12.7893 0.960859 13 1.46957 13 2V4.5L17 0.5V10.5L13 6.5V9C13 9.53043 12.7893 10.0391 12.4142 10.4142C12.0391 10.7893 11.5304 11 11 11H2C1.46957 11 0.960859 10.7893 0.585786 10.4142C0.210714 10.0391 0 9.53043 0 9V2C0 1.46957 0.210714 0.960859 0.585786 0.585786C0.960859 0.210714 1.46957 0 2 0ZM2 1C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2V9C1 9.26522 1.10536 9.51957 1.29289 9.70711C1.48043 9.89464 1.73478 10 2 10H11C11.2652 10 11.5196 9.89464 11.7071 9.70711C11.8946 9.51957 12 9.26522 12 9V2C12 1.73478 11.8946 1.48043 11.7071 1.29289C11.5196 1.10536 11.2652 1 11 1H2ZM16 2.914L13.414 5.5L16 8.086V2.914Z", fill: "black" })));
const SmallPhotoIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M5 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V19C21 19.7956 20.6839 20.5587 20.1213 21.1213C19.5587 21.6839 18.7956 22 18 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7956 2 19V6C2 5.20435 2.31607 4.44129 2.87868 3.87868C3.44129 3.31607 4.20435 3 5 3ZM5 4C4.46957 4 3.96086 4.21071 3.58579 4.58579C3.21071 4.96086 3 5.46957 3 6V17.586L7.293 13.293L9.793 15.793L14.793 10.793L20 16V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4H5ZM9.793 17.207L7.293 14.707L3 19C3 19.5304 3.21071 20.0391 3.58579 20.4142C3.96086 20.7893 4.46957 21 5 21H18C18.5304 21 19.0391 20.7893 19.4142 20.4142C19.7893 20.0391 20 19.5304 20 19V17.414L14.793 12.207L9.793 17.207ZM7.5 6C8.16304 6 8.79893 6.26339 9.26777 6.73223C9.73661 7.20107 10 7.83696 10 8.5C10 9.16304 9.73661 9.79893 9.26777 10.2678C8.79893 10.7366 8.16304 11 7.5 11C6.83696 11 6.20107 10.7366 5.73223 10.2678C5.26339 9.79893 5 9.16304 5 8.5C5 7.83696 5.26339 7.20107 5.73223 6.73223C6.20107 6.26339 6.83696 6 7.5 6ZM7.5 7C7.10218 7 6.72064 7.15804 6.43934 7.43934C6.15804 7.72064 6 8.10218 6 8.5C6 8.89782 6.15804 9.27936 6.43934 9.56066C6.72064 9.84196 7.10218 10 7.5 10C7.89782 10 8.27936 9.84196 8.56066 9.56066C8.84196 9.27936 9 8.89782 9 8.5C9 8.10218 8.84196 7.72064 8.56066 7.43934C8.27936 7.15804 7.89782 7 7.5 7Z", fill: "black" })));
const SmallMusicIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M8 6.10406L19 4.98706V16.0001C19 16.687 18.7643 17.3531 18.3323 17.8871C17.9002 18.4211 17.298 18.7907 16.6262 18.934C15.9544 19.0774 15.2538 18.9859 14.6414 18.6749C14.029 18.3638 13.5418 17.852 13.2614 17.2249C12.981 16.5979 12.9242 15.8936 13.1006 15.2297C13.277 14.5658 13.6759 13.9826 14.2306 13.5775C14.7853 13.1723 15.4623 12.9698 16.1483 13.0038C16.8344 13.0378 17.488 13.3061 18 13.7641V9.04406L9 10.0371V17.0001C9.00002 17.687 8.76431 18.3531 8.33226 18.8871C7.90021 19.4211 7.29799 19.7907 6.62622 19.934C5.95444 20.0774 5.25381 19.9859 4.64139 19.6749C4.02896 19.3638 3.54184 18.852 3.2614 18.2249C2.98097 17.5979 2.92421 16.8936 3.10062 16.2297C3.27702 15.5658 3.6759 14.9826 4.23061 14.5775C4.78532 14.1723 5.46226 13.9698 6.14832 14.0038C6.83438 14.0378 7.48802 14.3061 8 14.7641V6.10406ZM9 7.00806V9.03006L18 8.03706V6.09406L9 7.00806ZM8 17.0001C8 16.4696 7.78929 15.9609 7.41422 15.5858C7.03914 15.2108 6.53043 15.0001 6 15.0001C5.46957 15.0001 4.96086 15.2108 4.58579 15.5858C4.21072 15.9609 4 16.4696 4 17.0001C4 17.5305 4.21072 18.0392 4.58579 18.4143C4.96086 18.7893 5.46957 19.0001 6 19.0001C6.53043 19.0001 7.03914 18.7893 7.41422 18.4143C7.78929 18.0392 8 17.5305 8 17.0001ZM18 16.0001C18 15.4696 17.7893 14.9609 17.4142 14.5858C17.0391 14.2108 16.5304 14.0001 16 14.0001C15.4696 14.0001 14.9609 14.2108 14.5858 14.5858C14.2107 14.9609 14 15.4696 14 16.0001C14 16.5305 14.2107 17.0392 14.5858 17.4143C14.9609 17.7893 15.4696 18.0001 16 18.0001C16.5304 18.0001 17.0391 17.7893 17.4142 17.4143C17.7893 17.0392 18 16.5305 18 16.0001Z", fill: "black" })));
const PhoneIcon = props => (React.createElement(Icon, Object.assign({}, props, { viewBox: "0 0 48 48" }),
    React.createElement("path", { d: "M13 46q-1.2 0-2.1-.9-.9-.9-.9-2.1V5q0-1.2.9-2.1.9-.9 2.1-.9h22q1.2 0 2.1.9.9.9.9 2.1v38q0 1.2-.9 2.1-.9.9-2.1.9Zm0-7.5V43h22v-4.5Zm11 3.75q.65 0 1.075-.425.425-.425.425-1.075 0-.65-.425-1.075-.425-.425-1.075-.425-.65 0-1.075.425-.425.425-.425 1.075 0 .65.425 1.075.425.425 1.075.425ZM13 35.5h22v-26H13Zm0-29h22V5H13Zm0 32V43Zm0-32V5v1.5Z" })));
const CommentIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M14.414 17.25H14.1033L13.8837 17.4697L10.1767 21.1766C10.1767 21.1766 10.1767 21.1766 10.1767 21.1767C10.1417 21.2116 10.0972 21.2354 10.0488 21.245C10.0003 21.2546 9.95001 21.2497 9.90434 21.2308C9.85866 21.2118 9.81962 21.1798 9.79215 21.1387C9.76471 21.0976 9.75004 21.0494 9.75 21C9.75 20.9999 9.75 20.9999 9.75 20.9998V18V17.25H9H6C5.40326 17.25 4.83097 17.0129 4.40901 16.591C3.98705 16.169 3.75 15.5967 3.75 15V6C3.75 5.40326 3.98705 4.83097 4.40901 4.40901C4.83097 3.98705 5.40326 3.75 6 3.75H19C19.5967 3.75 20.169 3.98705 20.591 4.40901C21.0129 4.83097 21.25 5.40326 21.25 6V15C21.25 15.5967 21.0129 16.169 20.591 16.591C20.169 17.0129 19.5967 17.25 19 17.25H14.414Z", stroke: "black", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
const RepliesNewIcon = props => (React.createElement(Icon, Object.assign({}, props, { viewBox: "0 0 20 19" }),
    React.createElement("path", { d: "M0.999999 12V9H2V12C2 12.5304 2.21071 13.0391 2.58579 13.4142C2.96086 13.7893 3.46957 14 4 14H8V18L12 14H17C17.5304 14 18.0391 13.7893 18.4142 13.4142C18.7893 13.0391 19 12.5304 19 12V3C19 2.46957 18.7893 1.96086 18.4142 1.58579C18.0391 1.21071 17.5304 1 17 1H13V0H17C17.7956 0 18.5587 0.316071 19.1213 0.87868C19.6839 1.44129 20 2.20435 20 3V12C20 12.7956 19.6839 13.5587 19.1213 14.1213C18.5587 14.6839 17.7956 15 17 15H12.414L8.707 18.707C8.56715 18.8468 8.38898 18.942 8.19503 18.9806C8.00108 19.0192 7.80004 18.9993 7.61734 18.9237C7.43465 18.848 7.27848 18.7199 7.1686 18.5555C7.05871 18.391 7.00004 18.1978 7 18V15H4C3.20435 15 2.44129 14.6839 1.87868 14.1213C1.31607 13.5587 0.999999 12.7956 0.999999 12Z", fill: "black" }),
    React.createElement("path", { d: "M7.94444 9V6.86667C2.88889 6.33333 0.722222 3.66667 0 0.999998C1.80556 2.86667 4.33333 3.72 7.94444 3.72V1.53333L13 5.26667L7.94444 9Z", fill: "black" })));
const RepliesIcon = props => (React.createElement(Icon, Object.assign({}, props, { viewBox: "0 0 20 19" }),
    React.createElement("path", { d: "M5.05556 2.13333V0L0 3.73333L5.05556 7.46667V5.28C8.66667 5.28 11.1944 6.13333 13 8C12.2778 5.33333 10.1111 2.66667 5.05556 2.13333Z", fill: "black" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1 9V12C1 12.7956 1.31607 13.5587 1.87868 14.1213C2.44129 14.6839 3.20435 15 4 15H8.586L12.293 18.707C12.4329 18.8468 12.611 18.942 12.805 18.9806C12.9989 19.0192 13.2 18.9993 13.3827 18.9237C13.5654 18.848 13.7215 18.7199 13.8314 18.5555C13.9413 18.391 14 18.1978 14 18V15H17C17.7956 15 18.5587 14.6839 19.1213 14.1213C19.6839 13.5587 20 12.7956 20 12V3C20 2.20435 19.6839 1.44129 19.1213 0.87868C18.5587 0.316071 17.7956 0 17 0H13V1H17C17.5304 1 18.0391 1.21071 18.4142 1.58579C18.7893 1.96086 19 2.46957 19 3V12C19 12.5304 18.7893 13.0391 18.4142 13.4142C18.0391 13.7893 17.5304 14 17 14H13V18L9 14H4C3.46957 14 2.96086 13.7893 2.58579 13.4142C2.21071 13.0391 2 12.5304 2 12V9H1Z", fill: "black" })));
const LikeIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 22" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5.77982 1.7587C6.57557 1.51771 7.41257 1.44399 8.2382 1.54216C9.06382 1.64034 9.8602 1.90829 10.5772 2.32917C11.109 2.64127 11.5885 3.03245 12 3.48824C12.4115 3.03245 12.891 2.64127 13.4228 2.32917C14.1398 1.90829 14.9362 1.64034 15.7618 1.54216C16.5874 1.44399 17.4244 1.51771 18.2202 1.7587C19.0159 1.99968 19.7532 2.40272 20.3856 2.94246C21.0181 3.4822 21.532 4.14696 21.8951 4.89494C22.2581 5.64292 22.4625 6.45793 22.4953 7.28873C22.5281 8.11952 22.3887 8.94811 22.0857 9.7224C21.7862 10.4881 21.3331 11.1843 20.7546 11.7682C20.7482 11.7753 20.7417 11.7822 20.735 11.789L12.3535 20.1683C12.1582 20.3635 11.8417 20.3635 11.6465 20.1683L3.26502 11.7879C2.67712 11.1999 2.21721 10.4967 1.91427 9.7224C1.61133 8.94811 1.47188 8.11952 1.5047 7.28873C1.53751 6.45793 1.74188 5.64292 2.10494 4.89494C2.46801 4.14696 2.98192 3.4822 3.61436 2.94246C4.24679 2.40272 4.98407 1.99968 5.77982 1.7587Z", stroke: "black", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" })));
const PinIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 11 20" }, props),
    React.createElement("path", { d: "M8 10.415V3H9V2H2V3H3V10.414L1 12.414V13H10V12.414L8 10.414V10.415ZM11 11.998V13.998L6 14V18.5L5.5 20L5 18.5V14L0 13.998V11.998H0.00199986L2 10V3.998H1V0.998001H9.999V3.998H8.999V10L10.999 11.998H11Z", fill: "black" })));
const MoreHoriz = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 18 4" }, props),
    React.createElement("path", { d: "M2 0.5C1.17157 0.5 0.5 1.17157 0.5 2C0.5 2.82843 1.17157 3.5 2 3.5C2.82843 3.5 3.5 2.82843 3.5 2C3.5 1.17157 2.82843 0.5 2 0.5Z", fill: "black" }),
    React.createElement("path", { d: "M9 0.5C8.17157 0.5 7.5 1.17157 7.5 2C7.5 2.82843 8.17157 3.5 9 3.5C9.82843 3.5 10.5 2.82843 10.5 2C10.5 1.17157 9.82843 0.5 9 0.5Z", fill: "black" }),
    React.createElement("path", { d: "M16 0.5C15.1716 0.5 14.5 1.17157 14.5 2C14.5 2.82843 15.1716 3.5 16 3.5C16.8284 3.5 17.5 2.82843 17.5 2C17.5 1.17157 16.8284 0.5 16 0.5Z", fill: "black" }),
    ' '));
const MavenLogo = (_a) => {
    var { className, width = 54, height = 32, fill } = _a; __rest(_a, ["className", "width", "height", "fill"]);
    return (React.createElement("svg", { className: className, width: width, height: height, viewBox: "0 0 54 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M23.2027 14.0163H51.9433C52.711 14.0163 53.3333 14.5529 53.3333 15.2153V18.7822H23.2949L12.8551 28.8889L0 16.4444L12.8551 4L23.2027 14.0163ZM53.0753 20.0894V27.3176C53.0753 27.3176 51.759 27.3176 50.6063 27.3176C50.1563 27.3176 49.7248 27.1451 49.4067 26.8372C49.0884 26.5278 48.9097 26.1104 48.9097 25.6751V20.0894H53.0753ZM45.8802 20.0894V25.118C45.8802 25.118 44.5639 25.118 43.4112 25.118C42.9612 25.118 42.5297 24.9442 42.2116 24.6363C41.8933 24.3283 41.7146 23.9108 41.7146 23.4756V20.0894H45.8802ZM15.4261 11.4664C15.4261 11.4664 14.3108 10.3865 13.5493 9.65008C13.3652 9.47078 13.1156 9.37088 12.8551 9.37088C12.5947 9.37088 12.3449 9.47078 12.1608 9.65008C10.2653 11.4842 5.14197 16.4444 5.14197 16.4444C5.14197 16.4444 9.93855 21.0885 11.9667 23.0513C12.4573 23.5262 13.2529 23.5262 13.7436 23.0513C14.4877 22.3313 15.4289 21.4197 15.4289 21.4197L10.2897 16.4444L15.4261 11.4664ZM20.4081 16.4773L17.9762 14.1231C17.1656 14.9087 16.3549 15.693 15.5442 16.4773L17.9762 18.8329L20.4081 16.4773Z", fill: fill })));
};
const FootBallLogo = (_a) => {
    __rest(_a, ["className", "width", "height", "fill"]);
    return (React.createElement("svg", { width: "24.042", height: "24.042", viewBox: "0 0 24.042 24.042" },
        React.createElement("defs", null,
            React.createElement("clipPath", { id: "clip-path" },
                React.createElement("rect", { id: "Rectangle_1502", "data-name": "Rectangle 1502", width: "17", height: "17", fill: "#35363a" }))),
        React.createElement("g", { id: "Spots", transform: "translate(0 12.021) rotate(-45)" },
            React.createElement("g", { id: "Mask_Group_6", "data-name": "Mask Group 6", clipPath: "url(#clip-path)" },
                React.createElement("path", { id: "football-ball-solid", d: "M16.5,2.051A1.81,1.81,0,0,0,15.225.769,15.357,15.357,0,0,0,11.633.258L17,5.632A15.4,15.4,0,0,0,16.5,2.051ZM.5,15.466a1.81,1.81,0,0,0,1.278,1.282,15.357,15.357,0,0,0,3.592.511L0,11.884a15.4,15.4,0,0,0,.5,3.582ZM.144,9.7l7.41,7.424a10.891,10.891,0,0,0,9.305-9.3L9.446.4A10.884,10.884,0,0,0,.144,9.7ZM11.019,5.461a.275.275,0,0,1,.387,0l.387.387a.275.275,0,0,1,0,.387l-.97.97.97.97a.275.275,0,0,1,0,.387l-.387.387a.275.275,0,0,1-.387,0l-.97-.97-.775.778.97.97a.275.275,0,0,1,0,.387l-.387.387a.275.275,0,0,1-.387,0l-.97-.97-.775.775.97.97a.275.275,0,0,1,0,.387l-.387.387a.275.275,0,0,1-.387,0l-.97-.97-.97.97a.275.275,0,0,1-.387,0l-.387-.387a.275.275,0,0,1,0-.387l.97-.97-.97-.967a.275.275,0,0,1,0-.387l.387-.387a.275.275,0,0,1,.387,0l.97.97.775-.775-.97-.97a.275.275,0,0,1,0-.387l.387-.387a.275.275,0,0,1,.387,0l.97.97.775-.775-.97-.97a.275.275,0,0,1,0-.387l.387-.387a.275.275,0,0,1,.387,0l.97.97.97-.977Z", transform: "translate(0 -0.258)", fill: "#35363a" })))));
};
const BasketballLogo = (_a) => {
    var { className, width = 54, height = 32, fill } = _a; __rest(_a, ["className", "width", "height", "fill"]);
    return (React.createElement("svg", { className: className, xmlns: "http://www.w3.org/2000/svg", width: "13.375", height: "13.375", viewBox: "0 0 13.375 13.375" },
        React.createElement("g", { transform: "translate(-440 -747.313)" },
            React.createElement("path", { d: "M5.725.625a6.648,6.648,0,0,0-3.3,1.451L4.517,4.162A6.006,6.006,0,0,0,5.725.625Zm.963,5.709,4.258-4.258A6.665,6.665,0,0,0,7.022.563,7.277,7.277,0,0,1,5.439,5.085ZM1.513,2.992a6.648,6.648,0,0,0-1.451,3.3A6,6,0,0,0,3.6,5.079ZM8.853,8.5a7.3,7.3,0,0,1,4.522-1.583,6.665,6.665,0,0,0-1.513-3.924L7.6,7.25,8.853,8.5ZM6.687,8.167,2.43,12.425a6.683,6.683,0,0,0,3.924,1.513A7.3,7.3,0,0,1,7.936,9.415Zm5.175,3.341a6.648,6.648,0,0,0,1.451-3.3A6.03,6.03,0,0,0,9.775,9.421ZM4.522,6A7.261,7.261,0,0,1,0,7.584a6.665,6.665,0,0,0,1.513,3.924L5.771,7.25ZM7.65,13.875a6.648,6.648,0,0,0,3.3-1.451L8.858,10.338A6.036,6.036,0,0,0,7.65,13.875Z", transform: "translate(440 746.75)" }))));
};
const CheckMark = (_a) => {
    __rest(_a, ["className", "width", "height", "fill"]);
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "30", height: "30", viewBox: "0 0 30 30" },
        React.createElement("g", { id: "Group_1051", "data-name": "Group 1051", transform: "translate(-44 -1267)" },
            React.createElement("circle", { id: "Ellipse_229", "data-name": "Ellipse 229", cx: "15", cy: "15", r: "15", transform: "translate(44 1267)", fill: "#002539" }),
            React.createElement("g", { id: "Yes", transform: "translate(51 1274)" },
                React.createElement("path", { id: "Checkbox", d: "M6.9,12,1,6.1,2.4,4.7,6.9,9.1,15,1l1.4,1.4Z", transform: "translate(-1 1)", fill: "#fff" }),
                React.createElement("rect", { id: "Rectangle_556", "data-name": "Rectangle 556", width: "16", height: "16", fill: "none" })))));
};
const DeactiveClock = (_a) => {
    __rest(_a, ["className", "width", "height", "fill"]);
    return (React.createElement("svg", { id: "Time", xmlns: "http://www.w3.org/2000/svg", width: "30", height: "30", viewBox: "0 0 30 30" },
        React.createElement("path", { id: "Path_13", "data-name": "Path 13", d: "M4.5,4.5A13.617,13.617,0,0,1,15,0,13.617,13.617,0,0,1,25.5,4.5,13.617,13.617,0,0,1,30,15a13.617,13.617,0,0,1-4.5,10.5A13.617,13.617,0,0,1,15,30,13.617,13.617,0,0,1,4.5,25.5C1.75,22.5,0,19.25,0,15A13.617,13.617,0,0,1,4.5,4.5ZM21.75,21.75,23.5,20l-6.25-6.25L15,3.75H12.5V15a2.27,2.27,0,0,0,.75,1.75.873.873,0,0,0,.5.25Z", fill: "#ccc" })));
};
const WhiteClock = (_a) => {
    __rest(_a, ["className", "width", "height", "fill"]);
    return (React.createElement("svg", { id: "Time", xmlns: "http://www.w3.org/2000/svg", width: "25", height: "25", viewBox: "0 0 30 30" },
        React.createElement("path", { id: "Path_13", "data-name": "Path 13", d: "M4.5,4.5A13.617,13.617,0,0,1,15,0,13.617,13.617,0,0,1,25.5,4.5,13.617,13.617,0,0,1,30,15a13.617,13.617,0,0,1-4.5,10.5A13.617,13.617,0,0,1,15,30,13.617,13.617,0,0,1,4.5,25.5C1.75,22.5,0,19.25,0,15A13.617,13.617,0,0,1,4.5,4.5ZM21.75,21.75,23.5,20l-6.25-6.25L15,3.75H12.5V15a2.27,2.27,0,0,0,.75,1.75.873.873,0,0,0,.5.25Z", fill: "white" })));
};
const RedClock = (_a) => {
    __rest(_a, ["className", "width", "height", "fill"]);
    return (React.createElement("svg", { id: "Time", xmlns: "http://www.w3.org/2000/svg", width: "30", height: "30", viewBox: "0 0 30 30" },
        React.createElement("path", { id: "Path_13", "data-name": "Path 13", d: "M4.5,4.5A13.617,13.617,0,0,1,15,0,13.617,13.617,0,0,1,25.5,4.5,13.617,13.617,0,0,1,30,15a13.617,13.617,0,0,1-4.5,10.5A13.617,13.617,0,0,1,15,30,13.617,13.617,0,0,1,4.5,25.5C1.75,22.5,0,19.25,0,15A13.617,13.617,0,0,1,4.5,4.5ZM21.75,21.75,23.5,20l-6.25-6.25L15,3.75H12.5V15a2.27,2.27,0,0,0,.75,1.75.873.873,0,0,0,.5.25Z", fill: "red" })));
};
const MavenFullLogo = (_a) => {
    var { className, width = 153, height = 24, fill } = _a; __rest(_a, ["className", "width", "height", "fill"]);
    return (React.createElement("svg", { className: className, width: width, height: height, viewBox: "0 0 153 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M56.1201 0L65.5352 10.998L74.9502 0V22.4019H71.0543V11.5261C71.0543 11.4395 70.9987 11.3623 70.916 11.3356C70.8338 11.3089 70.7433 11.3384 70.6928 11.4089L65.5352 18.5359C65.5352 18.5359 61.6058 13.1046 60.3783 11.4084C60.3271 11.3378 60.2372 11.3084 60.1545 11.3351C60.0723 11.3617 60.0162 11.4389 60.0162 11.5255V22.4019H56.1201V0Z", fill: fill }),
        React.createElement("path", { d: "M104.172 22.4019L94.5649 0H98.817C98.817 0 103.048 8.71331 103.976 10.6288C104.009 10.6976 104.08 10.7416 104.156 10.7416C104.232 10.7416 104.303 10.6976 104.336 10.6294C105.271 8.7149 109.525 0 109.525 0H113.766L104.172 22.4019Z", fill: fill }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M77.735 22.3971H81.9941L83.636 18.5354H91.0155L92.6841 22.431H96.9244L87.3288 0.0301514L77.735 22.3971ZM85.2917 14.6393L87.1261 9.77772C87.1555 9.70002 87.2294 9.64839 87.3127 9.64839C87.3959 9.64839 87.4703 9.70002 87.4998 9.77723L89.3471 14.6393H85.2917Z", fill: fill }),
        React.createElement("path", { d: "M149.053 0.0406718H152.942V24L139.652 11.3446C139.594 11.2896 139.509 11.2741 139.436 11.3058C139.362 11.3374 139.315 11.4096 139.315 11.4896V22.4314H135.426V0.0301514C135.426 0.0301514 146.586 11.9943 148.708 14.269C148.764 14.329 148.851 14.3484 148.928 14.3184C149.004 14.2884 149.054 14.2146 149.054 14.1324C149.054 11.5556 149.053 0.0406718 149.053 0.0406718Z", fill: fill }),
        React.createElement("path", { d: "M116.043 14.5986V22.4029H129.678V18.5068H119.939V13.1993H127.189L127.188 9.54865H119.937V3.90753H129.678V0.0120239H116.042V10.9479C116.042 11.5561 116.042 12.1645 116.042 12.7728C116.042 13.3814 116.043 13.99 116.043 14.5986Z", fill: fill }),
        React.createElement("path", { d: "M56.1201 0L65.5352 10.998L74.9502 0V22.4019H71.0543V11.5261C71.0543 11.4395 70.9987 11.3623 70.916 11.3356C70.8338 11.3089 70.7433 11.3384 70.6928 11.4089L65.5352 18.5359C65.5352 18.5359 61.6058 13.1046 60.3783 11.4084C60.3271 11.3378 60.2372 11.3084 60.1545 11.3351C60.0723 11.3617 60.0162 11.4389 60.0162 11.5255V22.4019H56.1201V0Z", fill: fill }),
        React.createElement("path", { d: "M104.172 22.4019L94.5649 0H98.817C98.817 0 103.048 8.71331 103.976 10.6288C104.009 10.6976 104.08 10.7416 104.156 10.7416C104.232 10.7416 104.303 10.6976 104.336 10.6294C105.271 8.7149 109.525 0 109.525 0H113.766L104.172 22.4019Z", fill: fill }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M77.735 22.3971H81.9941L83.636 18.5354H91.0155L92.6841 22.431H96.9244L87.3288 0.0301514L77.735 22.3971ZM85.2917 14.6393L87.1261 9.77772C87.1555 9.70002 87.2294 9.64839 87.3127 9.64839C87.3959 9.64839 87.4703 9.70002 87.4998 9.77723L89.3471 14.6393H85.2917Z", fill: fill }),
        React.createElement("path", { d: "M149.053 0.0406718H152.942V24L139.652 11.3446C139.594 11.2896 139.509 11.2741 139.436 11.3058C139.362 11.3374 139.315 11.4096 139.315 11.4896V22.4314H135.426V0.0301514C135.426 0.0301514 146.586 11.9943 148.708 14.269C148.764 14.329 148.851 14.3484 148.928 14.3184C149.004 14.2884 149.054 14.2146 149.054 14.1324C149.054 11.5556 149.053 0.0406718 149.053 0.0406718Z", fill: fill }),
        React.createElement("path", { d: "M116.043 14.5986V22.4029H129.678V18.5068H119.939V13.1993H127.189L127.188 9.54865H119.937V3.90753H129.678V0.0120239H116.042V10.9479C116.042 11.5561 116.042 12.1645 116.042 12.7728C116.042 13.3814 116.043 13.99 116.043 14.5986Z", fill: fill }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M19.9378 8.72934C20.1255 8.91703 20.3798 9.02201 20.6446 9.02201H45.2898C45.9588 9.02201 46.5018 9.50506 46.5018 10.1013V13.3144H20.7252C20.4598 13.3144 20.206 13.42 20.0183 13.6071C18.4598 15.1656 11.2085 22.4169 11.2085 22.4169L0 11.2085L11.2085 0C11.2085 0 18.3882 7.17911 19.9378 8.72934ZM46.2769 14.4916V21.0011H43.8439C43.5258 21.0011 43.2209 20.8745 42.9961 20.6497C42.7713 20.4248 42.6446 20.12 42.6446 19.8018V14.4916H46.2769ZM40.0034 14.4916V19.02H37.5704C37.2522 19.02 36.9473 18.8934 36.7226 18.6686C36.4977 18.4437 36.371 18.1388 36.371 17.8207V14.4916H40.0034ZM13.4505 6.72494C13.4505 6.72494 12.3595 5.6339 11.6994 4.9743C11.5694 4.84387 11.3929 4.77107 11.2085 4.77107C11.0247 4.77107 10.8481 4.84387 10.7177 4.9743C9.16859 6.52342 4.48354 11.2085 4.48354 11.2085C4.48354 11.2085 8.90981 15.6347 10.5806 17.3055C10.9275 17.6525 11.49 17.6525 11.8364 17.3055C12.5005 16.6415 13.4527 15.6892 13.4527 15.6892L8.97197 11.2085L13.4505 6.72494ZM17.2727 11.1168L14.7742 8.61836C13.9414 9.45123 13.1085 10.284 12.2756 11.1168L14.7742 13.6154L17.2727 11.1168Z", fill: fill })));
};
const KeyIcon = (_a) => {
    var { className, width = 54, height = 32, fill } = _a; __rest(_a, ["className", "width", "height", "fill"]);
    return (React.createElement("svg", { className: className, width: width, height: height, viewBox: "0 0 48 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M47.5731 23.8071H45.0974C44.7699 23.8067 44.4567 23.6776 44.2248 23.4487C43.9929 23.2197 43.864 22.909 43.8627 22.5848V17.2148H47.5762V23.8025L47.5731 23.8071ZM11.738 22.9616L0.284973 11.6334L11.738 0.280731L20.6627 9.10311C20.7495 9.19242 20.8543 9.26342 20.9691 9.31294C21.0838 9.36247 21.206 9.3889 21.3311 9.39106H46.5736C46.8801 9.37875 47.1796 9.4852 47.4091 9.68667C47.6386 9.88814 47.7778 10.1697 47.8021 10.4724V13.7502H21.4425C21.1749 13.7491 20.9171 13.8509 20.7246 14.0351L11.738 22.9616ZM11.738 6.77192L6.58861 11.7314L11.738 16.6174L16.6707 11.7314L11.738 6.77192ZM41.155 21.8128H38.6731C38.3471 21.8112 38.0372 21.6826 37.8066 21.4544C37.5761 21.2262 37.4431 20.9179 37.4415 20.5952V17.2163H41.1581V21.8159L41.155 21.8128Z", fill: fill })));
};
const Plus = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M6 13V12H12V6H13V12H19V13H13V19H12V13H6Z", fill: "black" })));
const Minus = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M5 13V12H18.01L18 13H5Z", fill: "black" })));
const Search = props => (React.createElement(Icon, Object.assign({}, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11Z", fill: "white" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.9428 15.9429C16.3333 15.5524 16.9665 15.5524 17.357 15.9429L21.707 20.2929C22.0975 20.6834 22.0975 21.3166 21.707 21.7071C21.3165 22.0976 20.6833 22.0976 20.2928 21.7071L15.9428 17.3571C15.5523 16.9666 15.5523 16.3334 15.9428 15.9429Z", fill: "white" })));
const AltVideo = props => (React.createElement(Icon, Object.assign({ viewBox: "5 5 15 15" }, props),
    React.createElement("path", { d: "M3 9C3 6.79086 4.79086 5 7 5H16.2153C18.4244 5 20.2153 6.79086 20.2153 9V14.44C20.2153 16.6491 18.4244 18.44 16.2153 18.44H7.00001C4.79087 18.44 3 16.6491 3 14.44V9Z", fill: "white" }),
    React.createElement("path", { d: "M9 15L14.2752 12L9 9V15Z", fill: "black" })));
const Video = props => (React.createElement(Icon, Object.assign({ viewBox: "5 5 15 15" }, props),
    React.createElement("g", { clipPath: "url(#clip0)" },
        React.createElement("g", { filter: "url(#filter0_d)" },
            React.createElement("path", { d: "M3 9C3 6.79086 4.79086 5 7 5H16.2153C18.4244 5 20.2153 6.79086 20.2153 9V14.44C20.2153 16.6491 18.4244 18.44 16.2153 18.44H7C4.79086 18.44 3 16.6491 3 14.44V9Z", fill: "white" })),
        React.createElement("path", { d: "M9 15L14.2752 12L9 9V15Z", fill: "black", stroke: "black", strokeWidth: "0.25", strokeLinecap: "round", strokeLinejoin: "round" })),
    React.createElement("defs", null,
        React.createElement("filter", { id: "filter0_d", x: "-2", y: "0", width: "27.2153", height: "23.44", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
            React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
            React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
            React.createElement("feOffset", null),
            React.createElement("feGaussianBlur", { stdDeviation: "2.5" }),
            React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0" }),
            React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow" }),
            React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow", result: "shape" })),
        React.createElement("clipPath", { id: "clip0" },
            React.createElement("rect", { width: "24", height: "24", fill: "white" })))));
const LinkVariant = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 19 19" }, props),
    React.createElement("path", { d: "M8.728 11.965C8.7885 11.9921 8.843 12.031 8.88834 12.0794C8.93367 12.1278 8.96892 12.1847 8.99205 12.2469C9.01517 12.309 9.02571 12.3751 9.02304 12.4414C9.02037 12.5076 9.00455 12.5727 8.9765 12.6328C8.94845 12.6928 8.90872 12.7467 8.85965 12.7913C8.81057 12.8359 8.75311 12.8703 8.69062 12.8925C8.62813 12.9146 8.56186 12.9242 8.49565 12.9205C8.42945 12.9168 8.36464 12.9 8.305 12.871V12.872C7.64925 12.5663 7.07689 12.107 6.63643 11.533C6.19598 10.959 5.90042 10.2872 5.77481 9.57471C5.64921 8.86219 5.69726 8.12988 5.91489 7.43988C6.13252 6.74987 6.51332 6.12252 7.025 5.611L10.561 2.075C10.9789 1.65713 11.4749 1.32566 12.0209 1.09952C12.5669 0.87337 13.152 0.756973 13.743 0.756973C14.3339 0.756973 14.9191 0.87337 15.4651 1.09952C16.0111 1.32566 16.5071 1.65713 16.925 2.075C17.3429 2.49287 17.6743 2.98895 17.9005 3.53491C18.1266 4.08088 18.243 4.66605 18.243 5.257C18.243 5.84795 18.1266 6.43312 17.9005 6.97909C17.6743 7.52506 17.3429 8.02113 16.925 8.439L15.291 10.072L15.141 8.808L16.218 7.732C16.8744 7.07559 17.2432 6.18531 17.2432 5.257C17.2432 4.3287 16.8744 3.43841 16.218 2.782C15.5616 2.12559 14.6713 1.75682 13.743 1.75682C12.8147 1.75682 11.9244 2.12559 11.268 2.782L7.732 6.318C7.33389 6.71581 7.03758 7.20375 6.8682 7.74045C6.69882 8.27716 6.66137 8.84679 6.75901 9.40105C6.85665 9.95532 7.08652 10.4779 7.42911 10.9244C7.7717 11.3709 8.21691 11.7282 8.727 11.966V11.965H8.728ZM2.075 16.925C1.65713 16.5071 1.32566 16.0111 1.09951 15.4651C0.873356 14.9191 0.756958 14.334 0.756958 13.743C0.756958 13.152 0.873356 12.5669 1.09951 12.0209C1.32566 11.4749 1.65713 10.9789 2.075 10.561L3.709 8.928L3.859 10.192L2.782 11.268C2.12559 11.9244 1.75682 12.8147 1.75682 13.743C1.75682 14.2027 1.84735 14.6578 2.02325 15.0825C2.19915 15.5071 2.45698 15.893 2.782 16.218C3.10702 16.543 3.49288 16.8008 3.91754 16.9767C4.3422 17.1526 4.79735 17.2432 5.257 17.2432C6.1853 17.2432 7.07559 16.8744 7.732 16.218L11.268 12.682C11.6661 12.2842 11.9624 11.7963 12.1318 11.2595C12.3012 10.7228 12.3386 10.1532 12.241 9.59895C12.1433 9.04469 11.9135 8.52214 11.5709 8.07563C11.2283 7.62912 10.7831 7.27181 10.273 7.034V7.035C10.2113 7.00871 10.1556 6.97028 10.1091 6.922C10.0625 6.87372 10.0262 6.81658 10.0022 6.75397C9.97822 6.69137 9.96706 6.62458 9.96941 6.55757C9.97175 6.49057 9.98755 6.42472 10.0159 6.36395C10.0442 6.30317 10.0844 6.24871 10.1342 6.2038C10.184 6.1589 10.2423 6.12446 10.3056 6.10254C10.369 6.08062 10.4361 6.07167 10.503 6.07621C10.5699 6.08076 10.6352 6.09871 10.695 6.129V6.128C11.3507 6.43372 11.9231 6.89305 12.3636 7.46704C12.804 8.04103 13.0996 8.71277 13.2252 9.42529C13.3508 10.1378 13.3027 10.8701 13.0851 11.5601C12.8675 12.2501 12.4867 12.8775 11.975 13.389L8.439 16.925C8.02113 17.3429 7.52505 17.6743 6.97908 17.9005C6.43312 18.1266 5.84795 18.243 5.257 18.243C4.66604 18.243 4.08088 18.1266 3.53491 17.9005C2.98894 17.6743 2.49286 17.3429 2.075 16.925Z", fill: "black" })));
const GeneralAttachment = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M3 7C3 4.79086 4.79086 3 7 3H11.5C11.7761 3 12 3.22386 12 3.5C12 3.77614 11.7761 4 11.5 4H7C5.34315 4 4 5.34315 4 7V17C4 18.6569 5.34315 20 7 20H17.5C17.7761 20 18 20.2239 18 20.5C18 20.7761 17.7761 21 17.5 21H7C4.79086 21 3 19.2091 3 17V7Z", fill: "black" }),
    React.createElement("path", { d: "M14 6.5V14.5C14 14.7761 14.2239 15 14.5 15C14.7761 15 15 14.7761 15 14.5V6.5C15 5.11929 16.1193 4 17.5 4C18.8807 4 20 5.11929 20 6.5V14.5C20 15.3284 19.3284 16 18.5 16C17.6716 16 17 15.3284 17 14.5V7.5C17 7.22386 17.2239 7 17.5 7C17.7761 7 18 7.22386 18 7.5V13.5C18 13.7761 18.2239 14 18.5 14C18.7761 14 19 13.7761 19 13.5V7.5C19 6.67157 18.3284 6 17.5 6C16.6716 6 16 6.67157 16 7.5V14.5C16 15.8807 17.1193 17 18.5 17C19.8807 17 21 15.8807 21 14.5V6.5C21 4.567 19.433 3 17.5 3C15.567 3 14 4.567 14 6.5Z", fill: "black" })));
const LinkOpen = props => (React.createElement(Icon, Object.assign({}, props),
    React.createElement("path", { d: "M14,3V5H17.59L7.76,14.83L9.17,16.24L19,6.41V10H21V3M19,19H5V5H12V3H5C3.89,3 3,3.9 3,5V19C3,20.1 3.9,21 5,21H19C20.1,21 21,20.1 21,19V12H19V19Z", fill: "black" })));
const QuoteIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 16 16" }, props),
    React.createElement("path", { d: "M0 12V4L1.95 0H6.151L4.201 4H6V12H0ZM1 4.23V11H5V5H2.6L4.551 1H2.576L1 4.23ZM7 12V4L8.95 0H13.151L11.201 4H13V12H7ZM8 4.23V11H12V5H9.6L11.551 1H9.576L8 4.23Z", fill: "black" })));
const FilledQuoteIcon = props => (React.createElement(Icon, Object.assign({}, props),
    React.createElement("path", { d: "M5 0L3 4h3v6H0V4l2-4h3zm8 0l-2 4h3v6H8V4l2-4h3z", fill: "#000" })));
const ErrorIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 17 17" }, props),
    React.createElement("path", { d: "M0 12.011V4.98L4.98 0H12.02L17 4.98V12.026L12.025 17H4.99L0 12.011ZM5.393 1L1 5.393V11.597L5.403 16H11.611L16 11.611V5.393L11.607 1H5.393ZM8 4H9V9H8V4ZM8 11H9V13H8V11Z", fill: "black" })));
const CloseIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 16 16" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12.4714 4.47145C12.7318 4.2111 12.7318 3.78899 12.4714 3.52864C12.2111 3.26829 11.789 3.26829 11.5286 3.52864L8.00001 7.05723L4.47141 3.52864C4.21107 3.26829 3.78896 3.26829 3.52861 3.52864C3.26826 3.78899 3.26826 4.2111 3.52861 4.47145L7.0572 8.00004L3.52861 11.5286C3.26826 11.789 3.26826 12.2111 3.52861 12.4714C3.78896 12.7318 4.21107 12.7318 4.47141 12.4714L8.00001 8.94285L11.5286 12.4714C11.789 12.7318 12.2111 12.7318 12.4714 12.4714C12.7318 12.2111 12.7318 11.789 12.4714 11.5286L8.94282 8.00004L12.4714 4.47145Z", fill: "black" })));
const DownArrow = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 6 4" }, props),
    React.createElement("path", { d: "M3.11034 3.75223L0.783949 1.16735C0.610198 0.974289 0.747206 0.666656 1.00694 0.666656H5.65972C5.91945 0.666656 6.05646 0.974289 5.88271 1.16735L3.55632 3.75223C3.43714 3.88464 3.22951 3.88464 3.11034 3.75223Z", fill: "black" })));
const Delete = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 15 19" }, props),
    React.createElement("path", { d: "M14 16C14 16.7956 13.6839 17.5587 13.1213 18.1213C12.5587 18.6839 11.7956 19 11 19H4C3.20435 19 2.44129 18.6839 1.87868 18.1213C1.31607 17.5587 1 16.7956 1 16V4H0V1H4.5L5.5 0H9.5L10.5 1H15V4H14V16ZM2 4V16C2 16.5304 2.21071 17.0391 2.58579 17.4142C2.96086 17.7893 3.46957 18 4 18H11C11.5304 18 12.0391 17.7893 12.4142 17.4142C12.7893 17.0391 13 16.5304 13 16V4H2ZM14 3V2H10L9 1H6L5 2H1V3H14ZM4 6H5V16H4V6ZM10 6H11V16H10V6Z", fill: "black" })));
const SearchIcon = (_a) => {
    var { className, fill = 'black' } = _a, props = __rest(_a, ["className", "fill"]);
    return (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props, { title: "Search" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M4 11C4 7.13401 7.13401 4 11 4C14.866 4 18 7.13401 18 11C18 12.8859 17.2542 14.5977 16.0414 15.8563C16.0072 15.8827 15.9743 15.9115 15.9429 15.9429C15.9115 15.9743 15.8827 16.0072 15.8563 16.0414C14.5977 17.2542 12.8859 18 11 18C7.13401 18 4 14.866 4 11ZM16.6177 18.0319C15.078 19.2635 13.125 20 11 20C6.02944 20 2 15.9706 2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 13.125 19.2635 15.078 18.0319 16.6177L21.7071 20.2929C22.0976 20.6834 22.0976 21.3166 21.7071 21.7071C21.3166 22.0976 20.6834 22.0976 20.2929 21.7071L16.6177 18.0319Z", fill: fill })));
};
const MenuIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 6C3 5.44772 3.44772 5 4 5L14 5C14.5523 5 15 5.44771 15 6C15 6.55228 14.5523 7 14 7L4 7C3.44772 7 3 6.55228 3 6Z", fill: "black" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 12C3 11.4477 3.44772 11 4 11L20 11C20.5523 11 21 11.4477 21 12C21 12.5523 20.5523 13 20 13L4 13C3.44772 13 3 12.5523 3 12Z", fill: "black" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 18C3 17.4477 3.44772 17 4 17L10 17C10.5523 17 11 17.4477 11 18C11 18.5523 10.5523 19 10 19L4 19C3.44772 19 3 18.5523 3 18Z", fill: "black" })));
const MessageIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M5 3H18C18.7956 3 19.5587 3.31607 20.1213 3.87868C20.6839 4.44129 21 5.20435 21 6V15C21 15.7956 20.6839 16.5587 20.1213 17.1213C19.5587 17.6839 18.7956 18 18 18H13.414L9.707 21.707C9.56715 21.8468 9.38898 21.942 9.19503 21.9806C9.00108 22.0192 8.80005 21.9993 8.61735 21.9237C8.43465 21.848 8.27848 21.7199 8.1686 21.5555C8.05871 21.391 8.00004 21.1978 8 21V18H5C4.20435 18 3.44129 17.6839 2.87868 17.1213C2.31607 16.5587 2 15.7956 2 15V6C2 5.20435 2.31607 4.44129 2.87868 3.87868C3.44129 3.31607 4.20435 3 5 3ZM18 4H5C4.46957 4 3.96086 4.21071 3.58579 4.58579C3.21071 4.96086 3 5.46957 3 6V15C3 15.5304 3.21071 16.0391 3.58579 16.4142C3.96086 16.7893 4.46957 17 5 17H9V21L13 17H18C18.5304 17 19.0391 16.7893 19.4142 16.4142C19.7893 16.0391 20 15.5304 20 15V6C20 5.46957 19.7893 4.96086 19.4142 4.58579C19.0391 4.21071 18.5304 4 18 4ZM5 7H18V8H5V7ZM5 10H17V11H5V10ZM5 13H13V14H5V13Z", fill: "black" })));
const BellIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props),
    React.createElement("path", { d: "M12 4.5C12 4.36739 11.9473 4.24021 11.8536 4.14645C11.7598 4.05268 11.6326 4 11.5 4C11.3674 4 11.2402 4.05268 11.1464 4.14645C11.0527 4.24021 11 4.36739 11 4.5V6.027C9.89981 6.15001 8.88356 6.67424 8.14561 7.49946C7.40766 8.32467 6.99979 9.39295 7 10.5V16.414L5.414 18H17.586L16 16.414V10.5C16.0002 9.39295 15.5923 8.32467 14.8544 7.49946C14.1164 6.67424 13.1002 6.15001 12 6.027V4.5ZM11.5 3C11.8978 3 12.2794 3.15804 12.5607 3.43934C12.842 3.72064 13 4.10218 13 4.5V5.207C15.309 5.86 17 7.982 17 10.5V16L20 19H3L6 16V10.5C6 9.30267 6.39058 8.13802 7.11247 7.18278C7.83436 6.22754 8.84815 5.53386 10 5.207V4.5C10 4.10218 10.158 3.72064 10.4393 3.43934C10.7206 3.15804 11.1022 3 11.5 3ZM11.5 22C10.9237 22.0001 10.365 21.8011 9.91855 21.4367C9.47209 21.0722 9.16527 20.5647 9.05 20H10.085C10.1881 20.293 10.3796 20.5468 10.633 20.7263C10.8865 20.9058 11.1894 21.0022 11.5 21.0022C11.8106 21.0022 12.1135 20.9058 12.367 20.7263C12.6204 20.5468 12.8119 20.293 12.915 20H13.95C13.8347 20.5647 13.5279 21.0722 13.0815 21.4367C12.635 21.8011 12.0763 22.0001 11.5 22Z", fill: "black" })));
const Login = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.586 11L7.05 8.464L8.464 7.05L13.414 12L8.464 16.95L7.05 15.536L9.586 13H3V11H9.586ZM11 3H19C20.1 3 21 3.9 21 5V19C21 20.1 20.1 21 19 21H11V19H19V5H11V3Z", fill: "black" })));
const TwitterIcon = (_a) => {
    var props = __rest(_a, ["className", "fill"]);
    return (React.createElement(Icon, Object.assign({ viewBox: "0 0 24.62 20" }, props),
        React.createElement("path", { fill: "white", d: "M24.62 2.38A10.85 10.85 0 0 1 22.09 5v.66A14.26 14.26 0 0 1 7.75 20 14.26 14.26 0 0 1 0 17.73a10.41 10.41 0 0 0 1.22.06 10.11 10.11 0 0 0 6.27-2.16 5.06 5.06 0 0 1-4.72-3.5 6.35 6.35 0 0 0 1 .08A5.35 5.35 0 0 0 5 12a5 5 0 0 1-4-5 5.09 5.09 0 0 0 2.28.64A5.05 5.05 0 0 1 1.72.92 14.34 14.34 0 0 0 12.13 6.2 5.71 5.71 0 0 1 12 5a5 5 0 0 1 5-5 5 5 0 0 1 3.69 1.59A9.94 9.94 0 0 0 23.94.38a5 5 0 0 1-2.22 2.78 10.12 10.12 0 0 0 2.91-.78z" })));
};
const FacebookIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "white", d: "M13.5.19v4.12H11c-1.92 0-2.28.92-2.28 2.25v3h4.58l-.61 4.63h-4V26H4V14.14H0V9.52h4V6.11C4 2.16 6.41 0 9.94 0a30.8 30.8 0 0 1 3.56.19z" })));
const InstagramIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "white", d: "M16 12a4 4 0 1 0-4 4 4 4 0 0 0 4-4zm2.16 0A6.16 6.16 0 1 1 12 5.84 6.15 6.15 0 0 1 18.16 12zm1.69-6.41a1.44 1.44 0 1 1-1.44-1.44 1.43 1.43 0 0 1 1.43 1.44zM12 2.16c-1.75 0-5.5-.14-7.08.48a3.84 3.84 0 0 0-1.37.91 3.82 3.82 0 0 0-.91 1.38C2 6.5 2.16 10.25 2.16 12s-.14 5.5.48 7.08a3.84 3.84 0 0 0 .91 1.38 3.82 3.82 0 0 0 1.37.91c1.58.63 5.33.48 7.08.48s5.5.14 7.08-.48a4.09 4.09 0 0 0 2.28-2.28c.63-1.58.48-5.33.48-7.08s.14-5.5-.48-7.08a3.84 3.84 0 0 0-.91-1.38 3.82 3.82 0 0 0-1.37-.91C17.5 2 13.75 2.16 12 2.16zM24 12c0 1.66 0 3.3-.08 5A7.14 7.14 0 0 1 22 22a7.13 7.13 0 0 1-5 1.94c-1.66.09-3.3.08-5 .08s-3.3 0-5-.08A7.14 7.14 0 0 1 2 22a7.13 7.13 0 0 1-1.92-5C0 15.3 0 13.66 0 12s0-3.3.08-5A7.14 7.14 0 0 1 2 2 7.13 7.13 0 0 1 7 .08C8.7 0 10.34 0 12 0s3.3 0 5 .08A7.14 7.14 0 0 1 22 2a7.13 7.13 0 0 1 1.94 5c.06 1.7.06 3.34.06 5z" })));
const LinkedinIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "white", d: "M5.45 7.45v15.49H.3V7.45zm.33-4.78a2.67 2.67 0 0 1-2.9 2.67A2.68 2.68 0 1 1 2.91 0a2.66 2.66 0 0 1 2.87 2.67zM24 14.06v8.88h-5.14v-8.28c0-2.08-.75-3.5-2.61-3.5A2.82 2.82 0 0 0 13.61 13a3.88 3.88 0 0 0-.17 1.27v8.64H8.3c.06-14 0-15.48 0-15.48h5.14V9.7a5.1 5.1 0 0 1 4.64-2.6c3.39 0 5.92 2.22 5.92 7z" })));
const YoutubeIcon = props => (React.createElement(Icon, Object.assign({ viewBox: "0 0 28 19.69" }, props),
    React.createElement("path", { fill: "white", d: "M11.11 13.47l7.56-3.91-7.56-4zM14 0c5.89 0 9.8.28 9.8.28a4 4 0 0 1 2.81 1.19 4.92 4.92 0 0 1 1.11 2.78A37.79 37.79 0 0 1 28 8.78v2.12a37.78 37.78 0 0 1-.28 4.53 5 5 0 0 1-1.11 2.78 4 4 0 0 1-2.81 1.17s-3.91.3-9.8.3c-7.28-.06-9.52-.28-9.52-.28a4.72 4.72 0 0 1-3.09-1.19 5 5 0 0 1-1.11-2.77A37.79 37.79 0 0 1 0 10.91V8.78a37.78 37.78 0 0 1 .28-4.53 4.92 4.92 0 0 1 1.11-2.78A4 4 0 0 1 4.2.28S8.11 0 14 0z" })));
const useStyles$7 = makeStyles(theme => {
    const mavenTheme = theme;
    return {
        filled: {
            '& path': {
                fill: 'currentColor',
                stroke: 'currentColor'
            }
        },
        notFilled: {
            '& path': {
                fill: 'none',
                stroke: 'currentColor'
            }
        },
        thin: {
            '& path': {
                fill: 'currentColor',
                stroke: 'none'
            }
        },
        full: {
            width: '100%',
            height: '100%'
        },
        large: {
            width: mavenTheme.icon.large,
            height: mavenTheme.icon.large
        },
        medium: {
            width: mavenTheme.icon.normal,
            height: mavenTheme.icon.normal
        },
        small: {
            width: mavenTheme.icon.small,
            height: mavenTheme.icon.small
        }
    };
});
const Icon = props => {
    const classes = useStyles$7();
    const cs = props.filled !== undefined ? [props.filled ? classes.filled : classes.notFilled] : [];
    if (props.thin) {
        cs.push(classes.thin);
    }
    if (props.className) {
        cs.push(props.className);
    }
    switch (props.size) {
        case RelativeSize.Full:
            cs.push(classes.full);
            break;
        case RelativeSize.Large:
            cs.push(classes.large);
            break;
        case RelativeSize.Medium:
            cs.push(classes.medium);
            break;
        case RelativeSize.Small:
            cs.push(classes.small);
            break;
    }
    return (React.createElement("svg", { className: cs.join(' '), viewBox: props.viewBox },
        props.title && React.createElement("title", null, props.title),
        props.children));
};
const SearchBarSearchIcon = (props) => (React.createElement("svg", { height: "30px", width: "30px" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11 4C7.13401 4 4 7.13401 4 11C4 14.866 7.13401 18 11 18C14.866 18 18 14.866 18 11C18 7.13401 14.866 4 11 4ZM2 11C2 6.02944 6.02944 2 11 2C15.9706 2 20 6.02944 20 11C20 15.9706 15.9706 20 11 20C6.02944 20 2 15.9706 2 11Z", fill: props.color }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M15.9428 15.9429C16.3333 15.5524 16.9665 15.5524 17.357 15.9429L21.707 20.2929C22.0975 20.6834 22.0975 21.3166 21.707 21.7071C21.3165 22.0976 20.6833 22.0976 20.2928 21.7071L15.9428 17.3571C15.5523 16.9666 15.5523 16.3334 15.9428 15.9429Z", fill: props.color })));
const TheArenaGroupLogo = ({ className, fill = '#ffffff', width = 150, height = 80 }) => {
    return (React.createElement("svg", { className: className, x: "0px", y: "0px", viewBox: "0 0 864 432", width: width, height: height, xmlSpace: "preserve" },
        React.createElement("g", null,
            React.createElement("g", null,
                React.createElement("path", { fill: fill, d: "M215.6,112.4c0.7-0.2,1.1-0.8,0.9-1.5c-0.2-0.7-0.8-1.1-1.5-0.9c-0.7,0.2-1.1,0.8-0.9,1.5\n        C214.3,112.1,214.9,112.5,215.6,112.4" }),
                React.createElement("path", { fill: fill, d: "M227.1,139.4c1,0.5,2.1,0,2.6-0.9c0.5-1,0-2.1-0.9-2.6c-1-0.5-2.1,0-2.6,0.9\n        C225.7,137.8,226.1,138.9,227.1,139.4" }),
                React.createElement("path", { fill: fill, d: "M240.4,170.7c2.9,1.9,6.8,1.2,8.7-1.7c1.9-2.9,1.2-6.8-1.7-8.7c-2.9-1.9-6.8-1.2-8.7,1.7\n        C236.8,164.9,237.5,168.8,240.4,170.7" }),
                React.createElement("path", { fill: fill, d: "M206.3,228.9c4,1.8,8.7,0.1,10.6-3.9c1.8-4,0.1-8.7-3.9-10.6c-4-1.8-8.7-0.1-10.6,3.9\n        C200.6,222.4,202.3,227.1,206.3,228.9" }),
                React.createElement("path", { fill: fill, d: "M188.6,155.3c0.8-0.6,1-1.8,0.4-2.6c-0.6-0.8-1.8-1-2.6-0.4c-0.8,0.6-1,1.8-0.4,2.6\n        C186.6,155.7,187.8,155.9,188.6,155.3" }),
                React.createElement("path", { fill: fill, d: "M204.2,181.8c1.3-0.8,1.7-2.5,0.9-3.8c-0.8-1.3-2.5-1.7-3.9-0.9c-1.3,0.8-1.7,2.5-0.9,3.8\n        C201.1,182.2,202.9,182.6,204.2,181.8" }),
                React.createElement("path", { fill: fill, d: "M257.5,91.3c1.1-0.4,1.7-1.6,1.3-2.7c-0.4-1.1-1.6-1.7-2.7-1.3c-1.1,0.4-1.7,1.6-1.3,2.7\n        C255.2,91.1,256.4,91.7,257.5,91.3" }),
                React.createElement("path", { fill: fill, d: "M285.6,161.7c3.9,3.4,9.9,3,13.3-1c3.4-3.9,3-9.9-0.9-13.3c-3.9-3.4-9.9-3-13.3,0.9\n        C281.2,152.3,281.6,158.3,285.6,161.7" }),
                React.createElement("path", { fill: fill, d: "M274.5,119.9c2.1-1.8,2.3-4.8,0.5-6.9c-1.8-2.1-4.8-2.3-6.9-0.5c-2.1,1.8-2.3,4.8-0.5,6.9\n        C269.4,121.4,272.5,121.6,274.5,119.9" }),
                React.createElement("path", { fill: fill, d: "M304.8,213.2c7.1,5.3,17.2,3.8,22.5-3.4c5.3-7.1,3.8-17.2-3.4-22.5c-7.1-5.3-17.2-3.8-22.5,3.4\n        C296.2,197.9,297.7,207.9,304.8,213.2" }),
                React.createElement("path", { fill: fill, d: "M130.3,241.9c1.5,1.2,3.7,0.9,4.9-0.6c1.2-1.5,0.9-3.7-0.6-4.9c-1.5-1.2-3.7-0.9-4.9,0.6\n        C128.5,238.5,128.8,240.7,130.3,241.9" }),
                React.createElement("path", { fill: fill, d: "M243.3,69c0.5,0.3,1.1,0.2,1.4-0.3c0.3-0.5,0.2-1.1-0.3-1.4c-0.5-0.3-1.1-0.2-1.4,0.3\n        C242.7,68,242.8,68.7,243.3,69" }),
                React.createElement("path", { fill: fill, d: "M251.6,222c5.5,3.5,12.8,1.9,16.3-3.6c3.5-5.5,1.9-12.8-3.6-16.3c-5.5-3.5-12.8-1.9-16.3,3.6\n        C244.5,211.2,246.1,218.5,251.6,222" }),
                React.createElement("path", { fill: fill, d: "M233.3,274.7c3.6-7,0.8-15.6-6.2-19.2c-7-3.6-15.6-0.8-19.2,6.2c-3.6,7-0.8,15.6,6.2,19.2\n        C221.1,284.5,229.7,281.7,233.3,274.7" }),
                React.createElement("path", { fill: fill, d: "M292.5,273.3c5.5-9,2.6-20.8-6.4-26.3c-9-5.5-20.8-2.6-26.3,6.4c-5.5,9-2.6,20.8,6.4,26.3\n        C275.2,285.1,287,282.3,292.5,273.3" }),
                React.createElement("path", { fill: fill, d: "M183.6,276.2c1.7-5.1-1-10.7-6.1-12.4c-5.1-1.7-10.7,1-12.4,6.1c-1.7,5.1,1,10.7,6.1,12.4\n        C176.3,284,181.9,281.3,183.6,276.2" }),
                React.createElement("path", { fill: fill, d: "M188.4,308.8c-8.6-3.7-18.5,0.3-22.2,8.9c-3.7,8.6,0.3,18.5,8.9,22.2c8.6,3.7,18.5-0.3,22.2-8.9\n        C201,322.4,197,312.5,188.4,308.8" }),
                React.createElement("path", { fill: fill, d: "M246.2,304.5c-10.9-5.7-24.4-1.5-30.1,9.4c-5.7,10.9-1.5,24.4,9.4,30.1c10.9,5.7,24.4,1.5,30.1-9.4\n        C261.3,323.7,257.1,310.2,246.2,304.5" }),
                React.createElement("path", { fill: fill, d: "M379.6,291c-18.4-1.5-34.5,12.1-36,30.5c-1.5,18.4,12.1,34.5,30.5,36c18.4,1.5,34.5-12.1,36-30.5\n        C411.6,308.6,397.9,292.5,379.6,291" }),
                React.createElement("path", { fill: fill, d: "M363.3,272.4c7.7-11.5,4.6-27-6.8-34.7c-11.5-7.7-27-4.6-34.7,6.8c-7.7,11.5-4.6,27,6.8,34.7\n        C340,286.9,355.6,283.9,363.3,272.4" }),
                React.createElement("path", { fill: fill, d: "M137.9,283.2c3-0.5,5-3.4,4.5-6.4c-0.5-3-3.4-5-6.4-4.5c-3,0.5-5,3.4-4.5,6.4\n        C132,281.7,134.9,283.7,137.9,283.2" }),
                React.createElement("path", { fill: fill, d: "M314.8,300.2c-13.3-7.7-30.3-3.3-38,10c-7.7,13.3-3.3,30.3,10,38c13.3,7.7,30.3,3.3,38-10\n        C332.5,325,328.1,307.9,314.8,300.2" }),
                React.createElement("path", { fill: fill, d: "M102.4,285.3c2,1.4,4.7,0.8,6-1.1c1.4-2,0.8-4.7-1.1-6c-2-1.4-4.7-0.8-6,1.1C100,281.3,100.5,284,102.4,285.3\n        " }),
                React.createElement("path", { fill: fill, d: "M80.6,320c-2.4-1.5-5.6-0.8-7.2,1.6c-1.5,2.4-0.8,5.6,1.6,7.2c2.4,1.5,5.6,0.8,7.2-1.6\n        C83.7,324.7,83,321.5,80.6,320" }),
                React.createElement("path", { fill: fill, d: "M170.2,234.9c2.2-0.7,3.4-3,2.7-5.1c-0.7-2.2-3-3.4-5.1-2.7c-2.2,0.7-3.4,3-2.7,5.1\n        C165.8,234.4,168.1,235.6,170.2,234.9" }),
                React.createElement("path", { fill: fill, d: "M104.2,317.4c-3.9,0.4-6.7,3.9-6.3,7.7c0.4,3.9,3.9,6.7,7.7,6.3c3.9-0.4,6.7-3.9,6.3-7.7\n        C111.5,319.8,108,317,104.2,317.4" }),
                React.createElement("path", { fill: fill, d: "M141.4,313.1c-6.2-1.6-12.6,2.1-14.2,8.3c-1.6,6.2,2.1,12.6,8.3,14.2c6.2,1.6,12.6-2.1,14.2-8.3\n        C151.3,321.1,147.6,314.7,141.4,313.1" }),
                React.createElement("path", { fill: fill, d: "M165,189.7c-1.1-1-2.7-1-3.7,0.1c-1,1.1-1,2.7,0.1,3.7c1.1,1,2.7,1,3.7-0.1\n        C166.2,192.3,166.1,190.7,165,189.7" })),
            React.createElement("g", null,
                React.createElement("g", null,
                    React.createElement("polygon", { fill: !className && fill, points: "568.7,153.7 568.7,172.5 532.5,172.5 532.5,153.7 522.3,153.7 522.3,201.6 532.5,201.6 532.5,181\n          568.7,181 568.7,201.6 578.8,201.6 578.8,153.7 \t\t\t" }),
                    React.createElement("polygon", { fill: !className && fill, points: "510.5,153.7 510.5,163.5 486,163.5 486,201.6 475.9,201.6 475.9,163.5 451.4,163.5 451.4,153.7\n          " }),
                    React.createElement("polygon", { fill: !className && fill, points: "641.6,163 641.6,153.7 590.7,153.7 590.7,201.6 641.6,201.6 641.6,192.3 600,192.3 600,181\n          638.7,181 638.7,172.5 600,172.5 600,163 \t\t\t" })),
                React.createElement("g", null,
                    React.createElement("path", { fill: !className && fill, d: "M450,321.7c0-12.9,10-23.3,22.8-23.3c9.6,0,17.3,6,20.6,14.6l-3.6,0.7c-2.8-7-8.9-11.7-16.9-11.7\n          c-10.9,0-19.1,8.8-19.1,19.7c0,10.8,8,19.7,19.1,19.7c10.1,0,16.9-7.4,17.8-17.3h-18l-0.1-3.3h21.7v1c0,12.8-8.6,23-21.5,23\n          C459.8,344.9,450,334.4,450,321.7z" }),
                    React.createElement("path", { fill: !className && fill, d: "M502.3,309.9h3.6v7.8c2.1-5.9,7.6-9.1,15-7.9v3.7c-8.5-1.8-15,3.4-15,13.7v17.2h-3.6V309.9z" }),
                    React.createElement("path", { fill: !className && fill, d: "M523.7,327.1c0-9.8,7.7-17.8,17.6-17.8c10,0,17.6,8.1,17.6,17.8c0,9.8-7.8,17.8-17.6,17.8\n          C531.5,345,523.7,337,523.7,327.1z M555.6,327.1c0-7.9-6.3-14.4-14.2-14.4c-8,0-14.2,6.4-14.2,14.4c0,8.1,6.4,14.5,14.2,14.5\n          C549.3,341.6,555.6,335.1,555.6,327.1z" }),
                    React.createElement("path", { fill: !className && fill, d: "M566.2,330.5v-20.6h3.6v19.3c0,8.1,5.5,12.4,11.7,12.4c7.1,0,12.5-5.7,12.5-14.2v-17.5h3.6v34.5h-3.6v-7.4\n          c-2.1,4.2-6.5,7.9-13,7.9C573.2,345,566.2,339.8,566.2,330.5z" }),
                    React.createElement("path", { fill: !className && fill, d: "M606.2,309.9h3.6v7.9c2.7-4.9,7.9-8.5,14.3-8.5c9.8,0,17.4,8.1,17.4,17.8c0,10-7.7,17.8-17.4,17.8\n          c-6.4,0-11.7-3.5-14.3-8.5v21.7h-3.6V309.9z M638.1,327.1c0-7.9-6.3-14.5-14.3-14.5c-7.9,0-14.3,6.5-14.3,14.5\n          c0,8,6.3,14.5,14.3,14.5C631.7,341.6,638.1,335.3,638.1,327.1z" })),
                React.createElement("g", null,
                    React.createElement("g", null,
                        React.createElement("path", { fill: !className && fill, d: "M561.4,255.3h-17.3l24.7,20.6h14.4l-14.4-12c6.6-2.9,11.3-9.5,11.3-17.2c0-10.3-8.4-18.7-18.7-18.7h-36.1\n            v47.9h10.2v-37.7h25.9c4.7,0,8.5,3.8,8.5,8.5C569.9,251.4,566.1,255.3,561.4,255.3" })),
                    React.createElement("path", { fill: !className && fill, d: "M506.5,275.9h12.2L486.6,228h-10.8l-32.1,47.8h12.2l5.3-7.8h39.9L506.5,275.9z M467.2,259.2l14-20.4l14,20.4\n          H467.2z" }),
                    React.createElement("g", null,
                        React.createElement("g", null,
                            React.createElement("polygon", { fill: !className && fill, points: "699.2,228 699.2,263.5 664.9,228 652.9,228 652.9,275.9 663,275.9 663,240.4 697.4,275.9\n              709.4,275.9 709.4,228 \t\t\t\t\t" }))),
                    React.createElement("path", { fill: !className && fill, d: "M779.2,275.9h12.2L759.2,228h-10.8l-32.1,47.8h12.2l5.3-7.8h39.9L779.2,275.9z M739.9,259.2l14-20.4l14,20.4\n          H739.9z" }),
                    React.createElement("polygon", { fill: !className && fill, points: "641.6,237.3 641.6,228 590.7,228 590.7,275.9 641.6,275.9 641.6,266.6 600,266.6 600,255.3\n          638.7,255.3 638.7,246.8 600,246.8 600,237.3 \t\t\t" }))))));
};
const SearchBarCloseIcon = () => (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M18.7071 6.70711C19.0976 6.31658 19.0976 5.68342 18.7071 5.29289C18.3166 4.90237 17.6834 4.90237 17.2929 5.29289L12 10.5858L6.70711 5.29289C6.31658 4.90237 5.68342 4.90237 5.29289 5.29289C4.90237 5.68342 4.90237 6.31658 5.29289 6.70711L10.5858 12L5.29289 17.2929C4.90237 17.6834 4.90237 18.3166 5.29289 18.7071C5.68342 19.0976 6.31658 19.0976 6.70711 18.7071L12 13.4142L17.2929 18.7071C17.6834 19.0976 18.3166 19.0976 18.7071 18.7071C19.0976 18.3166 19.0976 17.6834 18.7071 17.2929L13.4142 12L18.7071 6.70711Z", fill: "white" })));
const ArrowUpAndDown = (props) => {
    return (React.createElement("div", { style: props.style, className: props.className },
        React.createElement("svg", { width: "10", height: "10", viewBox: "0 0 10 10", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("path", { d: "M5.00001 0L0.833344 4.16667H9.16668L5.00001 0ZM0.833344 5.83333L5.00001 10L9.16668 5.83333H0.833344Z", fill: "black" }))));
};
const GoldMedal = (props) => {
    return (React.createElement("div", { style: props.style, className: props.className },
        React.createElement("svg", { width: "22", height: "23", viewBox: "0 0 22 23", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { filter: "url(#filter0_d)" },
                React.createElement("rect", { width: "20", height: "20", rx: "10", fill: "#FFB800" })),
            React.createElement("defs", null,
                React.createElement("filter", { id: "filter0_d", x: "0", y: "0", width: "22", height: "23", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                    React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                    React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
                    React.createElement("feOffset", { dx: "1", dy: "2" }),
                    React.createElement("feGaussianBlur", { stdDeviation: "0.5" }),
                    React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }),
                    React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow" }),
                    React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow", result: "shape" }))))));
};
const SilverMedal = (props) => {
    return (React.createElement("div", { style: props.style, className: props.className },
        React.createElement("svg", { width: "22", height: "23", viewBox: "0 0 22 23", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { filter: "url(#filter0_d)" },
                React.createElement("rect", { width: "20", height: "20", rx: "10", fill: "#E3E3E3" })),
            React.createElement("defs", null,
                React.createElement("filter", { id: "filter0_d", x: "0", y: "0", width: "22", height: "23", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                    React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                    React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
                    React.createElement("feOffset", { dx: "1", dy: "2" }),
                    React.createElement("feGaussianBlur", { stdDeviation: "0.5" }),
                    React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }),
                    React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow" }),
                    React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow", result: "shape" }))))));
};
const BronzeMedal = (props) => {
    return (React.createElement("div", { style: props.style, className: props.className },
        React.createElement("svg", { width: "22", height: "23", viewBox: "0 0 22 23", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("g", { filter: "url(#filter0_d)" },
                React.createElement("rect", { width: "20", height: "20", rx: "10", fill: "#9D6A2D" })),
            React.createElement("defs", null,
                React.createElement("filter", { id: "filter0_d", x: "0", y: "0", width: "22", height: "23", filterUnits: "userSpaceOnUse", colorInterpolationFilters: "sRGB" },
                    React.createElement("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
                    React.createElement("feColorMatrix", { in: "SourceAlpha", type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" }),
                    React.createElement("feOffset", { dx: "1", dy: "2" }),
                    React.createElement("feGaussianBlur", { stdDeviation: "0.5" }),
                    React.createElement("feColorMatrix", { type: "matrix", values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" }),
                    React.createElement("feBlend", { mode: "normal", in2: "BackgroundImageFix", result: "effect1_dropShadow" }),
                    React.createElement("feBlend", { mode: "normal", in: "SourceGraphic", in2: "effect1_dropShadow", result: "shape" }))))));
};
const ProfileIcon = () => (React.createElement("svg", { width: "18", height: "20", viewBox: "0 0 18 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.31328 13.2163C3.15415 12.3655 4.29463 11.8876 5.4838 11.8876H12.6579C13.8471 11.8876 14.9875 12.3655 15.8284 13.2163C16.6693 14.067 17.1417 15.2209 17.1417 16.424V18.2386C17.1417 18.7397 16.7402 19.1459 16.2449 19.1459C15.7497 19.1459 15.3482 18.7397 15.3482 18.2386V16.424C15.3482 15.7021 15.0647 15.0098 14.5602 14.4994C14.0557 13.9889 13.3714 13.7022 12.6579 13.7022H5.4838C4.7703 13.7022 4.08601 13.9889 3.58149 14.4994C3.07696 15.0098 2.79352 15.7021 2.79352 16.424V18.2386C2.79352 18.7397 2.39203 19.1459 1.89676 19.1459C1.40149 19.1459 1 18.7397 1 18.2386V16.424C1 15.2209 1.4724 14.067 2.31328 13.2163Z", fill: "currentColor", stroke: "currentColor", strokeWidth: "0.2", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M9.07072 2.81458C7.58492 2.81458 6.38044 4.03321 6.38044 5.53646C6.38044 7.03971 7.58492 8.25833 9.07072 8.25833C10.5565 8.25833 11.761 7.03971 11.761 5.53646C11.761 4.03321 10.5565 2.81458 9.07072 2.81458ZM4.58691 5.53646C4.58691 3.03104 6.59438 1 9.07072 1C11.5471 1 13.5545 3.03104 13.5545 5.53646C13.5545 8.04187 11.5471 10.0729 9.07072 10.0729C6.59438 10.0729 4.58691 8.04187 4.58691 5.53646Z", fill: "currentColor", stroke: "currentColor", strokeWidth: "0.2", strokeLinecap: "round", strokeLinejoin: "round" })));

var LoginStep;
(function (LoginStep) {
    LoginStep[LoginStep["GetEmail"] = 0] = "GetEmail";
    LoginStep[LoginStep["SendCodeEmail"] = 1] = "SendCodeEmail";
    LoginStep[LoginStep["WaitForCode"] = 2] = "WaitForCode";
    LoginStep[LoginStep["CheckCode"] = 3] = "CheckCode";
    LoginStep[LoginStep["ClassicLogin"] = 4] = "ClassicLogin";
    LoginStep[LoginStep["SendC3LoginCredentials"] = 5] = "SendC3LoginCredentials";
    LoginStep[LoginStep["SendSalishLoginCredentials"] = 6] = "SendSalishLoginCredentials";
    LoginStep[LoginStep["GetUsername"] = 7] = "GetUsername";
    LoginStep[LoginStep["SetUsername"] = 8] = "SetUsername";
    LoginStep[LoginStep["Complete"] = 9] = "Complete";
})(LoginStep || (LoginStep = {}));
var LoginUsernameCollectionBehavior;
(function (LoginUsernameCollectionBehavior) {
    LoginUsernameCollectionBehavior[LoginUsernameCollectionBehavior["None"] = 0] = "None";
    LoginUsernameCollectionBehavior[LoginUsernameCollectionBehavior["Required"] = 1] = "Required";
    LoginUsernameCollectionBehavior[LoginUsernameCollectionBehavior["Optional"] = 2] = "Optional";
})(LoginUsernameCollectionBehavior || (LoginUsernameCollectionBehavior = {}));
var LoginCodeSource;
(function (LoginCodeSource) {
    LoginCodeSource["None"] = "None";
    LoginCodeSource["Login"] = "Login";
    LoginCodeSource["JoinFree"] = "JoinFree";
    LoginCodeSource["Subscribe"] = "Subscribe";
    LoginCodeSource["StandaloneLogin"] = "StandaloneLogin";
    LoginCodeSource["CoralLogin"] = "CoralLogin";
})(LoginCodeSource || (LoginCodeSource = {}));

var SubscriberStatus;
(function (SubscriberStatus) {
    SubscriberStatus["Active"] = "active";
    SubscriberStatus["Inactive"] = "inactive";
    SubscriberStatus["NoSub"] = "noSub";
})(SubscriberStatus || (SubscriberStatus = {}));
var SubscriptionType;
(function (SubscriptionType) {
    SubscriptionType["Free"] = "free_sub";
    SubscriptionType["InTrial"] = "trial_sub";
    SubscriptionType["Paid"] = "paid_sub";
})(SubscriptionType || (SubscriptionType = {}));

const UserEventCategory = {
    System: 0,
    User: 1,
    Stream: 2,
    Conversation: 3,
    Video: 4,
    Audio: 5,
    Sharing: 6,
    Advertisement: 7,
    Widget: 8,
    Navigation: 9
};
var UserEventTypeResponse;
(function (UserEventTypeResponse) {
    UserEventTypeResponse["View"] = "View";
    UserEventTypeResponse["Navigate"] = "Navigate";
    UserEventTypeResponse["UserRegistered"] = "UserRegistered";
    UserEventTypeResponse["RescoreUser"] = "RescoreUser";
    UserEventTypeResponse["Preview"] = "Preview";
    UserEventTypeResponse["EnteredText"] = "EnteredText";
    UserEventTypeResponse["ClearedText"] = "ClearedText";
    UserEventTypeResponse["SentMessage"] = "SentMessage";
    UserEventTypeResponse["ReadMore"] = "ReadMore";
    UserEventTypeResponse["ReadMessage"] = "ReadMessage";
    UserEventTypeResponse["Play"] = "Play";
    UserEventTypeResponse["PlayPercent"] = "PlayPercent";
    UserEventTypeResponse["PlaySeconds"] = "PlaySeconds";
    UserEventTypeResponse["JoinChannel"] = "JoinChannel";
    UserEventTypeResponse["NewQuickpost"] = "NewQuickpost";
    UserEventTypeResponse["NewStory"] = "NewStory";
    UserEventTypeResponse["NewVideoStory"] = "NewVideoStory";
    UserEventTypeResponse["LoadMore"] = "LoadMore";
    UserEventTypeResponse["CopyLinkStart"] = "CopyLinkStart";
    UserEventTypeResponse["FacebookShareStart"] = "FacebookShareStart";
    UserEventTypeResponse["TwitterShareStart"] = "TwitterShareStart";
    UserEventTypeResponse["PinterestShareStart"] = "PinterestShareStart";
    UserEventTypeResponse["CopyLinkComplete"] = "CopyLinkComplete";
    UserEventTypeResponse["FacebookShareComplete"] = "FacebookShareComplete";
    UserEventTypeResponse["TwitterShareComplete"] = "TwitterShareComplete";
    UserEventTypeResponse["PinterestShareComplete"] = "PinterestShareComplete";
    UserEventTypeResponse["LeaveChannel"] = "LeaveChannel";
    UserEventTypeResponse["Subscribe"] = "Subscribe";
    UserEventTypeResponse["ChangeSetting"] = "ChangeSetting";
    UserEventTypeResponse["UploadMedia"] = "UploadMedia";
    UserEventTypeResponse["AdCall"] = "AdCall";
    UserEventTypeResponse["AdCallSuccess"] = "AdCallSuccess";
    UserEventTypeResponse["AdCallFailure"] = "AdCallFailure";
    UserEventTypeResponse["Search"] = "Search";
    UserEventTypeResponse["UploadFailure"] = "UploadFailure";
    UserEventTypeResponse["UploadComplete"] = "UploadComplete";
    UserEventTypeResponse["UploadProgress"] = "UploadProgress";
    UserEventTypeResponse["VideoManuallyTranscoded"] = "VideoManuallyTranscoded";
    UserEventTypeResponse["TranscodeJobBegun"] = "TranscodeJobBegun";
    UserEventTypeResponse["TranscodeJobComplete"] = "TranscodeJobComplete";
    UserEventTypeResponse["TranscodeJobError"] = "TranscodeJobError";
    UserEventTypeResponse["VideoTranscodedEnoughRenderable"] = "VideoTranscodedEnoughRenderable";
    UserEventTypeResponse["TranscodeJobCritical"] = "TranscodeJobCritical";
    UserEventTypeResponse["VideoCritical"] = "VideoCritical";
    UserEventTypeResponse["GdprShown"] = "GdprShown";
    UserEventTypeResponse["GdprAccept"] = "GdprAccept";
    UserEventTypeResponse["GdprDecline"] = "GdprDecline";
    UserEventTypeResponse["VideoDownloadRequested"] = "VideoDownloadRequested";
    UserEventTypeResponse["ShufflerNext"] = "ShufflerNext";
    UserEventTypeResponse["ShufflerPrevious"] = "ShufflerPrevious";
    UserEventTypeResponse["UpdateL1Sort"] = "UpdateL1Sort";
    UserEventTypeResponse["UpdateL2Sort"] = "UpdateL2Sort";
    UserEventTypeResponse["LoginWithPassword"] = "LoginWithPassword";
    UserEventTypeResponse["LoginWithOauth"] = "LoginWithOauth";
    UserEventTypeResponse["MuidInterstitialVisitedFirst"] = "MuidInterstitialVisitedFirst";
    UserEventTypeResponse["MuidInterstitialClickContinue"] = "MuidInterstitialClickContinue";
    UserEventTypeResponse["MuidInterstitialVisitedAgain"] = "MuidInterstitialVisitedAgain";
    UserEventTypeResponse["MarkNotificationsConsumed"] = "MarkNotificationsConsumed";
    UserEventTypeResponse["WidgetLoaded"] = "WidgetLoaded";
    UserEventTypeResponse["WidgetOpened"] = "WidgetOpened";
    UserEventTypeResponse["WidgetClosed"] = "WidgetClosed";
    UserEventTypeResponse["WidgetHidden"] = "WidgetHidden";
    UserEventTypeResponse["WidgetHeightChanged"] = "WidgetHeightChanged";
    UserEventTypeResponse["LikePost"] = "LikePost";
    UserEventTypeResponse["LikeReply"] = "LikeReply";
    UserEventTypeResponse["ReportMessage"] = "ReportMessage";
    UserEventTypeResponse["StartPost"] = "StartPost";
    UserEventTypeResponse["StartReply"] = "StartReply";
})(UserEventTypeResponse || (UserEventTypeResponse = {}));
var ReactionType;
(function (ReactionType) {
    ReactionType["None"] = "None";
    ReactionType["Like"] = "Like";
    ReactionType["Laugh"] = "Laugh";
    ReactionType["Shock"] = "Shock";
})(ReactionType || (ReactionType = {}));
var ActionAuthorizationState;
(function (ActionAuthorizationState) {
    ActionAuthorizationState["Yes"] = "Yes";
    ActionAuthorizationState["No"] = "No";
    ActionAuthorizationState["Register"] = "Register";
    ActionAuthorizationState["VerifyEmail"] = "VerifyEmail";
    ActionAuthorizationState["Subscribe"] = "Subscribe";
    ActionAuthorizationState["Publisher"] = "Publisher";
    ActionAuthorizationState["Username"] = "Username";
})(ActionAuthorizationState || (ActionAuthorizationState = {}));
var AccountActionMode;
(function (AccountActionMode) {
    AccountActionMode["None"] = "None";
    AccountActionMode["Login"] = "Login";
    AccountActionMode["Register"] = "Register";
    AccountActionMode["Registered"] = "Registered";
    AccountActionMode["Username"] = "Username";
    AccountActionMode["VerifyEmail"] = "VerifyEmail";
    AccountActionMode["ForgotPassword"] = "ForgotPassword";
    AccountActionMode["ResetPassword"] = "ResetPassword";
})(AccountActionMode || (AccountActionMode = {}));
var UrlType;
(function (UrlType) {
    UrlType["Html"] = "Html";
    UrlType["Image"] = "Image";
})(UrlType || (UrlType = {}));
var Align;
(function (Align) {
    Align["Left"] = "Left";
    Align["Right"] = "Right";
    Align["Center"] = "Center";
})(Align || (Align = {}));
var ImageSize;
(function (ImageSize) {
    ImageSize["Small"] = "Small";
    ImageSize["Medium"] = "Medium";
    ImageSize["Large"] = "Large";
    ImageSize["Original"] = "Original";
})(ImageSize || (ImageSize = {}));

const logEventType = 'log-event';
const logEventHelper = ({ category, channelKey, conversationId, label, loginToken, messageId, roomKey, type, value, viewType, navigateDestination, currentLocation, typeContainerName, component }) => {
    const event = new CustomEvent(logEventType, {
        detail: {
            category,
            channelKey,
            conversationId,
            label,
            loginToken,
            messageId,
            roomKey,
            type,
            value,
            viewType,
            navigateDestination,
            currentLocation,
            typeContainerName,
            component
        }
    });
    window.dispatchEvent(event);
};

const ONE_YEAR_IN_MILLISECONDS = 31104000000;
const UserTokenCookieName$1 = 'mut';
const CoralTokenCookieName = 'mct';
class UserLoginStore {
    constructor(cookieConfig) {
        this.cookieConfig = Object.assign({ rgisName: 'RGIS' }, cookieConfig);
        const hasDocument = typeof document !== 'undefined';
        let domainValue = hasDocument ? document.domain : '';
        if (domainValue && domainValue.split('.').length > 2) {
            domainValue = domainValue.substr(domainValue.indexOf('.'));
        }
        this.opts = {
            domain: domainValue,
            encode: val => {
                return val;
            },
            expires: (cookieConfig === null || cookieConfig === void 0 ? void 0 : cookieConfig.expires) || new Date(Date.now() + ONE_YEAR_IN_MILLISECONDS),
            path: '/',
            secure: (cookieConfig === null || cookieConfig === void 0 ? void 0 : cookieConfig.secure) === false ? false : true
        };
        this.cookies = new Cookies();
    }
    setRgisCookie(rgis) {
        if (this.cookieConfig.rgisName) {
            this.cookies.set(this.cookieConfig.rgisName, JSON.stringify(rgis || ''), this.opts);
        }
    }
    setUserLogin(user) {
        const { c3RGIS: rgisCookie, userToken, coralToken } = user;
        this.setRgisCookie(rgisCookie);
        if (userToken) {
            this.cookies.set(UserTokenCookieName$1, userToken, this.opts);
        }
        if (coralToken) {
            this.setCoralToken(coralToken);
        }
        logEventHelper({
            category: UserEventCategory.User,
            value: 'userLoginCompleted'
        });
    }
    setCoralToken(coralToken) {
        if (coralToken) {
            this.cookies.set(CoralTokenCookieName, coralToken, this.opts);
        }
    }
    getRgisCookie() {
        return this.cookies.get(this.cookieConfig.rgisName);
    }
    getUserTokenCookie() {
        return this.cookies.get(UserTokenCookieName$1);
    }
    getCoralTokenCookie() {
        return this.cookies.get(CoralTokenCookieName);
    }
    removeUserLogin() {
        if (this.cookieConfig.rgisName) {
            this.cookies.remove(this.cookieConfig.rgisName, this.opts);
        }
        this.cookies.remove(UserTokenCookieName$1, this.opts);
        this.cookies.remove(CoralTokenCookieName, this.opts);
        logEventHelper({
            category: UserEventCategory.User,
            value: 'userLogoutCompleted'
        });
        window.location.hash = window.location.hash.replace(/(#|&)?viaLogin(Complete)?/g, '');
    }
}

const setItem = (key, value) => {
    if (typeof window === 'undefined') {
        return false;
    }
    try {
        localStorage.setItem(key, value);
        return true;
    }
    catch (err) {
        console.error(`Could not set localStorage key ${key}`, err);
        return false;
    }
};
const removeItem = (key) => {
    if (typeof window === 'undefined') {
        return;
    }
    localStorage.removeItem(key);
};

var NewsletterSubStatus;
(function (NewsletterSubStatus) {
    NewsletterSubStatus["STOP"] = "stop";
    NewsletterSubStatus["RECEIVE"] = "receive";
})(NewsletterSubStatus || (NewsletterSubStatus = {}));
var NewsletterEndpoint;
(function (NewsletterEndpoint) {
    NewsletterEndpoint["LIST_ALL"] = "/list";
    NewsletterEndpoint["LIST_USER_SUBSCRIPTIONS"] = "/userPreferences?filter=subscribed";
    NewsletterEndpoint["LIST_ALL_WITH_STATUSES"] = "/userPreferences?filter=all";
    NewsletterEndpoint["SUBSCRIBE_TOGGLE"] = "/subscribe";
})(NewsletterEndpoint || (NewsletterEndpoint = {}));

var caProvinces = [
	{
		name: "Alberta",
		abbreviation: "AB"
	},
	{
		name: "British Columbia",
		abbreviation: "BC"
	},
	{
		name: "Manitoba",
		abbreviation: "MB"
	},
	{
		name: "New Brunswick",
		abbreviation: "NB"
	},
	{
		name: "Newfoundland and Labrador",
		abbreviation: "NL"
	},
	{
		name: "Northwest Territories",
		abbreviation: "NT"
	},
	{
		name: "Nova Scotia",
		abbreviation: "NS"
	},
	{
		name: "Nunavut",
		abbreviation: "NU"
	},
	{
		name: "Ontario",
		abbreviation: "ON"
	},
	{
		name: "Prince Edward Island",
		abbreviation: "PE"
	},
	{
		name: "Quebec",
		abbreviation: "QC"
	},
	{
		name: "Saskatchewan",
		abbreviation: "SK"
	},
	{
		name: "Yukon",
		abbreviation: "YT"
	}
];

var countryList = [
	{
		name: "United States",
		code: "US",
		callingCode: "1"
	},
	{
		name: "Åland Islands",
		code: "AX",
		callingCode: "358 18"
	},
	{
		name: "Argentina",
		code: "AR",
		callingCode: "54"
	},
	{
		name: "Australia",
		code: "AU",
		callingCode: "61"
	},
	{
		name: "Austria",
		code: "AT",
		callingCode: "43"
	},
	{
		name: "Azores",
		code: "PT",
		callingCode: "351"
	},
	{
		name: "Belgium",
		code: "BE",
		callingCode: "32"
	},
	{
		name: "Brazil",
		code: "BR",
		callingCode: "55"
	},
	{
		name: "Bulgaria",
		code: "BG",
		callingCode: "359"
	},
	{
		name: "Canada",
		code: "CA",
		callingCode: "1"
	},
	{
		name: "Canary Islands",
		code: "IC",
		callingCode: "34"
	},
	{
		name: "Chile",
		code: "CL",
		callingCode: "56"
	},
	{
		name: "Croatia",
		code: "HR",
		callingCode: "385"
	},
	{
		name: "Cyprus",
		code: "CY",
		callingCode: "357"
	},
	{
		name: "Czech Republic",
		code: "CZ",
		callingCode: "420"
	},
	{
		name: "Denmark",
		code: "DK",
		callingCode: "45"
	},
	{
		name: "Estonia",
		code: "EE",
		callingCode: "372"
	},
	{
		name: "Faroe Islands",
		code: "FO",
		callingCode: "298"
	},
	{
		name: "Finland",
		code: "FI",
		callingCode: "358"
	},
	{
		name: "France",
		code: "FR",
		callingCode: "33"
	},
	{
		name: "French Guiana",
		code: "GF",
		callingCode: "594"
	},
	{
		name: "Germany",
		code: "DE",
		callingCode: "49"
	},
	{
		name: "Gibraltar",
		code: "GI",
		callingCode: "350"
	},
	{
		name: "Greece",
		code: "GR",
		callingCode: "30"
	},
	{
		name: "Guadeloupe",
		code: "GP",
		callingCode: "590"
	},
	{
		name: "Guernsey",
		code: "GG",
		callingCode: "44 1481"
	},
	{
		name: "Hong Kong",
		code: "HK",
		callingCode: "852"
	},
	{
		name: "Hungary",
		code: "HU",
		callingCode: "36"
	},
	{
		name: "Iceland",
		code: "IS",
		callingCode: "354"
	},
	{
		name: "India",
		code: "IN",
		callingCode: "91"
	},
	{
		name: "Indonesia",
		code: "ID",
		callingCode: "62"
	},
	{
		name: "Ireland",
		code: "IE",
		callingCode: "353"
	},
	{
		name: "Isle of Man",
		code: "IM",
		callingCode: "44 1624"
	},
	{
		name: "Israel",
		code: "IL",
		callingCode: "972"
	},
	{
		name: "Italy",
		code: "IT",
		callingCode: "39"
	},
	{
		name: "Jersey",
		code: "JE",
		callingCode: "44 1534"
	},
	{
		name: "Latvia",
		code: "LV",
		callingCode: "371"
	},
	{
		name: "Lichtenstein",
		code: "LI",
		callingCode: "423"
	},
	{
		name: "Lithuania",
		code: "LT",
		callingCode: "370"
	},
	{
		name: "Luxembourg",
		code: "LU",
		callingCode: "352"
	},
	{
		name: "Madeira",
		code: "PT",
		callingCode: "351"
	},
	{
		name: "Malaysia",
		code: "MY",
		callingCode: "60"
	},
	{
		name: "Malta",
		code: "MT",
		callingCode: "356"
	},
	{
		name: "Martinique",
		code: "MQ",
		callingCode: "596"
	},
	{
		name: "Mayotte",
		code: "YT",
		callingCode: "262 269"
	},
	{
		name: "Mexico",
		code: "MX",
		callingCode: "52"
	},
	{
		name: "Monaco",
		code: "MC",
		callingCode: "377"
	},
	{
		name: "Morocco",
		code: "MA",
		callingCode: "212"
	},
	{
		name: "Netherlands",
		code: "NL",
		callingCode: "31"
	},
	{
		name: "New Zealand",
		code: "NZ",
		callingCode: "64"
	},
	{
		name: "Norway",
		code: "NO",
		callingCode: "47"
	},
	{
		name: "Peru",
		code: "PE",
		callingCode: "51"
	},
	{
		name: "Philippines",
		code: "PH",
		callingCode: "63"
	},
	{
		name: "Poland",
		code: "PL",
		callingCode: "48"
	},
	{
		name: "Portugal",
		code: "PT",
		callingCode: "351"
	},
	{
		name: "Réunion",
		code: "RE",
		callingCode: "262"
	},
	{
		name: "Romania",
		code: "RO",
		callingCode: "40"
	},
	{
		name: "Saint Barthélemy",
		code: "BL",
		callingCode: "590"
	},
	{
		name: "Saint Martin",
		code: "MF",
		callingCode: "590"
	},
	{
		name: "Saint Pierre and Miquelon",
		code: "PM",
		callingCode: "508"
	},
	{
		name: "San Marino",
		code: "SM",
		callingCode: "378"
	},
	{
		name: "Serbia",
		code: "RS",
		callingCode: "381"
	},
	{
		name: "Singapore",
		code: "SG",
		callingCode: "65"
	},
	{
		name: "Slovakia",
		code: "SK",
		callingCode: "421"
	},
	{
		name: "Slovenia",
		code: "SI",
		callingCode: "386"
	},
	{
		name: "South Africa",
		code: "ZA",
		callingCode: "27"
	},
	{
		name: "Spain",
		code: "ES",
		callingCode: "34"
	},
	{
		name: "Sweden",
		code: "SE",
		callingCode: "46"
	},
	{
		name: "Switzerland",
		code: "CH",
		callingCode: "41"
	},
	{
		name: "Thailand",
		code: "TH",
		callingCode: "66"
	},
	{
		name: "Turkey",
		code: "TR",
		callingCode: "90"
	},
	{
		name: "United Kingdom",
		code: "GB",
		callingCode: "44"
	},
	{
		name: "Uruguay",
		code: "UY",
		callingCode: "598"
	},
	{
		name: "Vietnam",
		code: "VN",
		callingCode: "84"
	}
];

TimeAgo.addLocale(en);
new TimeAgo('en-US');
const formatIsoDate = (isoDate, locale = 'en-US', options) => {
    const date = new Date(isoDate);
    return new Intl.DateTimeFormat(locale, options !== null && options !== void 0 ? options : {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    }).format(date);
};
const formatDate = (dateToFormat) => {
    return `${dateToFormat.toLocaleString('default', {
        month: 'long'
    })} ${dateToFormat.getDate()}, ${dateToFormat.getFullYear()}`;
};
const addDays = (startDate, daysToAdd) => {
    const date = startDate;
    date.setDate(date.getDate() + daysToAdd);
    return date;
};
const addMonths = (startDate, MonthsToAdd) => {
    const date = startDate;
    date.setMonth(date.getMonth() + MonthsToAdd);
    return date;
};

var usStates = [
	{
		name: "Alabama",
		abbreviation: "AL"
	},
	{
		name: "Alaska",
		abbreviation: "AK"
	},
	{
		name: "American Samoa",
		abbreviation: "AS"
	},
	{
		name: "Arizona",
		abbreviation: "AZ"
	},
	{
		name: "Arkansas",
		abbreviation: "AR"
	},
	{
		name: "California",
		abbreviation: "CA"
	},
	{
		name: "Colorado",
		abbreviation: "CO"
	},
	{
		name: "Connecticut",
		abbreviation: "CT"
	},
	{
		name: "Delaware",
		abbreviation: "DE"
	},
	{
		name: "District Of Columbia",
		abbreviation: "DC"
	},
	{
		name: "Federated States Of Micronesia",
		abbreviation: "FM"
	},
	{
		name: "Florida",
		abbreviation: "FL"
	},
	{
		name: "Georgia",
		abbreviation: "GA"
	},
	{
		name: "Guam",
		abbreviation: "GU"
	},
	{
		name: "Hawaii",
		abbreviation: "HI"
	},
	{
		name: "Idaho",
		abbreviation: "ID"
	},
	{
		name: "Illinois",
		abbreviation: "IL"
	},
	{
		name: "Indiana",
		abbreviation: "IN"
	},
	{
		name: "Iowa",
		abbreviation: "IA"
	},
	{
		name: "Kansas",
		abbreviation: "KS"
	},
	{
		name: "Kentucky",
		abbreviation: "KY"
	},
	{
		name: "Louisiana",
		abbreviation: "LA"
	},
	{
		name: "Maine",
		abbreviation: "ME"
	},
	{
		name: "Marshall Islands",
		abbreviation: "MH"
	},
	{
		name: "Maryland",
		abbreviation: "MD"
	},
	{
		name: "Massachusetts",
		abbreviation: "MA"
	},
	{
		name: "Michigan",
		abbreviation: "MI"
	},
	{
		name: "Minnesota",
		abbreviation: "MN"
	},
	{
		name: "Mississippi",
		abbreviation: "MS"
	},
	{
		name: "Missouri",
		abbreviation: "MO"
	},
	{
		name: "Montana",
		abbreviation: "MT"
	},
	{
		name: "Nebraska",
		abbreviation: "NE"
	},
	{
		name: "Nevada",
		abbreviation: "NV"
	},
	{
		name: "New Hampshire",
		abbreviation: "NH"
	},
	{
		name: "New Jersey",
		abbreviation: "NJ"
	},
	{
		name: "New Mexico",
		abbreviation: "NM"
	},
	{
		name: "New York",
		abbreviation: "NY"
	},
	{
		name: "North Carolina",
		abbreviation: "NC"
	},
	{
		name: "North Dakota",
		abbreviation: "ND"
	},
	{
		name: "Northern Mariana Islands",
		abbreviation: "MP"
	},
	{
		name: "Ohio",
		abbreviation: "OH"
	},
	{
		name: "Oklahoma",
		abbreviation: "OK"
	},
	{
		name: "Oregon",
		abbreviation: "OR"
	},
	{
		name: "Palau",
		abbreviation: "PW"
	},
	{
		name: "Pennsylvania",
		abbreviation: "PA"
	},
	{
		name: "Puerto Rico",
		abbreviation: "PR"
	},
	{
		name: "Rhode Island",
		abbreviation: "RI"
	},
	{
		name: "South Carolina",
		abbreviation: "SC"
	},
	{
		name: "South Dakota",
		abbreviation: "SD"
	},
	{
		name: "Tennessee",
		abbreviation: "TN"
	},
	{
		name: "Texas",
		abbreviation: "TX"
	},
	{
		name: "Utah",
		abbreviation: "UT"
	},
	{
		name: "Vermont",
		abbreviation: "VT"
	},
	{
		name: "Virgin Islands",
		abbreviation: "VI"
	},
	{
		name: "Virginia",
		abbreviation: "VA"
	},
	{
		name: "Washington",
		abbreviation: "WA"
	},
	{
		name: "West Virginia",
		abbreviation: "WV"
	},
	{
		name: "Wisconsin",
		abbreviation: "WI"
	},
	{
		name: "Wyoming",
		abbreviation: "WY"
	}
];

var EAlertMedium;
(function (EAlertMedium) {
    EAlertMedium["EMail"] = "Email";
    EAlertMedium["SMS"] = "SMS";
})(EAlertMedium || (EAlertMedium = {}));
var EAlertStatus;
(function (EAlertStatus) {
    EAlertStatus["Active"] = "Active";
    EAlertStatus["Inactive"] = "Inactive";
})(EAlertStatus || (EAlertStatus = {}));
var EProductItemType;
(function (EProductItemType) {
    EProductItemType["Author"] = "Author";
    EProductItemType["Ticker"] = "Ticker";
    EProductItemType["PremiumProduct"] = "PremiumProduct";
})(EProductItemType || (EProductItemType = {}));
var FrequencyState;
(function (FrequencyState) {
    FrequencyState["Daily"] = "Daily";
    FrequencyState["RealTime"] = "Real-time";
    FrequencyState["Weekly"] = "Weekly";
})(FrequencyState || (FrequencyState = {}));
var EAlertTriggerType;
(function (EAlertTriggerType) {
    EAlertTriggerType["AllAlertTypes"] = "All alert types";
    EAlertTriggerType["FreeAlertsOnly"] = "Free alerts only";
    EAlertTriggerType["SubscriptionAlertsOnly"] = "Subscription alerts only";
})(EAlertTriggerType || (EAlertTriggerType = {}));
const EMPTY_PREMIUM_MEMBERSHIP = {
    isActive: false
};

var ePaymentMethod;
(function (ePaymentMethod) {
    ePaymentMethod["CreditCard"] = "Credit Card";
})(ePaymentMethod || (ePaymentMethod = {}));
var eStatus;
(function (eStatus) {
    eStatus["Default"] = "";
    eStatus["Submitting"] = "isSubmitting";
    eStatus["Error"] = "error";
    eStatus["Success"] = "success";
})(eStatus || (eStatus = {}));
var ePortalTabs;
(function (ePortalTabs) {
    ePortalTabs[ePortalTabs["Profile"] = 0] = "Profile";
    ePortalTabs[ePortalTabs["Email"] = 1] = "Email";
    ePortalTabs[ePortalTabs["Subscriptions"] = 2] = "Subscriptions";
    ePortalTabs[ePortalTabs["Alerts"] = 3] = "Alerts";
    ePortalTabs[ePortalTabs["Contact"] = 4] = "Contact";
})(ePortalTabs || (ePortalTabs = {}));

const UNAUTHORIZED = 'User not authorized';
const HTTP_UNAUTHORIZED = 401;
const rgisFetch = (userContext, resource, reqData) => {
    return new Promise((resolve, reject) => {
        var _a;
        let rgis = (_a = userContext === null || userContext === void 0 ? void 0 : userContext.currentUserLogin) === null || _a === void 0 ? void 0 : _a.c3RGIS;
        if (!rgis) {
            return reject(new Error(UNAUTHORIZED));
        }
        reqData = reqData || {};
        reqData.headers = reqData.headers || {};
        if (rgis.startsWith('"') && rgis.endsWith('"')) {
            rgis = rgis.slice(1, -1);
        }
        reqData.headers['x-rgis'] = rgis;
        return fetch(resource, reqData).then(resp => {
            if (resp.status === HTTP_UNAUTHORIZED) {
                return reject(new Error(UNAUTHORIZED));
            }
            return resolve(resp);
        }, reject);
    });
};
const rgisOrEmailJwtFetch = (emailJwt, userContext, resource, reqData) => {
    return new Promise((resolve, reject) => {
        var _a;
        let rgis = (_a = userContext === null || userContext === void 0 ? void 0 : userContext.currentUserLogin) === null || _a === void 0 ? void 0 : _a.c3RGIS;
        reqData = reqData || {};
        reqData.headers = reqData.headers || {};
        if (emailJwt) {
            reqData.headers['x-email-jwt'] = emailJwt;
        }
        else if (rgis) {
            if (rgis.startsWith('"') && rgis.endsWith('"')) {
                rgis = rgis.slice(1, -1);
            }
            reqData.headers['x-rgis'] = rgis;
        }
        else {
            return reject(new Error(UNAUTHORIZED));
        }
        return fetch(resource, reqData).then(resp => {
            if (resp.status === HTTP_UNAUTHORIZED) {
                return reject(new Error(UNAUTHORIZED));
            }
            return resolve(resp);
        }, reject);
    });
};
const findNewsletterPredicate = ({ id, productItemId }) => (n) => productItemId && n.productItemId ? n.productItemId === productItemId : n.id === id;
const getBrandByPlanCode = (planCode) => {
    const brandInitials = planCode.split('-')[0];
    return brandInitials.toUpperCase();
};
const PlanVariants = {
    ft: 'Free Trial',
    sp: 'Straight Paid'
};
const getVariantByPlanCode = (planCode) => {
    const planCodeSplit = planCode.split('-');
    return PlanVariants[planCodeSplit[4]];
};
const getTermByPlan = (plan) => {
    return `${plan.intervalLength} ${plan.intervalUnit}`;
};

const THE_STREET_PROPERTIES = {
    phoneNumber: '1-866-321-8726 (Outside the U.S. or in Canada, please call 1-212-321-5200)',
    supportTimeOfSite: 'Mon-Fri 9am-6pm EST'
};
const NEWSLETTER_SIGNUP_EVENT = 'newsletter-signup-event';
const DEFAULT_TERMS_AND_CONDITIONS = [
    {
        title: {
            text: '',
            decoration: 'none',
            isBold: true
        },
        contentText: 'By selecting "Subscribe Now", I agree to the Terms of Use.',
        link: {
            text: 'Terms of Use',
            value: 'https://thearenagroup.net/terms-of-use/'
        }
    },
    {
        title: {
            text: 'Automatic Renewal Policy',
            decoration: 'none',
            isBold: true
        },
        contentText: 'To ensure uninterrupted service, your Subscription will automatically renew unless you cancel prior to the renewal date. We will email a notice with your renewal price 30 days in advance if your subscription is 6 months or longer. You may cancel by calling 1-866-321-8726. Except to the extent refunds are required by law, payments are nonrefundable and there are no refunds after 30 days. However, we may, in our sole discretion, provide a refund or discount in certain cases.',
        link: {
            text: 'cancel',
            value: ''
        }
    }
];

var PermutiveAction;
(function (PermutiveAction) {
    PermutiveAction["NewsletterSignup"] = "successfulNewsletterSignup";
    PermutiveAction["PremiumSubSignup"] = "successfulPremiumSubSignup";
    PermutiveAction["NewsletterSignupAbandoned"] = "newsletterAbandoned";
    PermutiveAction["PremiumSubSignupAbandoned"] = "subProductAbandoned";
    PermutiveAction["NewsletterSubscribeToAll"] = "newsletterSubscribeAll";
    PermutiveAction["NewsletterUnsubscribe"] = "newsletterUnsubscribe";
})(PermutiveAction || (PermutiveAction = {}));
var PermutiveEventCategory;
(function (PermutiveEventCategory) {
    PermutiveEventCategory["Newsletter"] = "newsletter";
    PermutiveEventCategory["PremiumSubscription"] = "premium-subscription";
})(PermutiveEventCategory || (PermutiveEventCategory = {}));
var PermutiveTrackingType;
(function (PermutiveTrackingType) {
    PermutiveTrackingType["Subscription"] = "subscription";
})(PermutiveTrackingType || (PermutiveTrackingType = {}));
const permutiveIdentify = (email_sha256) => __awaiter(void 0, void 0, void 0, function* () {
    const { permutive } = window;
    if (!permutive)
        return;
    yield permutive.identify([
        {
            id: email_sha256,
            tag: 'email_sha256'
        }
    ]);
});
const permutiveTrack = (type, event) => __awaiter(void 0, void 0, void 0, function* () {
    const { permutive } = window;
    if (!permutive)
        return;
    const options = {
        error: (errors) => {
        }
    };
    const permutiveTrackingSchema = { type, data: event };
    yield permutive.track('Tracking', permutiveTrackingSchema, options);
});
const pushToDataLayer = (data) => {
    if (typeof window !== 'undefined') {
        const dataLayer = window.dataLayer || [];
        window.dataLayer = dataLayer;
        dataLayer.push(data);
    }
};
const sendProductImpressionToDL = (plans) => {
    if (plans.length) {
        const products = plans.map((p) => ({
            brand: getBrandByPlanCode(p.code),
            category: getTermByPlan(p),
            id: p.code,
            name: p.name,
            price: p.unitAmount,
            variant: getVariantByPlanCode(p.code),
            list: p.description
        }));
        pushToDataLayer({
            event: 'product-impression',
            ecommerce: {
                currencyCode: 'USD',
                impressions: products
            }
        });
    }
    else {
        sendErrorToDL('product-impression', 'no-plans');
    }
};
const sendProductClickToDL = (selectedPlan, planData) => {
    if (selectedPlan) {
        pushToDataLayer({
            event: 'product-click',
            ecommerce: {
                currencyCode: 'USD',
                click: {
                    actionField: {
                        list: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.description
                    },
                    products: [
                        {
                            name: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.name,
                            id: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code,
                            brand: getBrandByPlanCode((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code) || ''),
                            category: getTermByPlan(selectedPlan),
                            variant: getVariantByPlanCode((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code) || ''),
                            price: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.unitAmount,
                            position: planData.findIndex(plan => plan.code === (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code))
                        }
                    ]
                }
            }
        });
    }
    else {
        sendErrorToDL('product-click', 'no-selectedPlan');
    }
};
const sendAddToCartToDL = (selectedPlan, planData) => {
    if (selectedPlan) {
        pushToDataLayer({
            event: 'add-to-cart',
            ecommerce: {
                currencyCode: 'USD',
                add: {
                    actionField: {
                        list: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.description,
                        position: planData.findIndex(plan => plan.code === (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code))
                    },
                    products: [
                        {
                            name: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.name,
                            id: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code,
                            brand: getBrandByPlanCode((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code) || ''),
                            category: getTermByPlan(selectedPlan),
                            variant: getVariantByPlanCode((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code) || ''),
                            price: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.unitAmount,
                            quantity: 1
                        }
                    ]
                }
            }
        });
    }
    else {
        sendErrorToDL('add-to-cart', 'no-selectedPlan');
    }
};
const sendRemoveFromCartToDL = (selectedPlan) => {
    if (selectedPlan) {
        pushToDataLayer({
            event: 'remove-from-cart',
            ecommerce: {
                currencyCode: 'USD',
                remove: {
                    products: [
                        {
                            name: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.name,
                            id: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code,
                            brand: getBrandByPlanCode((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code) || ''),
                            category: getTermByPlan(selectedPlan),
                            variant: getVariantByPlanCode((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code) || ''),
                            price: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.unitAmount
                        }
                    ]
                }
            }
        });
    }
    else {
        sendErrorToDL('remove-from-cart', 'no-selectedPlan');
    }
};
const sendTransactionToDL = (selectedPlan, inv, userId, tracking) => {
    var _a, _b, _c, _d;
    if (selectedPlan) {
        const revenue = selectedPlan.unitAmount;
        const isTrial = selectedPlan.trialLength > 0;
        pushToDataLayer(Object.assign({ event: 'transaction', ecommerce: {
                currencyCode: 'USD',
                purchase: {
                    actionField: {
                        id: (_a = inv === null || inv === void 0 ? void 0 : inv.chargeInvoice) === null || _a === void 0 ? void 0 : _a.number,
                        affiliation: getBrandByPlanCode(selectedPlan.code || ''),
                        revenue: isTrial ? selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.setupFee.toFixed(2) : revenue,
                        tax: (((_c = (_b = inv === null || inv === void 0 ? void 0 : inv.chargeInvoice) === null || _b === void 0 ? void 0 : _b.taxInfo) === null || _c === void 0 ? void 0 : _c.rate) * Number(revenue)).toFixed(2)
                    },
                    products: [
                        {
                            name: selectedPlan.name,
                            id: selectedPlan.code,
                            brand: getBrandByPlanCode(selectedPlan.code || ''),
                            category: getTermByPlan(selectedPlan),
                            variant: getVariantByPlanCode(selectedPlan.code || ''),
                            price: revenue,
                            quantity: 1
                        }
                    ]
                }
            }, subscriberId: userId, isFreeTrial: isTrial && (selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.setupFee) === 0 ? 'yes' : 'no', subscriptionPlan: selectedPlan.name, subscriptionId: (_d = inv === null || inv === void 0 ? void 0 : inv.chargeInvoice) === null || _d === void 0 ? void 0 : _d.number, revenue: selectedPlan.unitAmount }, tracking));
        if (!(inv === null || inv === void 0 ? void 0 : inv.chargeInvoice)) {
            sendErrorToDL('transaction', 'no-chargeInvoice');
        }
    }
    else {
        sendErrorToDL('transaction', 'no-selectedPlan');
    }
};
const sendCheckoutToDL = (selectedPlan) => {
    if (selectedPlan) {
        pushToDataLayer({
            event: 'checkout-step',
            ecommerce: {
                currencyCode: 'USD',
                checkout: {
                    actionField: {
                        step: 1
                    },
                    products: [
                        {
                            name: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.name,
                            id: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code,
                            brand: getBrandByPlanCode((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code) || ''),
                            category: getTermByPlan(selectedPlan),
                            variant: getVariantByPlanCode((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code) || ''),
                            price: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.unitAmount,
                            quantity: 1
                        }
                    ]
                }
            }
        });
    }
    else {
        sendErrorToDL('checkout-step', 'no-selectedPlan');
    }
};
var PaymentInfoFillType;
(function (PaymentInfoFillType) {
    PaymentInfoFillType["Auto"] = "auto";
    PaymentInfoFillType["Manual"] = "manual";
    PaymentInfoFillType["Zip"] = "zip";
})(PaymentInfoFillType || (PaymentInfoFillType = {}));
const sendNewsletterSignupInfoToDL = (newsletterIds, userType = 'returning') => {
    let newsletterTrackingSession = false;
    const newsletterSignupEvent = {
        newsletterIds,
        event: NEWSLETTER_SIGNUP_EVENT,
        type: newsletterIds.length === 1 ? 'singleSubscription' : 'subscribeAll',
        userType
    };
    const newsletterTrackingSessionString = (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(NEWSLETTER_SIGNUP_EVENT)) || 'false';
    newsletterTrackingSession = JSON.parse(newsletterTrackingSessionString);
    if (!newsletterTrackingSession) {
        pushToDataLayer(newsletterSignupEvent);
        sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem(NEWSLETTER_SIGNUP_EVENT, JSON.stringify(true));
    }
};
const sendNewsletterSignupInfoWithProductItemIdsToDL = (productItemIds, userType = 'returning', placement) => {
    let newsletterTrackingSession = false;
    const newsletterSignupEvent = {
        newsletterIds: [],
        productItemIds,
        event: NEWSLETTER_SIGNUP_EVENT,
        type: productItemIds.length === 1 ? 'singleSubscription' : 'subscribeAll',
        userType,
        placement
    };
    const newsletterTrackingSessionString = (sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.getItem(NEWSLETTER_SIGNUP_EVENT)) || 'false';
    newsletterTrackingSession = JSON.parse(newsletterTrackingSessionString);
    if (!newsletterTrackingSession) {
        pushToDataLayer(newsletterSignupEvent);
        sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.setItem(NEWSLETTER_SIGNUP_EVENT, JSON.stringify(true));
    }
};
const sendPaymentInfoFillToDL = (type, subscriberId, selectedPlan) => {
    if (type) {
        pushToDataLayer({
            event: 'payment-info-fill',
            paymentInfoFillType: type,
            subscriberId,
            ecommerce: {
                currencyCode: 'USD',
                payment: {
                    products: [
                        {
                            name: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.name,
                            id: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code,
                            brand: getBrandByPlanCode((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code) || ''),
                            category: getTermByPlan(selectedPlan),
                            variant: getVariantByPlanCode((selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.code) || ''),
                            price: selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.unitAmount,
                            quantity: 1
                        }
                    ]
                }
            }
        });
    }
    else {
        sendErrorToDL('payment-info-fill', 'no-type');
    }
};
const sendSubscriberInfoToDL = (subscriberInfo, subscriberId) => {
    if (subscriberInfo) {
        pushToDataLayer({
            event: 'subscriber-info-send',
            subscriberStatus: subscriberInfo === null || subscriberInfo === void 0 ? void 0 : subscriberInfo.status,
            subscriberType: subscriberInfo === null || subscriberInfo === void 0 ? void 0 : subscriberInfo.type,
            subscriberId
        });
    }
    else {
        sendErrorToDL('subscriber-info-send', 'no-subscriberInfo');
    }
};
const sendErrorToDL = (event, error) => {
    pushToDataLayer({
        event: 'push-to-dl-error',
        pushToDlError: {
            event,
            error
        }
    });
};

const UserContext = React.createContext({
    currentUserLogin: undefined,
    updateUserLogin: userLogin => { },
    removeUserLogin: () => null,
    updateRgisCookie: rgisCookie => null
});
const UserContextProvider = ({ userCookieConfig, children }) => {
    const EmailHashesKey = 'emailHashes';
    let store = null;
    const getUserLoginFromCookies = () => {
        store = new UserLoginStore(userCookieConfig);
        const rgisCookie = store.getRgisCookie();
        const userTokenCookie = store.getUserTokenCookie();
        const coralTokenCookie = store.getCoralTokenCookie();
        let userLoginFromCookies = {};
        if (rgisCookie) {
            userLoginFromCookies.c3RGIS = rgisCookie;
        }
        if (userTokenCookie) {
            userLoginFromCookies.userToken = userTokenCookie;
        }
        if (coralTokenCookie) {
            userLoginFromCookies.coralToken = coralTokenCookie;
        }
        userLoginFromCookies = Object.keys(userLoginFromCookies).length > 0 ? userLoginFromCookies : undefined;
        return userLoginFromCookies;
    };
    const [userLogin, setUserLogin] = useState(getUserLoginFromCookies);
    const updateUserLogin = (newUserLogin, newUserResponse = {}) => {
        store = new UserLoginStore(userCookieConfig);
        store.setUserLogin(newUserLogin);
        setUserLogin(Object.assign(Object.assign({}, newUserLogin), { email: newUserResponse.email }));
        if (newUserResponse === null || newUserResponse === void 0 ? void 0 : newUserResponse.emailHashes) {
            setItem(EmailHashesKey, JSON.stringify(newUserResponse.emailHashes));
            const sha256 = newUserResponse.emailHashes.find(item => item.alg === 'sha256');
            if (sha256) {
                permutiveIdentify(sha256.digest);
            }
        }
    };
    const updateRgisCookie = (rgisCookie) => {
        if (!store) {
            store = new UserLoginStore(userCookieConfig);
        }
        store.setRgisCookie(rgisCookie);
    };
    const removeUserLogin = () => {
        store = new UserLoginStore(userCookieConfig);
        store.removeUserLogin();
        setUserLogin(undefined);
        removeItem(EmailHashesKey);
    };
    return (React.createElement(UserContext.Provider, { value: { currentUserLogin: userLogin, updateUserLogin, removeUserLogin, updateRgisCookie } }, children));
};

const SspAppContext = React.createContext({
    apiDomain: 'https://taiga-int.qamaven.com',
    refetchProfile: () => { }
});

const NewsletterContext = createContext({
    sendEmail: () => null,
    lastRunQuery: null,
    status: eStatus.Default,
    setStatus: (status) => null
});

var termsOfUseUrl = "https://thearenagroup.net/terms-of-use/";
var privacyPolicyUrl = "https://thearenagroup.net/privacy-policy/";

var SiData = [
	{
		id: 123,
		title: "SI Morning Madness",
		description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
		frequency: "Daily, starting March 15",
		logo: "https://sfgov.org/sfc/sites/default/files/Combined%20Charity/newsletter%20%281%29.jpg",
		isPremium: false,
		isFeatured: true,
		isWhitepaper: false,
		isSubscribed: true,
		productItemId: "d9a99ef6-0bcf-4902-a741-54de8a9aeee7"
	},
	{
		id: 456,
		title: "SI Daily Newsletter",
		description: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
		frequency: "Weekdays",
		logo: "https://sfgov.org/sfc/sites/default/files/Combined%20Charity/newsletter%20%281%29.jpg",
		isPremium: false,
		isFeatured: false,
		isWhitepaper: false,
		isSubscribed: false,
		productItemId: "752d9754-ade2-4c44-90bb-d3fab4ad66e9"
	},
	{
		id: 789,
		title: "SI Extra Mustard",
		description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
		frequency: "Tuesdays, Thursdays",
		logo: "https://sfgov.org/sfc/sites/default/files/Combined%20Charity/newsletter%20%281%29.jpg",
		isPremium: true,
		isFeatured: false,
		isWhitepaper: false,
		isSubscribed: false,
		productItemId: "dd03d14b-c350-49f9-af2e-5534d42a66be"
	},
	{
		id: 555,
		title: "Firehose Nonsense",
		description: "Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.",
		frequency: "Every 5 seconds",
		logo: "https://sfgov.org/sfc/sites/default/files/Combined%20Charity/newsletter%20%281%29.jpg",
		isPremium: false,
		isFeatured: true,
		isWhitepaper: false,
		isSubscribed: false,
		productItemId: "dd03d14b-c350-49f9-af2e-5534d42a66bf"
	},
	{
		id: 999,
		title: "Glacier Report",
		description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
		frequency: "Once per decade",
		logo: "https://sfgov.org/sfc/sites/default/files/Combined%20Charity/newsletter%20%281%29.jpg",
		isPremium: true,
		isFeatured: true,
		isWhitepaper: false,
		isSubscribed: true,
		productItemId: "dd03d14b-c350-49f9-af2e-5534d42a66c1"
	},
	{
		id: 364,
		title: "Morning Read Marketing Newsletter",
		description: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
		frequency: "Weekdays",
		logo: "https://sfgov.org/sfc/sites/default/files/Combined%20Charity/newsletter%20%281%29.jpg",
		isPremium: true,
		isFeatured: false,
		isWhitepaper: false,
		isSubscribed: true,
		productItemId: "52709530-d1f1-495a-b2d5-f7149d127c5c"
	}
];

var TstData = [
	{
		id: 1,
		title: "Midday Bell Newsletter",
		description: "",
		frequency: "",
		logo: "",
		isFeatured: false,
		isPremium: false,
		isWhitepaper: false,
		isSubscribed: null,
		productItemId: "77e9a5cd-f127-4451-b988-b26d128e8bf3",
		status: null
	},
	{
		id: 2,
		title: "Real Money Midday Premium Newsletter",
		description: "",
		frequency: "",
		logo: "",
		isFeatured: false,
		isPremium: true,
		isWhitepaper: false,
		isSubscribed: null,
		productItemId: "41e09b33-24ae-4d80-bc28-085033c9ed5d",
		status: null
	},
	{
		id: 4,
		title: "Winners & Losers Newsletter",
		description: "",
		frequency: "",
		logo: "",
		isFeatured: false,
		isPremium: false,
		isWhitepaper: false,
		isSubscribed: null,
		productItemId: "42f27250-6ef9-4648-8699-7cfb4fc11584",
		status: null
	},
	{
		id: 5,
		title: "Coronavirus Newsletter",
		description: "",
		frequency: "",
		logo: "",
		isFeatured: false,
		isPremium: false,
		isWhitepaper: false,
		isSubscribed: null,
		productItemId: "bc99f9a9-3467-4112-ba51-4b3f25abfeec",
		status: null
	},
	{
		id: 6,
		title: "5 Things You Must Know Before the Market Opens Newslettter",
		description: "",
		frequency: "",
		logo: "",
		isFeatured: false,
		isPremium: false,
		isWhitepaper: false,
		isSubscribed: null,
		productItemId: "b000c68f-5f8f-48b7-abeb-c201e34f58ab",
		status: null
	},
	{
		id: 7,
		title: "Jim Cramer's Daily Booyah! Newsletter",
		description: "",
		frequency: "",
		logo: "",
		isFeatured: false,
		isPremium: false,
		isWhitepaper: false,
		isSubscribed: null,
		productItemId: "a70629d7-dbd9-4f81-aa8a-3220cfacfbfe",
		status: null
	},
	{
		id: 8,
		title: "Trifecta Stocks Premium Alert",
		description: "",
		frequency: "",
		logo: "",
		isFeatured: false,
		isPremium: true,
		isWhitepaper: false,
		isSubscribed: null,
		productItemId: "6c7d8194-2fc7-4f0d-b338-4fc0555618b1",
		status: null
	},
	{
		id: 9,
		title: "Top Stocks Premium Alert",
		description: "",
		frequency: "",
		logo: "",
		isFeatured: false,
		isPremium: true,
		isWhitepaper: false,
		isSubscribed: null,
		productItemId: "ea9b7cb1-6b49-417c-acd9-4c1008edc07d",
		status: null
	},
	{
		id: 10,
		title: "TheStreet Quant Ratings Premium Alert",
		description: "",
		frequency: "",
		logo: "",
		isFeatured: false,
		isPremium: true,
		isWhitepaper: false,
		isSubscribed: null,
		productItemId: "652cc2e4-1808-40b5-a9dd-302622909c5e",
		status: null
	},
	{
		id: 11,
		title: "Stocks Under $10 Premium Alert",
		description: "",
		frequency: "",
		logo: "",
		isFeatured: false,
		isPremium: true,
		isWhitepaper: false,
		isSubscribed: null,
		productItemId: "e8123b8d-3f37-46b5-9926-12a78918937e",
		status: null
	},
	{
		id: 12,
		title: "Real Money Daily Premium Newsletter",
		description: "",
		frequency: "",
		logo: "",
		isFeatured: false,
		isPremium: true,
		isWhitepaper: false,
		isSubscribed: null,
		productItemId: "7dd837a2-137d-4116-ab34-2938a07544c5",
		status: null
	},
	{
		id: 13,
		title: "Action Alerts PLUS Premium Alert",
		description: "",
		frequency: "",
		logo: "",
		isFeatured: false,
		isPremium: true,
		isWhitepaper: false,
		isSubscribed: null,
		productItemId: "d61fb0f7-aa13-4586-a25c-d0fe6f0bdc06",
		status: null
	},
	{
		id: 15,
		title: "TheStreet Top Ten Newsletter",
		description: "",
		frequency: "",
		logo: "",
		isFeatured: false,
		isPremium: false,
		isWhitepaper: false,
		isSubscribed: null,
		productItemId: "14e8f19d-cff8-4dd2-b16d-c6129fa3b467",
		status: null
	}
];

const dialogMinHeight = 300;
const useLoginStyles = makeStyles(theme => ({
    loading: {
        width: '100%',
        minHeight: dialogMinHeight,
        display: 'inline-flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexFlow: 'column'
    },
    progressBar: {
        color: theme.palette.text.secondary
    },
    logo: {
        fill: theme.palette.text.primary
    },
    logoImg: {
        maxHeight: 25,
        maxWidth: 125
    },
    buttonGrey: {
        color: props => props.textColor,
        textTransform: 'uppercase',
        '&:hover': {
            color: props => props.textHoverColor
        }
    },
    altLoginTxt: {
        fontSize: 12,
        opacity: 0.7,
        cursor: 'pointer'
    },
    title: {
        display: 'flex',
        alignItems: 'center',
        flexFlow: 'column',
        padding: '32px 32px 0 32px',
        '& svg': {
            marginBottom: theme.spacing()
        }
    },
    mavenDialog: {
        backgroundColor: props => props.backgroundColor,
        color: props => props.textColor,
        minHeight: props => (props.loginStep === LoginStep.Complete ? 0 : dialogMinHeight),
        borderRadius: 16,
        minWidth: '288px',
        width: '375px'
    },
    label: {
        textTransform: 'uppercase',
        textAlign: 'center'
    },
    close: {
        position: 'absolute',
        top: 30,
        left: 25,
        '& path': {
            stroke: 'none'
        }
    },
    content: {
        display: 'grid',
        alignContent: 'center',
        padding: '8px 30px',
        wordBreak: 'break-word',
        overflowWrap: 'break-word'
    },
    textField: {
        color: props => props.textColor,
        borderTop: '1px solid',
        borderBottom: '1px solid',
        padding: '20px 0'
    },
    textFieldDual: {
        color: props => props.textColor,
        borderBottom: '1px solid',
        padding: '13px 0'
    },
    input: {
        color: props => props.textColor,
        '& input': {
            display: 'block',
            textAlign: 'center',
            padding: '5px 0'
        },
        '& input::placeholder': {
            display: 'block',
            textAlign: 'center'
        }
    },
    policy: {
        padding: '15px 30px 5px',
        textAlign: 'center',
        display: 'block'
    },
    actions: {
        alignSelf: 'flex-end',
        padding: '15px 20px',
        justifyContent: 'flex-end',
        marginBottom: '20px',
        '& button:disabled': {
            opacity: '.4'
        },
        '& span': {
            zIndex: 3
        }
    },
    arrow: {
        width: '18px'
    }
}));
var useLoginStyles$1 = useLoginStyles;

const claimCodeLength = 6;
const AuthCodeInputView = ({ authTheme, step, loginFlow }) => {
    const classes = useLoginStyles$1(Object.assign({}, authTheme));
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogContent, { className: classes.content },
            React.createElement(DialogContentText, { align: "center", color: "inherit" },
                "Please enter the code we sent to ",
                loginFlow.email,
                "."),
            React.createElement(DialogContentText, { align: "center" }, loginFlow.loginError && (React.createElement(Typography, { component: "span", variant: "body2", color: "error" }, loginFlow.loginError))),
            React.createElement(TextField, { autoFocus: true, className: classes.textField, InputProps: {
                    className: classes.input,
                    disableUnderline: true
                }, onChange: e => loginFlow.setClaim(e.target.value.replace(/\W/g, '')), value: loginFlow.claim, margin: "dense", id: "code", placeholder: "Code", onKeyPress: enter(step) })),
        React.createElement(DialogActions, { className: classes.actions },
            React.createElement(Button, { className: classes.buttonGrey, color: "default", onClick: step, disabled: loginFlow.claim.length !== claimCodeLength, "data-testid": "auth-code-login-btn" },
                "Login",
                React.createElement(ChevronRight$1, { className: classes.arrow, fill: authTheme === null || authTheme === void 0 ? void 0 : authTheme.textColor })))));
};
var AuthCodeInputView$1 = AuthCodeInputView;

const useStyles$6 = makeStyles$1((theme) => {
    var _a;
    return ({
        root: {
            color: ((_a = theme.palette.interactive) === null || _a === void 0 ? void 0 : _a.main) || theme.palette.text.primary,
            padding: 0,
            border: 'none',
            background: 'transparent',
            textTransform: 'none',
            verticalAlign: 'unset',
            fontSize: 'inherit',
            textAlign: 'left'
        }
    });
});
const LinkButton = props => {
    const classes = useStyles$6();
    return (React.createElement(ButtonBase, Object.assign({}, props, { className: clsx(classes.root, props === null || props === void 0 ? void 0 : props.className), disableRipple: true }), props.children));
};

const useStyles$5 = makeStyles(theme => ({
    altLoginTxt: {
        fontSize: theme.typography.pxToRem(13),
        color: theme.palette.text.hint
    }
}));
const SwapLoginButton = ({ labelTxt, setLoginStep }) => {
    const classes = useStyles$5();
    return (React.createElement(LinkButton, { onClick: setLoginStep, className: classes.altLoginTxt }, labelTxt));
};
var SwapLoginButton$1 = SwapLoginButton;

const ClassicInputView = ({ authTheme, backLabel = '< Standard login', forgotPassword, step, loginFlow }) => {
    const classes = useLoginStyles$1(Object.assign({}, authTheme));
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogContent, { className: classes.content },
            React.createElement(DialogContentText, { className: classes.label, color: "inherit" }, "Classic Login"),
            React.createElement(DialogContentText, { align: "center" }, loginFlow.loginError && (React.createElement(Typography, { component: "span", variant: "body2", color: "error" }, loginFlow.loginError))),
            React.createElement(TextField, { className: classes.textFieldDual, InputProps: {
                    className: classes.input,
                    disableUnderline: true
                }, onKeyPress: enter(step), autoFocus: true, onChange: e => loginFlow.setEmail(e.target.value), value: loginFlow.email, margin: "dense", id: "email", placeholder: "Email Address", type: "email" }),
            React.createElement(TextField, { className: classes.textFieldDual, InputProps: {
                    className: classes.input,
                    disableUnderline: true
                }, onKeyPress: enter(step), autoFocus: true, onChange: e => loginFlow.setPassword(e.target.value), value: loginFlow.password, margin: "dense", id: "password", placeholder: "Password", type: "password" }),
            forgotPassword && (React.createElement(Box, null,
                React.createElement(Typography, { className: classes.policy, align: "center", variant: "caption", color: "inherit" },
                    React.createElement(Link, { color: "inherit", href: forgotPassword, target: "_blank" }, "Forgot Password"))))),
        React.createElement(DialogActions, { className: classes.actions, style: { justifyContent: 'space-between' } },
            React.createElement(SwapLoginButton$1, { labelTxt: backLabel, setLoginStep: () => loginFlow.setLoginStep(LoginStep.GetEmail) }),
            React.createElement(Button, { className: classes.buttonGrey, onClick: step, disabled: !(loginFlow.email.length > 0 && loginFlow.password.length > 0), "data-testid": "classic-view-login-btn" },
                "Login",
                React.createElement(ChevronRight$1, { className: classes.arrow, fill: authTheme === null || authTheme === void 0 ? void 0 : authTheme.textColor })))));
};
var ClassicInputView$1 = ClassicInputView;

const useDarkButtonStyles = makeStyles({
    root: {
        textTransform: 'uppercase',
        color: 'white',
        '&:hover': {
            color: 'white'
        },
        background: 'black',
        border: 0,
        borderRadius: 3,
        height: 48,
        margin: '0 0 40px 0'
    }
});
const EmailInputView = ({ authTheme, classicSwapLabel = 'Have a password instead?', step, topLabel = 'Continue with email', loginFlow, showClassicLogin }) => {
    const classes = useLoginStyles$1(Object.assign({}, authTheme));
    const darkButtonClass = useDarkButtonStyles();
    const disableNext = () => {
        const { email } = loginFlow;
        return !(email && email.indexOf('@') > 0 && email.indexOf('@') < email.length - 1);
    };
    let showC3LoginOption = false;
    if (showClassicLogin) {
        showC3LoginOption = true;
    }
    else {
        if (typeof window !== 'undefined') {
            const domainsThatShowC3Login = ['thestreet'];
            showC3LoginOption = domainsThatShowC3Login.some(x => window.location.hostname.includes(x));
        }
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogContent, { className: classes.content },
            React.createElement(DialogContentText, { className: classes.label, color: 'inherit' }, topLabel),
            React.createElement(DialogContentText, null, loginFlow.emailError && (React.createElement(Typography, { component: "span", variant: "body2", color: "error" }, loginFlow.emailError))),
            React.createElement(TextField, { className: classes.textField, InputProps: {
                    className: classes.input,
                    disableUnderline: true
                }, onKeyPress: enter(step), autoFocus: true, onChange: e => loginFlow.setEmail(e.target.value), value: loginFlow.email, margin: "dense", id: "email", placeholder: "Email Address", type: "email" }),
            React.createElement(Box, null,
                React.createElement(Typography, { className: classes.policy, align: "center", variant: "caption" },
                    "Signing up to post comments will add you to our newsletter. By continuing you agree to The Arena Group's ",
                    React.createElement(Link, { color: "primary", href: "https://maven.io/company/pages/privacy", target: "_blank" }, "Privacy Policy"),
                    ' ',
                    "and",
                    ' ',
                    React.createElement(Link, { color: "primary", href: "https://maven.io/company/pages/terms", target: "_blank" }, "Terms of Use.")))),
        React.createElement(DialogActions, { className: classes.actions, style: showC3LoginOption ? { justifyContent: 'space-between' } : {} }, showC3LoginOption && (React.createElement(SwapLoginButton$1, { labelTxt: classicSwapLabel, setLoginStep: () => loginFlow.setLoginStep(LoginStep.ClassicLogin) }))),
        React.createElement(Typography, { align: "center" },
            React.createElement(Button, { className: darkButtonClass.root, onClick: step, disabled: disableNext(), "data-testid": "email-view-next-btn", variant: "contained" },
                "Continue",
                React.createElement(ChevronRight$1, { className: classes.arrow, fill: authTheme === null || authTheme === void 0 ? void 0 : authTheme.textColor })))));
};
var EmailInputView$1 = EmailInputView;

const LoginDialog = ({ authTheme, children, isStandalone, loading, logo, loginStep, onCancel, open, setOpen }) => {
    const classes = useLoginStyles$1(Object.assign(Object.assign({}, authTheme), { loginStep }));
    const headerLogo = logo ? (React.createElement("img", { src: logo, className: classes.logoImg })) : (React.createElement(TheArenaGroupLogo, { fill: '#D81919', className: classes.logo }));
    return (React.createElement(Dialog, { open: open, scroll: "body", classes: { paperScrollBody: classes.mavenDialog }, disableEscapeKeyDown: isStandalone },
        React.createElement(Box, null,
            !isStandalone && (React.createElement(ButtonBase, { className: classes.close, onClick: () => {
                    onCancel();
                    setOpen(false);
                } },
                React.createElement(CloseIcon, { size: RelativeSize.Large, filled: true }))),
            loading ? (React.createElement(DialogContent, { className: classes.loading },
                React.createElement(CircularProgress, { size: 48, className: classes.progressBar }))) : (React.createElement(React.Fragment, null,
                React.createElement(DialogTitle, { className: classes.title, disableTypography: true }, headerLogo),
                children)))));
};
var LoginDialog$1 = LoginDialog;

const translateNewslettersFromApi = (newsletters = []) => {
    return newsletters
        .filter(newsletter => !newsletter.isWhitepaper)
        .map(newsletter => (Object.assign(Object.assign({}, newsletter), { status: newsletter.isSubscribed ? NewsletterSubStatus.RECEIVE : NewsletterSubStatus.STOP })));
};
const useNewsletterService = ({ data, apiDomain, userContext, site = '', apiEndpoint, emailJwt, newsletterIds, productItemIds, timeout }) => {
    const [newsletters, setNewsletters] = useState(translateNewslettersFromApi(data) || []);
    const [lastRunQuery, setLastRunQuery] = useState(null);
    const [status, setStatus] = useState(eStatus.Default);
    const [submittingNewsletters, setSubmittingNewsletters] = useState([]);
    const [updateNewsletterSuccess, setUpdateNewsletterSuccess] = useState(false);
    useEffect(() => {
        var _a;
        if (!newsletters.length && apiEndpoint) {
            if (((_a = userContext.currentUserLogin) === null || _a === void 0 ? void 0 : _a.c3RGIS) || emailJwt) {
                fetchNewsletters(apiEndpoint);
            }
            else {
                fetchAllNewsletters();
            }
        }
        return () => {
            if (!updateNewsletterSuccess && newsletters.some(n => n.status === NewsletterSubStatus.STOP)) {
                permutiveTrack(PermutiveTrackingType.Subscription, {
                    action: PermutiveAction.NewsletterSignupAbandoned,
                    category: PermutiveEventCategory.Newsletter
                });
            }
        };
    }, []);
    const setNewslettersFromResponse = (newsletterData) => {
        const translatedNewsletters = translateNewslettersFromApi(newsletterData);
        if (productItemIds) {
            setNewsletters(translatedNewsletters.filter(newsletter => newsletter.productItemId && productItemIds.includes(newsletter.productItemId)));
        }
        else if (newsletterIds) {
            setNewsletters(translatedNewsletters.filter(newsletter => newsletterIds.includes(newsletter.id.toString())));
        }
        else {
            setNewsletters(translatedNewsletters);
        }
    };
    const updateNewsletter = (newsletter, value, bodyParams, placement) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        updateNewsletterLocal(newsletter, value);
        const { id, productItemId } = newsletter;
        const { correlator } = bodyParams !== null && bodyParams !== void 0 ? bodyParams : {};
        try {
            setLastRunQuery(NewsletterEndpoint.SUBSCRIBE_TOGGLE);
            setSubmittingNewsletters(submitting => [...submitting, Object.assign(Object.assign({}, newsletter), { status: eStatus.Submitting })]);
            const response = yield rgisOrEmailJwtFetch(emailJwt, userContext, `${apiDomain}/api/userProducts${NewsletterEndpoint.SUBSCRIBE_TOGGLE}`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    newsletter: id,
                    productItemId,
                    productItemType: ProductTypeTableNames.Newsletter,
                    status: value === NewsletterSubStatus.RECEIVE,
                    siteKeyword: site,
                    correlator
                })
            });
            if (response.status === 200) {
                removeNewsletterFromSubmitting(newsletter, eStatus.Success);
                setUpdateNewsletterSuccess(true);
                if (value === NewsletterSubStatus.RECEIVE) {
                    if (productItemId) {
                        sendNewsletterSignupInfoWithProductItemIdsToDL([productItemId], (_a = userContext.currentUserLogin) === null || _a === void 0 ? void 0 : _a.userType, placement);
                    }
                    else {
                        sendNewsletterSignupInfoToDL([id], (_b = userContext.currentUserLogin) === null || _b === void 0 ? void 0 : _b.userType);
                    }
                    permutiveTrack(PermutiveTrackingType.Subscription, {
                        action: PermutiveAction.NewsletterSignup,
                        category: PermutiveEventCategory.Newsletter,
                        id: productItemId !== null && productItemId !== void 0 ? productItemId : id.toString(),
                        name: newsletter.title
                    });
                }
                if (value === NewsletterSubStatus.STOP) {
                    permutiveTrack(PermutiveTrackingType.Subscription, {
                        action: PermutiveAction.NewsletterUnsubscribe,
                        category: PermutiveEventCategory.Newsletter,
                        id: productItemId !== null && productItemId !== void 0 ? productItemId : id.toString(),
                        name: newsletter === null || newsletter === void 0 ? void 0 : newsletter.title
                    });
                }
                return true;
            }
            else if (response.status >= 400) {
                throw new Error();
            }
        }
        catch (err) {
            updateNewsletterLocal(newsletter, value === NewsletterSubStatus.STOP ? NewsletterSubStatus.RECEIVE : NewsletterSubStatus.STOP);
            removeNewsletterFromSubmitting(newsletter, eStatus.Error);
            return false;
        }
    });
    const updateNewsletterLocal = (newsletter, value) => {
        const { id, productItemId } = newsletter;
        const newState = [...newsletters];
        const toChange = newState.find(findNewsletterPredicate({ id, productItemId }));
        if (toChange) {
            toChange.status = value;
            setNewsletters(newState);
        }
    };
    const removeNewsletterFromSubmitting = (newsletter, newsletterStatus) => {
        setSubmittingNewsletters(submitting => submitting.map(n => (findNewsletterPredicate(newsletter)(n) ? Object.assign(Object.assign({}, n), { status: newsletterStatus }) : n)));
        setTimeout(() => {
            setSubmittingNewsletters(submitting => [...submitting.filter(n => !findNewsletterPredicate(newsletter)(n))]);
        }, timeout || 2000);
    };
    const fetchNewsletters = (newsletterEndpoint) => __awaiter(void 0, void 0, void 0, function* () {
        setLastRunQuery(newsletterEndpoint);
        setStatus(eStatus.Submitting);
        yield rgisOrEmailJwtFetch(emailJwt, userContext, `${apiDomain}/api/subscriptions${newsletterEndpoint}&site=${site}`)
            .then((response) => __awaiter(void 0, void 0, void 0, function* () {
            if (response.status === 200) {
                setNewslettersFromResponse((yield response.json()).newsletters);
                setStatus(eStatus.Success);
            }
            else if (response.status >= 400) {
                throw new Error();
            }
        }))
            .catch(() => {
            setStatus(eStatus.Error);
        });
    });
    const fetchAllNewsletters = () => __awaiter(void 0, void 0, void 0, function* () {
        setLastRunQuery(NewsletterEndpoint.LIST_ALL);
        setStatus(eStatus.Submitting);
        yield fetch(`${apiDomain}/api/productItems?siteKeyword=${site}&type=newsletter`)
            .then((response) => __awaiter(void 0, void 0, void 0, function* () {
            if (response.status === 200) {
                const responseJson = yield response.json();
                const newsletterApiData = responseJson.map(newsletterData => ({
                    id: newsletterData.id,
                    productItemId: newsletterData.productItemId,
                    title: newsletterData.name,
                    description: newsletterData.shortDescription,
                    frequency: newsletterData.frequencyDescription,
                    logo: newsletterData.displayImageUrl,
                    isFeatured: false,
                    isPremium: newsletterData.isPremium,
                    isSubscribed: null,
                    isWhitepaper: false
                }));
                setNewslettersFromResponse(newsletterApiData);
                setStatus(eStatus.Success);
            }
            else {
                throw new Error();
            }
            return response;
        }))
            .catch(() => {
            setStatus(eStatus.Error);
        });
    });
    const toggleSubscriptionsLocal = (subscribe) => {
        setNewsletters(newsletters.map(newsletter => (Object.assign(Object.assign({}, newsletter), { status: subscribe ? NewsletterSubStatus.RECEIVE : NewsletterSubStatus.STOP }))));
    };
    return {
        status,
        setStatus,
        lastRunQuery,
        newsletters,
        fetchNewsletters,
        updateNewsletter,
        toggleSubscriptionsLocal,
        submittingNewsletters
    };
};

const useLoginFlow = (_a) => {
    var { authConfig, channelKey = 'company', userLogin: userLoginProp, taigaLoginCodeRequestProps } = _a, props = __rest(_a, ["authConfig", "channelKey", "userLogin", "taigaLoginCodeRequestProps"]);
    const [email, setEmail] = useState(props.emailJwt ? JSON.parse(atob(props.emailJwt.split('.')[1])).email : props.email || '');
    const [emailError, setEmailError] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [loginError, setLoginError] = useState('');
    const [username, setUsername] = useState('');
    const [usernameError, setUsernameError] = useState(undefined);
    const [loginStep, setLoginStep] = useState((props === null || props === void 0 ? void 0 : props.email)
        ? LoginStep.SendCodeEmail
        : (userLoginProp === null || userLoginProp === void 0 ? void 0 : userLoginProp.userToken) || (userLoginProp === null || userLoginProp === void 0 ? void 0 : userLoginProp.c3RGIS)
            ? LoginStep.GetUsername
            : LoginStep.GetEmail);
    const [loginCodeId, setLoginCodeId] = useState();
    const [claim, setClaim] = useState('');
    const [countryCode, setCountryCode] = useState('');
    const [taigaAuthState, setTaigaAuthState] = useState({ userLogin: userLoginProp });
    const [loginPropFired, setLoginPropFired] = useState(false);
    const { siteId, taigaApiBase } = taigaLoginCodeRequestProps || {};
    let { deviceType, location } = taigaLoginCodeRequestProps || {};
    let isMounted;
    if (typeof window !== 'undefined') {
        deviceType = deviceType || window.navigator.userAgent;
        location = location || window.location.href;
    }
    const tempUsernameError = validateUsername(username, taigaLoginCodeRequestProps === null || taigaLoginCodeRequestProps === void 0 ? void 0 : taigaLoginCodeRequestProps.taigaApiBase);
    if (tempUsernameError !== usernameError) {
        setUsernameError(tempUsernameError);
    }
    const handlePromiseCountryCode = (promiseCountryCode) => {
        promiseCountryCode
            .then((data) => {
            setCountryCode((data === null || data === void 0 ? void 0 : data.countryCode) || '');
        })
            .catch((err) => {
            console.error(err);
        });
    };
    const taigaCreate = () => {
        const { claimState, component = 'SyncLogin' } = taigaLoginCodeRequestProps;
        setLoading(true);
        const loginCodeEndpoint = props.baseFetchUrl
            ? props.baseFetchUrl + '/login-code'
            : `${taigaApiBase || 'https://taiga.maven.io'}/api/user/loginCode`;
        fetch$1(loginCodeEndpoint, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                email,
                siteId,
                claimState,
                deviceType,
                location,
                component
            })
        })
            .then(r => {
            return r.json().then(body => ({ status: r.status, body }));
        })
            .then(({ status, body }) => {
            var _a, _b;
            if (status === 200) {
                setLoginCodeId(body.clientCode);
                setLoginStep(LoginStep.WaitForCode);
                if (!countryCode) {
                    const promiseCountryCode = (_b = (_a = window.GdprStatus) === null || _a === void 0 ? void 0 : _a.mavenContextPromise) !== null && _b !== void 0 ? _b : fetch$1('https://uid.mavencoalition.io/v3').then(res => res.json());
                    handlePromiseCountryCode(promiseCountryCode);
                }
            }
            else {
                if ((body === null || body === void 0 ? void 0 : body.message) === 'Invalid email address') {
                    setLoginStep(LoginStep.GetEmail);
                    setEmailError('Invalid email address, please try again');
                }
                else {
                    setLoginStep(LoginStep.GetEmail);
                    setEmailError('Unknown error occurred, please try again');
                }
            }
        })
            .catch(err => {
            console.log(err);
        })
            .finally(() => setLoading(false));
    };
    const taigaClaim = () => {
        const { onLogin = response => { } } = taigaLoginCodeRequestProps;
        setLoading(true);
        const loginCodeClaimsEndpoint = props.baseFetchUrl
            ? props.baseFetchUrl + '/login-code-claims'
            : `${taigaApiBase || 'https://taiga.maven.io'}/api/user/loginCode/claim`;
        fetch$1(loginCodeClaimsEndpoint, {
            method: 'post',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                deviceType,
                clientCode: loginCodeId,
                claimShortCode: claim.replace(/\W/g, ''),
                siteKeyword: channelKey,
                countryCode
            })
        })
            .then(response => {
            if (response.ok) {
                return response.json();
            }
            else if (response.status === 403) {
                setLoginError('Invalid Code');
                setLoginStep(LoginStep.WaitForCode);
                return { isError: true };
            }
            throw new Error(response.statusText);
        })
            .then((checkCodeResp) => {
            var _a, _b, _c, _d, _e, _f, _g;
            if (checkCodeResp.isError) {
                setLoginError('Invalid Code');
                setLoginStep(LoginStep.WaitForCode);
                setLoading(false);
                return;
            }
            setClaim('');
            const tokens = {
                userToken: (_b = (_a = checkCodeResp.tokens) === null || _a === void 0 ? void 0 : _a.userToken) === null || _b === void 0 ? void 0 : _b.token,
                c3RGIS: (_c = checkCodeResp.tokens) === null || _c === void 0 ? void 0 : _c.rgis,
                coralToken: (_e = (_d = checkCodeResp.tokens) === null || _d === void 0 ? void 0 : _d.coralToken) === null || _e === void 0 ? void 0 : _e.token
            };
            const userType = checkCodeResp.operation === 'Login' ? 'returning' : 'new';
            setTaigaAuthState({ userLogin: tokens, userResponse: { emailHashes: (_f = checkCodeResp.userResponse) === null || _f === void 0 ? void 0 : _f.emailHashes } });
            onLogin(Object.assign(Object.assign({}, tokens), { userType }), checkCodeResp.userResponse);
            if (!isMounted) {
                return;
            }
            setLoginPropFired(true);
            if (props.usernameBehavior === LoginUsernameCollectionBehavior.None || ((_g = checkCodeResp.tokens) === null || _g === void 0 ? void 0 : _g.coralToken)) {
                setLoginStep(LoginStep.Complete);
            }
            else {
                setLoginStep(LoginStep.GetUsername);
            }
        })
            .catch(err => {
            console.error(err);
        })
            .finally(() => {
            if (isMounted) {
                setLoading(false);
            }
        });
    };
    const taigaSetUsername = () => {
        var _a, _b, _c, _d;
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        if ((_a = taigaAuthState === null || taigaAuthState === void 0 ? void 0 : taigaAuthState.userLogin) === null || _a === void 0 ? void 0 : _a.c3RGIS) {
            headers.append('x-rgis', (_b = taigaAuthState === null || taigaAuthState === void 0 ? void 0 : taigaAuthState.userLogin) === null || _b === void 0 ? void 0 : _b.c3RGIS);
        }
        if ((_c = taigaAuthState === null || taigaAuthState === void 0 ? void 0 : taigaAuthState.userLogin) === null || _c === void 0 ? void 0 : _c.userToken) {
            headers.append('x-user-token', (_d = taigaAuthState === null || taigaAuthState === void 0 ? void 0 : taigaAuthState.userLogin) === null || _d === void 0 ? void 0 : _d.userToken);
        }
        fetch$1(`${taigaApiBase}/api/user/displayName`, {
            method: 'put',
            headers,
            body: JSON.stringify({ displayName: username, siteId })
        })
            .then(resp => resp.json())
            .then((resp) => {
            var _a;
            setTaigaAuthState(Object.assign(Object.assign({}, taigaAuthState), { userLogin: Object.assign(Object.assign({}, taigaAuthState === null || taigaAuthState === void 0 ? void 0 : taigaAuthState.userLogin), { coralToken: (_a = resp.coralToken) === null || _a === void 0 ? void 0 : _a.token }) }));
            setLoginPropFired(false);
            setLoginStep(LoginStep.Complete);
        })
            .finally(() => setLoading(false));
    };
    const loginStepEffect = () => {
        switch (loginStep) {
            case LoginStep.SendCodeEmail:
                taigaCreate();
                break;
            case LoginStep.CheckCode:
                taigaClaim();
                break;
            case LoginStep.SendC3LoginCredentials:
                setLoading(true);
                const { onLogin = response => { } } = taigaLoginCodeRequestProps;
                const headers = new Headers();
                headers.append('Content-Type', 'application/json');
                fetch$1(`${taigaApiBase}/api/user/classicLogin`, {
                    method: 'post',
                    headers,
                    body: JSON.stringify({
                        username: email,
                        password
                    })
                })
                    .then(r => r.json())
                    .catch(() => setLoginError('Unable to login'))
                    .then(checkResp => {
                    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                    setEmail('');
                    setPassword('');
                    if (((_a = checkResp === null || checkResp === void 0 ? void 0 : checkResp.tokens) === null || _a === void 0 ? void 0 : _a.userToken) || ((_b = checkResp === null || checkResp === void 0 ? void 0 : checkResp.tokens) === null || _b === void 0 ? void 0 : _b.rgis)) {
                        const tokens = {
                            userToken: (_d = (_c = checkResp.tokens) === null || _c === void 0 ? void 0 : _c.userToken) === null || _d === void 0 ? void 0 : _d.token,
                            c3RGIS: (_e = checkResp.tokens) === null || _e === void 0 ? void 0 : _e.rgis,
                            coralToken: (_g = (_f = checkResp.tokens) === null || _f === void 0 ? void 0 : _f.coralToken) === null || _g === void 0 ? void 0 : _g.token
                        };
                        const userType = checkResp.operation === 'Login' ? 'returning' : 'new';
                        setTaigaAuthState({
                            userLogin: tokens,
                            userResponse: { emailHashes: (_h = checkResp.userResponse) === null || _h === void 0 ? void 0 : _h.emailHashes }
                        });
                        onLogin(Object.assign(Object.assign({}, tokens), { userType }), checkResp.userResponse);
                        if (props.usernameBehavior === LoginUsernameCollectionBehavior.None || ((_j = checkResp.tokens) === null || _j === void 0 ? void 0 : _j.coralToken)) {
                            setLoginStep(LoginStep.Complete);
                        }
                        else {
                            setLoginStep(LoginStep.GetUsername);
                        }
                    }
                    else {
                        setLoginError('Email/Password is invalid');
                        setLoginStep(LoginStep.ClassicLogin);
                    }
                })
                    .finally(() => setLoading(false));
                break;
            case LoginStep.SetUsername:
                taigaSetUsername();
                break;
            case LoginStep.Complete:
                if (!loginPropFired) {
                    if (taigaLoginCodeRequestProps.onLogin && (taigaAuthState === null || taigaAuthState === void 0 ? void 0 : taigaAuthState.userLogin)) {
                        taigaLoginCodeRequestProps.onLogin(taigaAuthState.userLogin, taigaAuthState.userResponse);
                        setLoginPropFired(true);
                    }
                }
                break;
        }
    };
    useEffect(() => {
        isMounted = true;
        loginStepEffect();
        return () => {
            isMounted = false;
        };
    }, [loginStep]);
    const getStepFunc = () => {
        let step = () => { };
        if (loginStep === LoginStep.GetEmail) {
            step = () => {
                const emailIsValid = isValidEmail(email);
                setEmailError(!emailIsValid ? 'Invalid email format' : '');
                if (!emailIsValid)
                    return;
                setLoginStep(LoginStep.SendCodeEmail);
            };
        }
        else if (loginStep === LoginStep.ClassicLogin) {
            step = () => {
                setLoginStep((authConfig === null || authConfig === void 0 ? void 0 : authConfig.useSalishLogin) ? LoginStep.SendSalishLoginCredentials : LoginStep.SendC3LoginCredentials);
            };
        }
        else if (loginStep === LoginStep.WaitForCode) {
            step = () => claim.length === 6 && setLoginStep(LoginStep.CheckCode);
        }
        else if (loginStep === LoginStep.GetUsername) {
            step = () => usernameError === '' && setLoginStep(LoginStep.SetUsername);
        }
        return step;
    };
    return {
        email,
        emailError,
        setEmail,
        setPassword,
        password,
        loading,
        loginError,
        loginStep,
        username,
        setUsername,
        usernameError,
        setLoginStep,
        claim,
        setClaim,
        taigaAuthState,
        stepFunc: getStepFunc()
    };
};
var useLoginFlow$1 = useLoginFlow;

var eligibleShippingCountries = [
	{
		name: "United States",
		code: "US"
	},
	{
		name: "Canada",
		code: "CA"
	}
];

var smsCountries = [
	{
		name: "United States",
		code: "US",
		callingCode: "1"
	}
];

var c3RGIS = "59607470|c2l0ZXN0dGVzdEBtYWlsaW5hdG9yLmNvbQ==-0-1613766751-52lWjrzJdjr7Siq06Qbupg==";
var emptyUserLogin = {
	c3RGIS: c3RGIS
};

var userProfile = {
	userId: "59563478",
	recurlyAccountId: "nnyjr75lu2nc",
	firstName: "Joe",
	lastName: "Shmo",
	email: "johndoe@gmail.com",
	phone: "5555555555",
	billingInfo: {
		id: "nnyjr77c5zai",
		firstName: "Paul",
		lastName: "McCartney",
		address: {
			street: "123 Penny Lane",
			city: "NY",
			country: "US",
			region: "NY",
			postalCode: "10014"
		},
		payment: {
			firstName: "Daniel",
			lastName: "DePaolo",
			cardType: "Visa",
			lastFour: "1111"
		}
	},
	invoices: [
		{
			id: "gj8v83nf932",
			number: "1072",
			state: "paid",
			total: 1415.36,
			tax: 115.37,
			createdAt: "2020-10-12T14:40:58.000Z",
			dueAt: "2020-10-12T14:40:58.000Z",
			closedAt: "2020-10-12T14:40:58.000Z",
			subscriptionId: "noxaoiihtq09"
		},
		{
			id: "4582u9578nmn",
			number: "1073",
			state: "paid",
			total: 163.3,
			tax: 13.31,
			createdAt: "2020-10-12T15:45:04.000Z",
			dueAt: "2020-10-12T15:45:04.000Z",
			closedAt: "2020-10-12T15:45:04.000Z",
			subscriptionId: "nnyjr7e6o7rd"
		}
	],
	subscriptions: [
		{
			id: "noxaoiihtq09",
			planName: "Real Money Pro Portfolio Annual Subscription",
			planCode: "tst-rmpp-a-1-sp-1299",
			state: "active",
			unitAmount: 1299.99,
			tax: 115.37,
			total: 1415.36,
			currentPeriodStartedAt: "2020-10-12T14:40:57.000Z",
			currentPeriodEndsAt: "2021-10-12T14:40:57.000Z",
			currentTermStartedAt: "2020-10-12T14:40:57.000Z",
			currentTermEndsAt: "2021-10-12T14:40:57.000Z",
			trialStartedAt: null,
			trialEndsAt: null,
			updatedAt: "2020-10-13T12:49:28.000Z",
			requireShipping: false
		},
		{
			id: "64hhr3ty3b",
			planName: "Real Money Pro Portfolio Semi-Annual Subscription",
			planCode: "tst-rmpp-a-1-sp-1299",
			state: "canceled",
			unitAmount: 1299.99,
			tax: 115.37,
			total: 1415.36,
			currentPeriodStartedAt: "2020-10-12T14:40:57.000Z",
			currentPeriodEndsAt: "2021-10-12T14:40:57.000Z",
			currentTermStartedAt: "2020-10-12T14:40:57.000Z",
			currentTermEndsAt: "2021-10-12T14:40:57.000Z",
			trialStartedAt: null,
			trialEndsAt: null,
			updatedAt: "2020-10-13T12:49:28.000Z",
			requireShipping: false
		},
		{
			id: "nnyjr7e6o7rd",
			planName: "Action Alerts PLUS Silver Annual Subscription",
			planCode: "tst-aaps-a-1-ft-149",
			state: "active",
			unitAmount: 149.99,
			tax: 13.31,
			total: 163.3,
			currentPeriodStartedAt: "2020-10-12T15:45:04.000Z",
			currentPeriodEndsAt: "2021-10-12T15:45:04.000Z",
			currentTermStartedAt: "2020-10-21T17:49:28.000Z",
			currentTermEndsAt: "2021-10-12T15:45:04.000Z",
			trialStartedAt: "2020-10-12T15:45:04.000Z",
			trialEndsAt: "2020-10-07T17:49:28.000Z",
			updatedAt: "2020-10-13T17:49:28.000Z",
			requireShipping: true,
			shippingAddress: {
				id: "452524",
				firstName: "Eddie",
				lastName: "Vedder",
				street1: "1 Who Knows St",
				street2: "",
				city: "Seattle",
				region: "WA",
				postalCode: "98136",
				country: ""
			}
		}
	],
	emailCommunication: {
		eventOffers: true,
		memberUpdate: true,
		partnerMarketing: true,
		salesCommunications: true,
		specialOffers: true
	}
};
var selfServicePortalUserProfile = {
	userProfile: userProfile
};

function getBytes() {
    try {
        return Array.from((window.crypto || window.msCrypto).getRandomValues(new Uint8Array(16)));
    }
    catch (error) {
        const ret = [];
        while (ret.length < 16) {
            ret.push((Math.random() * 256) & 0xff);
        }
        return ret;
    }
}
function m(v) {
    v = v.toString(16);
    if (v.length < 2) {
        v = '0' + v;
    }
    return v;
}
function genUUID() {
    const rnd = getBytes();
    rnd[6] = (rnd[6] & 0x0f) | 0x40;
    rnd[8] = (rnd[8] & 0x3f) | 0x80;
    const match = rnd
        .map(m)
        .join('')
        .match(/(.{8})(.{4})(.{4})(.{4})(.{12})/);
    if (!match) {
        return '';
    }
    match.shift();
    return match.join('-');
}
const uuidPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/;
function isUUID(uuid) {
    return uuidPattern.test(uuid);
}
genUUID.valid = isUUID;

const productItemApiParams = {
    name: 'test-product-item',
    productCode: 'tpi',
    productItemId: genUUID(),
    created: new Date().toDateString(),
    updated: new Date().toDateString()
};
const createProductItemApi = (params) => {
    const productItemApi = cloneDeep(productItemApiParams);
    return merge(productItemApi, params);
};
const alertApiParams = {
    itemId: genUUID(),
    productId: genUUID(),
    productItemId: genUUID(),
    type: EProductItemType.Author,
    frequency: 'Real-time',
    medium: 'Email',
    title: 'Aafia Chaudhry',
    userNotificationStatus: 'Active'
};
const createAlertApi = (params) => {
    const alertApi = cloneDeep(alertApiParams);
    return merge(alertApi, params);
};

const useMembershipStyles = makeStyles(() => ({
    root: {
        minHeight: 500,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center'
    },
    loader: {}
}));
const useStyles$4 = makeStyles(theme => ({
    root: {
        position: 'relative',
        height: props => props.viewHeight || '100%'
    },
    loader: {
        position: 'absolute',
        left: '49%',
        top: '49%'
    }
}));
const LoadingView = ({ spinnerSize, type, viewHeight }) => {
    const classes = type === 'membership' ? useMembershipStyles() : useStyles$4({ viewHeight });
    return (React.createElement(Box, { className: classes.root },
        React.createElement(CircularProgress, { size: spinnerSize, className: classes.loader })));
};

const UsernameInputView = ({ authTheme, step, usernameBehavior, loginFlow }) => {
    const classes = useLoginStyles$1(Object.assign({}, authTheme));
    const theme = useTheme();
    let adornment;
    if (loginFlow.usernameError === '') {
        adornment = (React.createElement(InputAdornment, { position: "end" },
            React.createElement(Check, { style: { color: theme.palette.success.main } })));
    }
    else if (loginFlow.usernameError) {
        adornment = (React.createElement(InputAdornment, { position: "end" },
            React.createElement(Error$1, { color: "error" })));
    }
    return (React.createElement(React.Fragment, null,
        React.createElement(DialogContent, { className: classes.content },
            React.createElement(DialogContentText, { className: classes.label, color: "inherit" }, usernameBehavior === LoginUsernameCollectionBehavior.Optional
                ? 'You can create a username now if you like, or you can do it later.'
                : 'A username is required to continue'),
            React.createElement(DialogContentText, null, loginFlow.usernameError && (React.createElement(Typography, { component: "span", variant: "body2", color: "error" }, loginFlow.usernameError))),
            React.createElement(TextField, { autoFocus: true, className: classes.textField, InputProps: {
                    endAdornment: adornment,
                    className: classes.input,
                    disableUnderline: true
                }, onChange: e => loginFlow.setUsername(e.target.value), value: loginFlow.username, margin: "dense", id: "username", placeholder: "Username", onKeyPress: enter(step) })),
        React.createElement(DialogActions, { className: classes.actions },
            usernameBehavior === LoginUsernameCollectionBehavior.Optional ? (React.createElement(Button, { className: classes.buttonGrey, onClick: () => loginFlow.setLoginStep(LoginStep.Complete) }, "Skip")) : null,
            React.createElement(Button, { className: classes.buttonGrey, disabled: Boolean(loginFlow.usernameError), onClick: step },
                "Next",
                React.createElement(ChevronRight$1, { className: classes.arrow, fill: authTheme === null || authTheme === void 0 ? void 0 : authTheme.textColor })))));
};
var UsernameInputView$1 = UsernameInputView;

const TempestContext = createContext({
    siteBasePath: undefined,
    flags: []
});
const useTempestContext = () => {
    return useContext(TempestContext);
};

const UserTokenCookieName = 'mut';
const SyncLogin = props => {
    var _a, _b, _c, _d;
    const { flags, siteBasePath } = useTempestContext();
    const [cookies] = useCookies([UserTokenCookieName]);
    if (flags.includes('use-new-sign-in')) {
        if ((!props.viaLogin && !props.viaLoginComplete && !cookies[UserTokenCookieName]) || props.isMeterLogin) {
            if (typeof window !== 'undefined') {
                window.location.href = `${window.location.origin}${siteBasePath !== null && siteBasePath !== void 0 ? siteBasePath : ''}/login?targetUrl=${encodeURIComponent(window.location.href)}`;
            }
            return React.createElement(React.Fragment, null);
        }
    }
    const userAuth = useContext(UserContext);
    const [open, setOpen] = useState(true);
    const completeReached = useRef(false);
    const captureReached = useRef(false);
    const isStandalone = Boolean(props.isStandalone);
    const authTheme = (_a = props.authConfig) === null || _a === void 0 ? void 0 : _a.authTheme;
    const dialogueForLoginStep = (loginFlow) => {
        var _a, _b;
        const { loginStep, stepFunc } = loginFlow;
        if (loginStep === LoginStep.GetEmail) {
            captureReached.current = false;
            completeReached.current = false;
            return (React.createElement(EmailInputView$1, { authTheme: authTheme, showClassicLogin: props.showClassicLogin, classicSwapLabel: props.classicLoginLabel, topLabel: props.label, step: stepFunc, loginFlow: loginFlow }));
        }
        else if (loginStep === LoginStep.ClassicLogin) {
            captureReached.current = false;
            completeReached.current = false;
            return (React.createElement(ClassicInputView$1, { authTheme: authTheme, forgotPassword: (_a = props.authConfig) === null || _a === void 0 ? void 0 : _a.forgotPassword, step: stepFunc, loginFlow: loginFlow }));
        }
        else if (loginStep === LoginStep.WaitForCode) {
            if (props.onCapture && !login.loading && !captureReached.current) {
                props.onCapture();
                captureReached.current = true;
            }
            return React.createElement(AuthCodeInputView$1, { authTheme: authTheme, step: stepFunc, loginFlow: loginFlow });
        }
        else if (loginStep === LoginStep.GetUsername) {
            completeReached.current = false;
            captureReached.current = false;
            return (React.createElement(UsernameInputView$1, { authTheme: authTheme, usernameBehavior: props.usernameBehavior, step: stepFunc, loginFlow: loginFlow }));
        }
        else if (loginStep === LoginStep.Complete) {
            setOpen(false);
            if (props.onComplete) {
                props.onComplete();
            }
            const { taigaAuthState } = loginFlow;
            const taigaOnComplete = (_b = props.taigaLoginCodeRequestProps) === null || _b === void 0 ? void 0 : _b.onComplete;
            if (taigaAuthState && taigaOnComplete) {
                taigaOnComplete(taigaAuthState.userLogin, taigaAuthState.userResponse);
            }
            return;
        }
        else {
            return null;
        }
    };
    const login = useLoginFlow$1(props);
    const hideDialog = !isStandalone && login.loginStep === LoginStep.Complete;
    if (hideDialog && login.loginStep === LoginStep.Complete && props.onComplete) {
        if (!completeReached.current) {
            props.onComplete(login, (_b = userAuth.currentUserLogin) === null || _b === void 0 ? void 0 : _b.userType);
        }
        completeReached.current = true;
    }
    return !hideDialog ? (React.createElement(LoginDialog$1, { authTheme: authTheme, open: open || isStandalone, setOpen: setOpen, isStandalone: isStandalone, loading: login.loading, logo: (_d = (_c = props.authConfig) === null || _c === void 0 ? void 0 : _c.authTheme) === null || _d === void 0 ? void 0 : _d.logo, loginStep: login.loginStep, onCancel: props.onCancel }, dialogueForLoginStep(login))) : null;
};

const fetchUserProfile = (signupContext, userContext) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b;
    const siteKeyword = (_a = signupContext.siteConfigs) === null || _a === void 0 ? void 0 : _a.config.siteKeyword;
    const endpoint = signupContext.hostName + `/api/user/profile?siteKeyword=${siteKeyword}`;
    try {
        const response = yield rgisFetch(userContext, endpoint, {
            method: 'GET',
            headers: {
                Accept: 'application/json'
            }
        });
        const data = yield response.json();
        return (_b = data === null || data === void 0 ? void 0 : data.userProfile) !== null && _b !== void 0 ? _b : undefined;
    }
    catch (err) {
        console.log('Error fetching UserProfile: ', err);
        return undefined;
    }
});
const userProfileService = {
    fetchUserProfile
};

const StyledSwitch = withStyles(theme => ({
    root: {
        width: 58,
        height: 35,
        padding: 0,
        margin: theme.spacing(1)
    },
    switchBase: {
        padding: 3,
        '&$checked': {
            transform: 'translateX(20px)',
            color: theme.palette.common.white,
            '& + $track': {
                backgroundColor: '#B0CCF1',
                opacity: 1,
                border: 'none'
            },
            '& $thumb': {
                backgroundColor: '#3E71B7',
                '&::after': {
                    color: '#FFFFFF',
                    content: '"ON"'
                }
            }
        }
    },
    thumb: {
        width: 31,
        height: 29,
        backgroundColor: '#7E7E7E',
        transition: theme.transitions.create(['background-color']),
        '&::after': {
            color: '#E0E0E0',
            content: '"OFF"',
            position: 'absolute',
            left: '50%',
            top: '50%',
            fontFamily: theme.typography.fontFamily,
            transform: 'translate(-50%, -50%)',
            fontWeight: 500,
            fontSize: 12,
            lineHeight: 14,
            transition: theme.transitions.create(['color', 'content'])
        }
    },
    track: {
        borderRadius: 35 / 2,
        backgroundColor: '#E0E0E0',
        opacity: 1,
        transition: theme.transitions.create(['background-color'])
    },
    checked: {}
}))(Switch);
const useStyles$3 = makeStyles((theme) => ({
    label: {
        color: theme.palette.text.primary,
        transition: theme.transitions.create(['color'])
    },
    disabled: {
        color: theme.palette.text.disabled
    },
    formControlLabel: {
        margin: 0
    }
}));
const SwitchButton = props => {
    const classes = useStyles$3();
    const { label, labelPlacement = 'start' } = props, switchProps = __rest(props, ["label", "labelPlacement"]);
    const [isChecked, setIsChecked] = useState(!!switchProps.checked);
    const handleChange = useCallback((event, checked) => {
        var _a;
        setIsChecked(checked);
        (_a = switchProps.onChange) === null || _a === void 0 ? void 0 : _a.call(switchProps, event, checked);
    }, []);
    useEffect(() => {
        var _a;
        setIsChecked((_a = props.checked) !== null && _a !== void 0 ? _a : false);
    }, [props.checked]);
    return (React.createElement(FormControlLabel, { labelPlacement: labelPlacement, control: React.createElement(StyledSwitch, Object.assign({}, switchProps, { checked: isChecked, onChange: handleChange })), label: React.createElement(Typography, { variant: "body1", className: clsx(classes.label, { [classes.disabled]: !isChecked }) }, label), className: classes.formControlLabel }));
};

const useStyles$2 = makeStyles((theme) => {
    const getContentColor = (props) => {
        if (props.status === eStatus.Error)
            return theme.palette.error.main;
        if (props.status === eStatus.Success)
            return theme.palette.success.main;
        return undefined;
    };
    return {
        root: {
            backgroundColor: props => getContentColor(props),
            minWidth: 100,
            '&.Mui-disabled': {
                backgroundColor: props => (props.status !== eStatus.Default ? getContentColor(props) : undefined),
                color: props => (props.status !== eStatus.Default ? theme.palette.common.white : undefined)
            }
        },
        specialContent: {
            position: 'relative',
            top: 3
        },
        svg: {
            fontSize: '1.3rem'
        }
    };
});
const LoadingButton = (_a) => {
    var { status, children } = _a, buttonProps = __rest(_a, ["status", "children"]);
    const classes = useStyles$2({ status });
    return (React.createElement(Button, Object.assign({}, buttonProps, { className: clsx(buttonProps.className, {
            [classes.root]: status !== eStatus.Default
        }) }),
        React.createElement(Box, { className: classes.btnContent },
            status !== eStatus.Default && (React.createElement(Box, { className: classes.specialContent },
                status === eStatus.Submitting && React.createElement(CircularProgress, { color: "inherit", size: 20 }),
                status === eStatus.Error && React.createElement(Error$1, { className: classes.svg, color: "error" }),
                status === eStatus.Success && React.createElement(CheckCircle, { className: classes.svg, color: "inherit" }))),
            status === eStatus.Default && children)));
};
var LoadingButton$1 = LoadingButton;

const BORDER_RADIUS = 4;
const useStyles$1 = makeStyles((theme) => ({
    root: {
        '& > button': {
            borderRadius: BORDER_RADIUS,
            border: 'none',
            padding: theme.spacing(1, 2)
        },
        '& > button:not(:first-child)': {
            marginLeft: theme.spacing(1),
            borderLeft: 'unset',
            borderTopLeftRadius: BORDER_RADIUS,
            borderBottomLeftRadius: BORDER_RADIUS
        },
        '& > button:not(:last-child)': {
            borderTopRightRadius: BORDER_RADIUS,
            borderBottomRightRadius: BORDER_RADIUS
        },
        '& > button.Mui-selected': {
            backgroundColor: theme.palette.primary.light,
            color: theme.palette.getContrastText(theme.palette.primary.light),
            '&:hover': {
                backgroundColor: lighten(theme.palette.primary.light, 0.1),
                color: theme.palette.getContrastText(theme.palette.primary.light)
            }
        },
        '& > button:not(.Mui-selected)': {
            backgroundColor: theme.palette.grey[400],
            color: theme.palette.common.white
        }
    },
    toggleButton: {
        '&.Mui-selected + &.Mui-selected': {
            marginLeft: theme.spacing(1)
        }
    },
    circularProgress: {
        margin: theme.spacing(0, 6, 0, 6),
        height: '100%'
    }
}));
const ButtonGroupToggle = ({ allowNoneSelected = false, buttons, currentValue, setValue, status, disabled }) => {
    const classes = useStyles$1();
    const onChangeValue = (e, value) => {
        if ((value && value.length) || allowNoneSelected) {
            setValue(value);
        }
    };
    return (React.createElement(ToggleButtonGroup, { value: currentValue, className: classes.root, exclusive: !Array.isArray(currentValue), onChange: onChangeValue }, status !== eStatus.Submitting ? (buttons.map(button => (React.createElement(ToggleButton, { key: button.value, className: classes.toggleButton, value: button.value, disabled: disabled }, button.content)))) : (React.createElement(Box, { className: classes.circularProgress },
        React.createElement(CircularProgress, null)))));
};

const useStylesBase = makeStyles((theme) => ({
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center'
        }
    },
    addMobileLink: {
        color: '#3E71B7',
        fontWeight: 500
    },
    alertButtonsBox: {
        gap: theme.spacing(0.5),
        [theme.breakpoints.up('sm')]: {
            gap: theme.spacing(2.5)
        }
    }
}));
const premiumProductAlertDetailStyles = makeStyles((theme) => ({
    root: {
        gap: theme.spacing(1.5)
    },
    buySubscriptionButton: {
        whiteSpace: 'nowrap',
        color: '#3E71B7',
        borderColor: '#3E71B7',
        padding: theme.spacing(1.5, 2)
    }
}));
const alertDetailStyles = makeStyles((theme) => ({
    alertButtonsContainer: {
        alignItems: 'flex-end',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(1),
        [theme.breakpoints.up('sm')]: {
            flexDirection: 'row',
            gap: theme.spacing(2.5)
        }
    },
    alertConfiguration: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        width: '100%'
    },
    alertSwitches: {
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%'
    },
    unfollowButton: {
        color: theme.palette.grey[700],
        backgroundColor: theme.palette.grey[300],
        borderRadius: 4,
        border: 'none',
        padding: theme.spacing(1.5, 2),
        '&:hover': {
            backgroundColor: lighten(theme.palette.grey[300], 0.1)
        },
        '& svg': {
            widht: 16,
            height: 16
        }
    },
    descPanel: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        marginBottom: theme.spacing(1),
        [theme.breakpoints.up('sm')]: {
            alignItems: 'flex-start',
            gap: theme.spacing(1),
            justifyContent: 'center',
            flexDirection: 'column',
            marginBottom: 0
        }
    },
    select: {
        '& .MuiInputBase-input': {
            paddingTop: theme.spacing(1.5),
            paddingBottom: theme.spacing(1.5)
        },
        '& .MuiSelect-select': {
            color: '#3E71B7',
            fontWeight: 700
        },
        height: '40px',
        marginTop: theme.spacing(1),
        width: '200px'
    },
    menuItem: {
        color: '#3E71B7'
    },
    selectGroup: {
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        [theme.breakpoints.up('lg')]: {
            gap: theme.spacing(1),
            flexDirection: 'row'
        }
    }
}));

const fromFrequencyStateEnum = (frequencyState) => {
    switch (frequencyState) {
        case FrequencyState.Daily:
            return 'Daily';
        case FrequencyState.RealTime:
            return 'Real-time';
        case FrequencyState.Weekly:
            return 'Weekly';
        default:
            return undefined;
    }
};
const toFrequencyStateEnum = (str) => {
    switch (str) {
        case 'Daily':
            return FrequencyState.Daily;
        case 'Real-time':
            return FrequencyState.RealTime;
        case 'Weekly':
            return FrequencyState.Weekly;
        default:
            return undefined;
    }
};
const displayProductItemType = (productItemType) => {
    switch (productItemType) {
        case EProductItemType.Author:
            return 'Author';
        case EProductItemType.PremiumProduct:
            return 'Premium Product';
        case EProductItemType.Ticker:
            return 'Ticker';
        default:
            return '';
    }
};
const generateAlertTriggerTypeMessageNode = (productItemName, productItemType, status) => {
    const label = React.createElement("b", null, status === eStatus.Success ? `${productItemName} |` : 'Error:');
    const successMessage = 'Alert type updated';
    const errorMessage = `${displayProductItemType(productItemType)} alert request is not responding. Refresh page and try again`;
    return (React.createElement(Typography, { align: "center", color: "textPrimary", variant: "body2" },
        label,
        " ",
        status === eStatus.Success ? successMessage : errorMessage));
};
const generateUpdateMessageNode = (productItemName, productItemType, alertMedium, activeStatus, status) => {
    const label = React.createElement("b", null, status === eStatus.Success ? `${productItemName} |` : 'Error:');
    const successMessage = `${alertMedium === EAlertMedium.EMail ? 'Emails' : 'SMS'} ${activeStatus ? 'activated' : 'paused'}`;
    const errorMessage = `${displayProductItemType(productItemType)} alert request is not responding. Refresh page and try again`;
    return (React.createElement(Typography, { align: "center", color: "textPrimary", variant: "body2" },
        label,
        " ",
        status === eStatus.Success ? successMessage : errorMessage));
};
const generateUnfollowMessageNode = (productItemName, productItemType, status) => {
    const label = React.createElement("b", null, status === eStatus.Success ? `${productItemName} |` : 'Error:');
    const message = status === eStatus.Success
        ? 'Unfollowed'
        : `Unfollow ${displayProductItemType(productItemType)} request is not responding. Refresh page and try
        again`;
    return (React.createElement(Typography, { align: "center", color: "textPrimary", variant: "body2" },
        label,
        " ",
        message));
};

const AlertDetail = props => {
    var _a, _b;
    const { name, emailAlert, productItem, productItemId, productItemType, setSnackbar, showFrequencySelect, smsAlert, updateAlert } = props;
    const [alertTriggerType, setAlertTriggerType] = useState(props.alertTriggerType || EAlertTriggerType.AllAlertTypes);
    const [emailFrequency, setEmailFrequency] = useState(emailAlert === null || emailAlert === void 0 ? void 0 : emailAlert.frequency);
    const [isEmailAlertActive, setIsEmailAlertActive] = useToggle((_a = emailAlert === null || emailAlert === void 0 ? void 0 : emailAlert.active) !== null && _a !== void 0 ? _a : false);
    const [isSmsAlertActive, setIsSmsAlertActive] = useToggle((_b = smsAlert === null || smsAlert === void 0 ? void 0 : smsAlert.active) !== null && _b !== void 0 ? _b : false);
    useEffect(() => {
        setAlertTriggerType(props.alertTriggerType || EAlertTriggerType.AllAlertTypes);
    }, [props.alertTriggerType]);
    useEffect(() => {
        setEmailFrequency(emailAlert === null || emailAlert === void 0 ? void 0 : emailAlert.frequency);
    }, [emailAlert]);
    const baseClasses = useStylesBase();
    const classes = alertDetailStyles();
    const handleAlertTriggerTypeChange = (e) => __awaiter(void 0, void 0, void 0, function* () {
        const prevAlertTriggerType = alertTriggerType;
        const newAlertTriggerType = e && e.target ? e.target.value : EAlertTriggerType.AllAlertTypes;
        setAlertTriggerType(newAlertTriggerType);
        const status = yield props.updateAlertTriggerType(newAlertTriggerType, productItem);
        const messageNode = generateAlertTriggerTypeMessageNode(name, productItemType, status);
        if (status === eStatus.Error) {
            setAlertTriggerType(prevAlertTriggerType);
        }
        setSnackbar(messageNode);
    });
    const handleEmailFrequencyChange = (e) => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        if (!showFrequencySelect || !emailAlert)
            return;
        const prevFrequencyState = emailFrequency;
        const newFrequencyState = toFrequencyStateEnum((_c = e === null || e === void 0 ? void 0 : e.target) === null || _c === void 0 ? void 0 : _c.value);
        setEmailFrequency(newFrequencyState);
        const status = yield props.updateAlert(productItem.productItemId, emailAlert.active, EAlertMedium.EMail, productItem, newFrequencyState);
        const messageNode = generateAlertTriggerTypeMessageNode(name, productItemType, status);
        if (status === eStatus.Error) {
            setEmailFrequency(prevFrequencyState);
        }
        setSnackbar(messageNode);
    });
    const handleUnfollowClick = () => __awaiter(void 0, void 0, void 0, function* () {
        const status = yield props.unfollowProductItem(productItem);
        const messageNode = generateUnfollowMessageNode(name, productItemType, status);
        setSnackbar(messageNode);
    });
    const toggleEmailAlert = (e, isActive) => __awaiter(void 0, void 0, void 0, function* () {
        setIsEmailAlertActive(isActive);
        const status = yield updateAlert(productItemId, isActive, EAlertMedium.EMail, productItem, emailFrequency);
        const messageNode = generateUpdateMessageNode(name, productItemType, EAlertMedium.EMail, isActive, status);
        if (status === eStatus.Error) {
            setIsEmailAlertActive(isEmailAlertActive);
        }
        setSnackbar(messageNode);
    });
    const toggleSmsAlert = (e, isActive) => __awaiter(void 0, void 0, void 0, function* () {
        setIsSmsAlertActive(isActive);
        const status = yield updateAlert(productItemId, isActive, EAlertMedium.SMS, productItem);
        const messageNode = generateUpdateMessageNode(name, productItemType, EAlertMedium.SMS, isActive, status);
        if (status === eStatus.Error) {
            setIsSmsAlertActive(isSmsAlertActive);
        }
        setSnackbar(messageNode);
    });
    return (React.createElement(Box, { className: baseClasses.root },
        React.createElement(Box, { className: classes.descPanel },
            React.createElement(Box, null,
                React.createElement(Typography, { variant: "body1" },
                    React.createElement("b", null, name))),
            React.createElement(Box, { className: classes.selectGroup }, props.productItemType === EProductItemType.Ticker &&
                props.showAlertTriggerTypeSelect &&
                ((emailAlert === null || emailAlert === void 0 ? void 0 : emailAlert.active) || (smsAlert === null || smsAlert === void 0 ? void 0 : smsAlert.active)) ? (React.createElement(FormControl, { variant: "outlined", className: classes.select },
                React.createElement(InputLabel, { id: "alert-type-label" }, "Type"),
                React.createElement(Select, { labelId: "alert-type-label", value: alertTriggerType, onChange: handleAlertTriggerTypeChange, label: "Type" },
                    React.createElement(MenuItem, { value: EAlertTriggerType.AllAlertTypes, className: classes.menuItem }, EAlertTriggerType.AllAlertTypes),
                    React.createElement(MenuItem, { value: EAlertTriggerType.FreeAlertsOnly, className: classes.menuItem }, EAlertTriggerType.FreeAlertsOnly),
                    React.createElement(MenuItem, { value: EAlertTriggerType.SubscriptionAlertsOnly, className: classes.menuItem }, EAlertTriggerType.SubscriptionAlertsOnly)))) : null)),
        React.createElement(Box, { className: classes.alertButtonsContainer },
            React.createElement(Box, { className: classes.alertConfiguration },
                React.createElement(Box, { className: classes.alertSwitches },
                    React.createElement(SwitchButton, { label: "Email", checked: isEmailAlertActive, onChange: toggleEmailAlert }),
                    !props.isFreeUser && !props.isMobileRegistered && (React.createElement(Link, { className: baseClasses.addMobileLink, href: "/my-account#profile", underline: "always", variant: "body1" }, "Add mobile for SMS")),
                    !props.isFreeUser && props.isMobileRegistered && (React.createElement(SwitchButton, { label: "SMS", checked: isSmsAlertActive, onChange: toggleSmsAlert }))),
                showFrequencySelect && isEmailAlertActive && (React.createElement(FormControl, { variant: "outlined", className: classes.select },
                    React.createElement(InputLabel, { id: "email-frequency-label" }, "Email Frequency"),
                    React.createElement(Select, { labelId: "email-frequency-label", value: emailFrequency, onChange: handleEmailFrequencyChange, label: "Email Alert Frequency" },
                        React.createElement(MenuItem, { value: "Daily", className: classes.menuItem }, "Daily"),
                        !props.isFreeUser && (React.createElement(MenuItem, { value: "Real-time", className: classes.menuItem }, "Real-Time")),
                        React.createElement(MenuItem, { value: "Weekly", className: classes.menuItem }, "Weekly"))))),
            React.createElement(Box, null,
                React.createElement(Button, { className: classes.unfollowButton, variant: "text", size: "large", onClick: handleUnfollowClick },
                    React.createElement(Box, { display: "flex", alignItems: "center" },
                        React.createElement(RemoveCircleOutlineIcon, null),
                        React.createElement(Typography, { variant: "body2" },
                            React.createElement("b", null, "UNFOLLOW"))))))));
};

const PremiumProductAlertDetail = props => {
    var _a, _b;
    const { emailAlert, productItem, productItemId, productItemType, setSnackbar, smsAlert, premiumMembership, name, updateAlert } = props;
    const [isEmailAlertActive, setIsEmailAlertActive] = useToggle((_a = emailAlert === null || emailAlert === void 0 ? void 0 : emailAlert.active) !== null && _a !== void 0 ? _a : false);
    const [isSmsAlertActive, setIsSmsAlertActive] = useToggle((_b = smsAlert === null || smsAlert === void 0 ? void 0 : smsAlert.active) !== null && _b !== void 0 ? _b : false);
    const landingPage = productItem === null || productItem === void 0 ? void 0 : productItem.landingPage;
    const productDescription = productItem === null || productItem === void 0 ? void 0 : productItem.description;
    const baseClasses = useStylesBase();
    const classes = premiumProductAlertDetailStyles();
    const toggleEmailAlert = (e, isActive) => __awaiter(void 0, void 0, void 0, function* () {
        setIsEmailAlertActive(isActive);
        const status = yield updateAlert(productItemId, isActive, EAlertMedium.EMail, productItem);
        const messageNode = generateUpdateMessageNode(name, productItemType, EAlertMedium.EMail, isActive, status);
        if (status === eStatus.Error) {
            setIsEmailAlertActive(isEmailAlertActive);
        }
        setSnackbar(messageNode);
    });
    const toggleSmsAlert = (e, isActive) => __awaiter(void 0, void 0, void 0, function* () {
        setIsSmsAlertActive(isActive);
        const status = yield updateAlert(productItemId, isActive, EAlertMedium.SMS, productItem);
        const messageNode = generateUpdateMessageNode(name, productItemType, EAlertMedium.SMS, isActive, status);
        if (status === eStatus.Error) {
            setIsSmsAlertActive(isSmsAlertActive);
        }
        setSnackbar(messageNode);
    });
    return (React.createElement(Box, { className: clsx(baseClasses.root, classes.root) },
        React.createElement(Box, { justifyContent: "center" },
            React.createElement(Typography, { variant: "body1" },
                React.createElement("b", null, name)),
            React.createElement(Box, { mt: 1.5 },
                React.createElement(Typography, { variant: "body1", color: "textSecondary" }, productDescription))),
        React.createElement(Box, { display: "flex", alignItems: "center", className: baseClasses.alertButtonsBox, justifyContent: premiumMembership.isActive ? 'space-between' : 'right' },
            premiumMembership.isActive && (React.createElement(Box, null,
                React.createElement(SwitchButton, { checked: isEmailAlertActive, label: "Email", onChange: toggleEmailAlert }))),
            premiumMembership.isActive && props.isMobileRegistered && (React.createElement(Box, null,
                React.createElement(SwitchButton, { checked: isSmsAlertActive, label: "SMS", onChange: toggleSmsAlert }))),
            premiumMembership.isActive && !props.isMobileRegistered && (React.createElement(Box, null,
                React.createElement(Link, { className: baseClasses.addMobileLink, href: "/my-account#profile", underline: "always", variant: "body1" }, "Add mobile for SMS"))),
            !premiumMembership.isActive && landingPage && (React.createElement(Box, null,
                React.createElement(Button, { className: classes.buySubscriptionButton, component: 'a', href: landingPage, size: "large", variant: "outlined" },
                    React.createElement(Typography, { variant: "body2" },
                        React.createElement("b", null, "BUY SUBSCRIPTION"))))))));
};

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(0.5, 0)
    },
    title: {
        fontSize: theme.typography.pxToRem(18),
        textTransform: 'uppercase',
        margin: theme.spacing(0.5, 0)
    },
    item: {
        borderBottom: `1px solid ${theme.palette.divider}`,
        padding: theme.spacing(2.5, 0),
        minHeight: 88
    },
    firstItem: {
        padding: theme.spacing(0, 0, 2.5, 0)
    }
}));
const AlertList = (props) => {
    const { isMobileRegistered, productItems, setSnackbar, title, unfollowProductItem, updateAlert, updateAlertTriggerType } = props;
    const classes = useStyles();
    return (React.createElement(Box, null,
        title && (React.createElement(Typography, { variant: "body1", color: "textPrimary", className: classes.title }, title)),
        React.createElement(List, { className: classes.root }, productItems.map((productItem, index) => (React.createElement(ListItem, { key: `${productItem.name}-${index}`, className: clsx(classes.item, index === 0 ? classes.firstItem : null) },
            productItem.type === EProductItemType.PremiumProduct && (React.createElement(PremiumProductAlertDetail, { isMobileRegistered: isMobileRegistered, name: productItem.name, productItemId: productItem.productItemId, emailAlert: productItem.email, premiumMembership: productItem.premiumMembership || EMPTY_PREMIUM_MEMBERSHIP, productItem: productItem, productItemType: productItem.type, setSnackbar: setSnackbar, smsAlert: productItem.sms, updateAlert: updateAlert })),
            (productItem.type === EProductItemType.Ticker || productItem.type === EProductItemType.Author) && (React.createElement(AlertDetail, { alertTriggerType: productItem.alertTriggerType, emailAlert: productItem.email, isFreeUser: props.isFreeUser, isMobileRegistered: isMobileRegistered, name: productItem.name, productItem: productItem, productItemId: productItem.productItemId, productItemType: productItem.type, setSnackbar: setSnackbar, showAlertTriggerTypeSelect: props.showAlertTriggerTypeSelect, showFrequencySelect: props.showFrequencySelect, smsAlert: productItem.sms, unfollowProductItem: unfollowProductItem, updateAlert: updateAlert, updateAlertTriggerType: updateAlertTriggerType }))))))));
};

const useSnackbar = () => {
    const [snackbarQueue, setSnackbarQueue] = useState([]);
    const [activeSnackbar, setActiveSnackbar] = useState(undefined);
    const [open, setOpen] = useState(false);
    useEffect(() => {
        if (snackbarQueue.length && !activeSnackbar) {
            setActiveSnackbar(Object.assign({}, snackbarQueue[0]));
            setSnackbarQueue(prev => prev.slice(1));
            setOpen(true);
        }
        else if (snackbarQueue.length && activeSnackbar && open) {
            setOpen(false);
        }
    }, [snackbarQueue, activeSnackbar, open]);
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };
    const handleExited = () => {
        setActiveSnackbar(undefined);
    };
    const setSnackbar = (message) => {
        setSnackbarQueue(prev => [...prev, { message, key: new Date().getTime() }]);
    };
    return {
        activeSnackbar,
        open,
        setSnackbar,
        handleClose,
        handleExited
    };
};
var useSnackbar$1 = useSnackbar;

const useAlertService = ({ apiDomain, emailJwt, site, siteId, siteList, userContext }) => {
    const [productItems, setProductItems] = useState([]);
    useEffect(() => {
        if (!productItems.length) {
            fetchProductItems();
        }
    }, []);
    const fetchProductItems = () => __awaiter(void 0, void 0, void 0, function* () {
        const alertsPageSites = siteList !== null && siteList !== void 0 ? siteList : [{ siteId, siteKeyword: site, siteName: '' }];
        try {
            const userPreferencesRequestPromises = alertsPageSites.map(e => {
                const resource = `${apiDomain}/api/subscriptions/userPreferences?site=${e.siteKeyword}&filter=subscribed`;
                return rgisOrEmailJwtFetch(emailJwt, userContext, resource)
                    .then(response => {
                    return response.json();
                })
                    .then(data => {
                    return Object.assign(Object.assign({}, data), { siteKeyword: e.siteKeyword, siteName: e.siteName });
                });
            });
            const followListRequestPromises = alertsPageSites.map(e => {
                const resource = `${apiDomain}/api/userProducts/${e.siteId}/followList`;
                return rgisOrEmailJwtFetch(emailJwt, userContext, resource)
                    .then(response => {
                    return response.json();
                })
                    .then(data => {
                    return data;
                });
            });
            const userPreferencesRawData = yield Promise.all(userPreferencesRequestPromises);
            const followListRawData = yield Promise.all(followListRequestPromises);
            const authors = [];
            const siteAlerts = [];
            const tickers = [];
            const followList = [];
            userPreferencesRawData.forEach(e => {
                var _a, _b, _c;
                (_a = e === null || e === void 0 ? void 0 : e.authors) === null || _a === void 0 ? void 0 : _a.forEach((a) => {
                    var _a, _b;
                    if (!((_a = a === null || a === void 0 ? void 0 : a.productItemDetail) === null || _a === void 0 ? void 0 : _a.firstName) && !((_b = a === null || a === void 0 ? void 0 : a.productItemDetail) === null || _b === void 0 ? void 0 : _b.firstName)) {
                        return;
                    }
                    a.siteKeyword = e.siteKeyword;
                    a.siteName = e.siteName;
                    authors.push(a);
                });
                (_b = e === null || e === void 0 ? void 0 : e.siteAlerts) === null || _b === void 0 ? void 0 : _b.forEach((s) => {
                    var _a;
                    if (!((_a = s === null || s === void 0 ? void 0 : s.productItemDetail) === null || _a === void 0 ? void 0 : _a.name)) {
                        return;
                    }
                    s.siteKeyword = e.siteKeyword;
                    siteAlerts.push(s);
                });
                (_c = e === null || e === void 0 ? void 0 : e.tickers) === null || _c === void 0 ? void 0 : _c.forEach((t) => {
                    var _a, _b;
                    if (!((_a = t === null || t === void 0 ? void 0 : t.productItemDetail) === null || _a === void 0 ? void 0 : _a.companyName) && !((_b = t === null || t === void 0 ? void 0 : t.productItemDetail) === null || _b === void 0 ? void 0 : _b.tickerSymbol)) {
                        return;
                    }
                    t.siteKeyword = e.siteKeyword;
                    tickers.push(t);
                });
            });
            followListRawData.forEach(e => {
                var _a;
                followList.push(...((_a = e.followList) !== null && _a !== void 0 ? _a : []));
            });
            setAuthorsFromResponse(authors, followList);
            setTickersFromResponse(tickers, followList);
            setPremiumProductsFromResponse(siteAlerts, followList);
            return eStatus.Success;
        }
        catch (e) {
            return eStatus.Error;
        }
    });
    const updateAlert = (productItemId, activeStatus, alertMedium, originalProductItem, frequency) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            setProductItems(prevProductItems => {
                return prevProductItems.map(prevProductItem => {
                    if (prevProductItem.productItemId !== productItemId) {
                        return prevProductItem;
                    }
                    const newAlert = {
                        active: activeStatus,
                        frequency,
                        medium: alertMedium,
                        productItemId: prevProductItem.productItemId
                    };
                    const newProductItem = Object.assign(Object.assign({}, prevProductItem), { email: alertMedium === EAlertMedium.EMail ? newAlert : prevProductItem.email, sms: alertMedium === EAlertMedium.SMS ? newAlert : prevProductItem.sms });
                    return newProductItem;
                });
            });
            const body = {
                activeNotifications: activeStatus,
                frequency: fromFrequencyStateEnum(frequency),
                notificationType: alertMedium === EAlertMedium.EMail ? 'Email' : 'SMS',
                productItemId,
                productItemType: fromProductItemType(originalProductItem.type),
                siteKeyword: originalProductItem.siteKeyword
            };
            const response = yield rgisOrEmailJwtFetch(emailJwt, userContext, `${apiDomain}/api/userProducts/toggleProductItemNotifications`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body)
            });
            if (!response.ok) {
                setProductItems(prevProductItems => {
                    return prevProductItems.map(prevProductItem => {
                        if (prevProductItem.productItemId !== productItemId) {
                            return prevProductItem;
                        }
                        return Object.assign({}, originalProductItem);
                    });
                });
                return eStatus.Error;
            }
            if (activeStatus &&
                originalProductItem.type === EProductItemType.Ticker &&
                originalProductItem.alertTriggerType) {
                const alertTypeBody = {
                    notificationAlertType: fromEAlertTriggerType(originalProductItem.alertTriggerType),
                    notificationType: alertMedium === EAlertMedium.EMail ? 'email' : 'SMS',
                    productItemId,
                    siteKeyword: originalProductItem.siteKeyword
                };
                const alertTypeResponse = yield rgisOrEmailJwtFetch(emailJwt, userContext, `${apiDomain}/api/userProducts/notifications`, {
                    method: 'PATCH',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(alertTypeBody)
                });
                if (!alertTypeResponse.ok) {
                    return eStatus.Error;
                }
            }
            return eStatus.Success;
        }
        catch (e) {
            setProductItems(prevProductItems => {
                return prevProductItems.map(prevProductItem => {
                    if (prevProductItem.productItemId !== productItemId) {
                        return prevProductItem;
                    }
                    return Object.assign({}, originalProductItem);
                });
            });
            return eStatus.Error;
        }
    });
    const updateAlertTriggerType = (newAlertTriggerType, originalProductItem) => __awaiter(void 0, void 0, void 0, function* () {
        const restoreFunction = (prevAlertTriggerType) => {
            setProductItems(prevProductItems => {
                return prevProductItems.map(prevProductItem => {
                    if (prevProductItem.productItemId !== originalProductItem.productItemId) {
                        return prevProductItem;
                    }
                    return Object.assign(Object.assign({}, prevProductItem), { alertTriggerType: prevAlertTriggerType });
                });
            });
        };
        const createAlertPromise = (alert) => {
            if (!alert || !alert.active) {
                const response = new Response(JSON.stringify({
                    status: 200,
                    statusText: 'OK'
                }));
                return Promise.resolve(response);
            }
            const body = {
                notificationAlertType: fromEAlertTriggerType(newAlertTriggerType),
                notificationType: alert.medium === EAlertMedium.EMail ? 'email' : 'SMS',
                productItemId: originalProductItem.productItemId,
                siteKeyword: originalProductItem.siteKeyword
            };
            return rgisOrEmailJwtFetch(emailJwt, userContext, `${apiDomain}/api/userProducts/notifications`, {
                method: 'PATCH',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body)
            });
        };
        try {
            setProductItems(prevProductItems => {
                return prevProductItems.map(prevProductItem => {
                    if (prevProductItem.productItemId !== originalProductItem.productItemId) {
                        return prevProductItem;
                    }
                    const newProductItem = Object.assign(Object.assign({}, prevProductItem), { alertTriggerType: newAlertTriggerType });
                    return newProductItem;
                });
            });
            const [emailResponse, smsResponse] = yield Promise.all([
                createAlertPromise(originalProductItem.email),
                createAlertPromise(originalProductItem.sms)
            ]);
            if (!emailResponse.ok || !smsResponse.ok) {
                restoreFunction(originalProductItem.alertTriggerType);
                return eStatus.Error;
            }
            return eStatus.Success;
        }
        catch (e) {
            restoreFunction(originalProductItem.alertTriggerType);
            return eStatus.Error;
        }
    });
    const unfollowProductItem = (originalProductItem) => __awaiter(void 0, void 0, void 0, function* () {
        let originalIndex = 0;
        try {
            setProductItems(prevProductItems => {
                return prevProductItems.filter((prevProductItem, index) => {
                    if (prevProductItem.productItemId === originalProductItem.productItemId) {
                        originalIndex = index;
                    }
                    return prevProductItem.productItemId !== originalProductItem.productItemId;
                });
            });
            const body = {
                productItemId: originalProductItem.productItemId,
                productItemType: fromProductItemType(originalProductItem.type),
                siteKeyword: originalProductItem.siteKeyword,
                status: false
            };
            const response = yield rgisOrEmailJwtFetch(emailJwt, userContext, `${apiDomain}/api/userProducts/subscribe`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(body)
            });
            if (!response.ok) {
                setProductItems(prevProductItems => {
                    const prevProductItemsCopy = [...prevProductItems];
                    prevProductItemsCopy.splice(originalIndex, 0, originalProductItem);
                    return prevProductItemsCopy;
                });
                return eStatus.Error;
            }
            return eStatus.Success;
        }
        catch (e) {
            setProductItems(prevProductItems => {
                const prevProductItemsCopy = [...prevProductItems];
                prevProductItemsCopy.splice(originalIndex, 0, originalProductItem);
                return prevProductItemsCopy;
            });
            return eStatus.Error;
        }
    });
    const setAuthorsFromResponse = (authorsApi, alertsApi) => {
        const translatedAuthors = translateAuthorsFromApi(authorsApi);
        const translatedAlerts = translateAlertsFromApi(alertsApi);
        const emailAlertsMap = new Map();
        const smsAlertsMap = new Map();
        translatedAlerts.forEach(e => {
            if (e.medium === EAlertMedium.EMail) {
                emailAlertsMap.set(e.productItemId, e);
            }
            if (e.medium === EAlertMedium.SMS) {
                smsAlertsMap.set(e.productItemId, e);
            }
        });
        translatedAuthors.forEach(e => {
            e.email = emailAlertsMap.get(e.productItemId);
            e.sms = smsAlertsMap.get(e.productItemId);
        });
        setProductItems(prevProductItems => [...prevProductItems, ...translatedAuthors]);
    };
    const setPremiumProductsFromResponse = (premiumProductsApi, alertsApi) => {
        const translatedPremiumProducts = translatePremiumProductsFromApi(premiumProductsApi);
        const translatedAlerts = translateAlertsFromApi(alertsApi);
        const emailAlertsMap = new Map();
        const smsAlertsMap = new Map();
        translatedAlerts.forEach(e => {
            if (e.medium === EAlertMedium.EMail) {
                emailAlertsMap.set(e.productItemId, e);
            }
            if (e.medium === EAlertMedium.SMS) {
                smsAlertsMap.set(e.productItemId, e);
            }
        });
        translatedPremiumProducts.forEach(e => {
            e.email = emailAlertsMap.get(e.productItemId);
            e.sms = smsAlertsMap.get(e.productItemId);
        });
        setProductItems(prevProductItems => [...prevProductItems, ...translatedPremiumProducts]);
    };
    const setTickersFromResponse = (tickersApi, alertsApi) => {
        const translatedTickers = translateTickersFromApi(tickersApi);
        const translatedAlerts = translateAlertsFromApi(alertsApi);
        const emailAlertsMap = new Map();
        const smsAlertsMap = new Map();
        translatedAlerts.forEach(e => {
            if (e.medium === EAlertMedium.EMail) {
                emailAlertsMap.set(e.productItemId, e);
            }
            if (e.medium === EAlertMedium.SMS) {
                smsAlertsMap.set(e.productItemId, e);
            }
        });
        translatedTickers.forEach(e => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j;
            e.email = emailAlertsMap.get(e.productItemId);
            e.sms = smsAlertsMap.get(e.productItemId);
            if (!((_a = e.email) === null || _a === void 0 ? void 0 : _a.active) && ((_b = e.sms) === null || _b === void 0 ? void 0 : _b.active)) {
                e.alertTriggerType = e.sms.alertTriggerType;
            }
            else if (((_c = e.email) === null || _c === void 0 ? void 0 : _c.active) && !((_d = e.sms) === null || _d === void 0 ? void 0 : _d.active)) {
                e.alertTriggerType = e.email.alertTriggerType;
            }
            else if (!((_e = e.email) === null || _e === void 0 ? void 0 : _e.active) && !((_f = e.sms) === null || _f === void 0 ? void 0 : _f.active)) {
                e.alertTriggerType = EAlertTriggerType.AllAlertTypes;
            }
            else {
                e.alertTriggerType = (_h = (_g = e.email) === null || _g === void 0 ? void 0 : _g.alertTriggerType) !== null && _h !== void 0 ? _h : (_j = e.sms) === null || _j === void 0 ? void 0 : _j.alertTriggerType;
            }
        });
        setProductItems(prevProductItems => [...prevProductItems, ...translatedTickers]);
    };
    return {
        fetchProductItems,
        updateAlert,
        updateAlertTriggerType,
        productItems,
        unfollowProductItem
    };
};
const fromProductItemType = (productItemType) => {
    switch (productItemType) {
        case EProductItemType.Author:
            return 'author';
        case EProductItemType.PremiumProduct:
            return 'site_alert';
        case EProductItemType.Ticker:
            return 'ticker';
        default:
            return '';
    }
};
const fromEAlertTriggerType = (alertTriggerType) => {
    switch (alertTriggerType) {
        case EAlertTriggerType.AllAlertTypes:
            return 'all';
        case EAlertTriggerType.FreeAlertsOnly:
            return 'free';
        case EAlertTriggerType.SubscriptionAlertsOnly:
            return 'premium';
        default:
            return 'all';
    }
};
const toEAlertTriggerType = (str) => {
    switch (str) {
        case 'all':
            return EAlertTriggerType.AllAlertTypes;
        case 'free':
            return EAlertTriggerType.FreeAlertsOnly;
        case 'premium':
            return EAlertTriggerType.SubscriptionAlertsOnly;
        default:
            return EAlertTriggerType.AllAlertTypes;
    }
};
const translateAlertsFromApi = (alertsApi) => {
    return alertsApi
        .filter(e => {
        var _a, _b;
        const medium = (_b = (_a = e.medium) === null || _a === void 0 ? void 0 : _a.toUpperCase) === null || _b === void 0 ? void 0 : _b.call(_a);
        return medium === 'EMAIL' || medium === 'SMS';
    })
        .map((e) => {
        var _a, _b;
        return {
            active: e.userNotificationStatus === 'Active',
            alertTriggerType: toEAlertTriggerType(e.userNotificationAlertType),
            frequency: toFrequencyStateEnum(e.frequency),
            medium: ((_b = (_a = e.medium) === null || _a === void 0 ? void 0 : _a.toUpperCase) === null || _b === void 0 ? void 0 : _b.call(_a)) === 'EMAIL' ? EAlertMedium.EMail : EAlertMedium.SMS,
            productItemId: e.productItemId || ''
        };
    });
};
const translateAuthorsFromApi = (authorsApi) => {
    return authorsApi.map((e) => {
        const productItemDetail = e.productItemDetail || {};
        const authorName = `${productItemDetail.firstName} ${productItemDetail.lastName}`;
        return {
            siteKeyword: e.siteKeyword,
            type: EProductItemType.Author,
            name: `${authorName}${e.siteName ? ` (${e.siteName})` : ''}`,
            productItemId: e.productItemId || ''
        };
    });
};
const translateTickersFromApi = (tickersApi) => {
    return tickersApi.map((e) => {
        const productItemDetail = e.productItemDetail || {};
        const tickerName = `${productItemDetail.tickerSymbol} ${productItemDetail.companyName}`;
        return {
            type: EProductItemType.Ticker,
            name: tickerName,
            productItemId: e.productItemId || '',
            siteKeyword: e.siteKeyword
        };
    });
};
const translatePremiumProductsFromApi = (premiumProductsApi) => {
    return premiumProductsApi.map((e) => {
        var _a, _b;
        const productItemDetail = e.productItemDetail || {};
        const isSomePlanActive = (_b = (_a = e.premiumMembership) === null || _a === void 0 ? void 0 : _a.plan) === null || _b === void 0 ? void 0 : _b.some(p => {
            return p.subscriberStatus === 'active' || p.subscriberStatus === 'canceled';
        });
        return {
            name: productItemDetail.name || '',
            premiumMembership: {
                isActive: isSomePlanActive !== null && isSomePlanActive !== void 0 ? isSomePlanActive : false
            },
            productCode: productItemDetail.productCode || '',
            productItemId: e.productItemId || '',
            type: EProductItemType.PremiumProduct,
            siteKeyword: e.siteKeyword
        };
    });
};

var ctaHeadline = "Learn How to Set Your Portfolio up for Success with TheStreet Pro!";
var ctaUrl = "https://subscriptions.thestreet.com/get-thestreet-pro?placement=wp-confirmation";
var ctaMessage = "Become a TheStreet Pro member to learn from the pros how to invest wisely and build a customized portfolio of blue chip stocks.";

var tstText = {
	disclaimers: {
		renewal: {
			label: "Automatic Renewal Policy",
			text: "To ensure uninterrupted service, your subscription will automatically renew unless you cancel prior to the renewal date. We will email a notice with your renewal price 30 days in advance if your subscription is 6 months or longer. You may cancel by calling 1-866-321-8726. Except to the extent refunds are required by law, payments are nonrefundable and there are no refunds after 30 days. However, we may, in our sole discretion, provide a refund or discount in certain cases."
		}
	}
};
var offerText = {
	tstText: tstText
};

const BUTTON_DEFAULT_STATUS_TIMEOUT = 3500;
const MESSAGE_DEFAULT_STATUS_TIMEOUT = 7000;
const extractPropertiesFromPlanCode = (planCode) => {
    let PlanCodeItemIndex;
    (function (PlanCodeItemIndex) {
        PlanCodeItemIndex[PlanCodeItemIndex["SiteCode"] = 0] = "SiteCode";
        PlanCodeItemIndex[PlanCodeItemIndex["ProductCode"] = 1] = "ProductCode";
        PlanCodeItemIndex[PlanCodeItemIndex["Term"] = 2] = "Term";
        PlanCodeItemIndex[PlanCodeItemIndex["BillingPeriodCount"] = 3] = "BillingPeriodCount";
        PlanCodeItemIndex[PlanCodeItemIndex["TrialStraightPay"] = 4] = "TrialStraightPay";
        PlanCodeItemIndex[PlanCodeItemIndex["Price"] = 5] = "Price";
        PlanCodeItemIndex[PlanCodeItemIndex["SalishChannelKey"] = 6] = "SalishChannelKey";
    })(PlanCodeItemIndex || (PlanCodeItemIndex = {}));
    const properties = {};
    if (!planCode) {
        return properties;
    }
    const split = planCode.split('-');
    if (split.length > PlanCodeItemIndex.SiteCode) {
        properties.siteCode = split[PlanCodeItemIndex.SiteCode].toUpperCase();
        switch (properties.siteCode) {
            case 'TST':
                properties.siteKeyword = 'thestreet';
                break;
            case 'PAR':
                properties.siteKeyword = 'parade';
                break;
            case 'WM':
                properties.siteKeyword = 'warriormaven';
                break;
            case 'RTP':
                properties.siteKeyword = 'roundtable';
                break;
            case 'SRT':
                properties.siteKeyword = 'crypto';
                break;
            default:
                properties.siteKeyword = 'thestreet';
                break;
        }
    }
    if (split.length > PlanCodeItemIndex.ProductCode) {
        properties.productCode = split[PlanCodeItemIndex.ProductCode];
    }
    if (split.length > PlanCodeItemIndex.Term) {
        properties.term = split[PlanCodeItemIndex.Term];
    }
    if (split.length > PlanCodeItemIndex.BillingPeriodCount) {
        properties.billingPeriodCount = +split[PlanCodeItemIndex.BillingPeriodCount];
    }
    if (split.length > PlanCodeItemIndex.TrialStraightPay) {
        properties.trialOrStraightPaid = split[PlanCodeItemIndex.TrialStraightPay];
    }
    if (split.length > PlanCodeItemIndex.Price) {
        properties.price = +split[PlanCodeItemIndex.Price];
    }
    if (split.length > PlanCodeItemIndex.SalishChannelKey) {
        properties.salishChannelKey = split[PlanCodeItemIndex.SalishChannelKey];
    }
    return properties;
};
const pagesUrlByProduct = {
    pro: 'https://pro.thestreet.com/',
    rd: 'https://www.thestreet.com/retirement-daily/',
    rtp: 'https://roundtable.io/',
    srt: 'http://thestreet.com/cryptocurrency',
    wm: 'https://warriormaven.com/'
};
const getPageUrlByPlanCode = (planCode) => {
    var _a;
    return pagesUrlByProduct[(_a = extractPropertiesFromPlanCode(planCode)) === null || _a === void 0 ? void 0 : _a.productCode];
};
const getSiteCodeFromPlanCode = (planCode) => {
    const siteCode = planCode.split('-')[0];
    return siteCode === 'tst' ? siteCode : 'default';
};
const getSubscriberTypeFromSubscriptions = (activeSubscriptions) => {
    const now = new Date();
    if (activeSubscriptions === null || activeSubscriptions === void 0 ? void 0 : activeSubscriptions.length) {
        const [inTrialSubs, notInTrialSubs] = partition(activeSubscriptions, s => {
            return s.trialEndsAt && new Date(s.trialEndsAt) > now;
        });
        if (notInTrialSubs.length) {
            const paidSubs = notInTrialSubs.filter(s => !!s.total);
            if (paidSubs.length) {
                return SubscriptionType.Paid;
            }
        }
        return inTrialSubs.length ? SubscriptionType.InTrial : SubscriptionType.Free;
    }
    else {
        return undefined;
    }
};
const getSubscriberInfoFromSubscriptions = (subscriptions) => {
    const subscriberInfo = {
        status: SubscriberStatus.NoSub,
        type: undefined
    };
    if (subscriptions === null || subscriptions === void 0 ? void 0 : subscriptions.length) {
        const activeSubscriptions = subscriptions.filter(s => s.state === 'active');
        subscriberInfo.status = activeSubscriptions.length ? SubscriberStatus.Active : SubscriberStatus.Inactive;
        subscriberInfo.type = getSubscriberTypeFromSubscriptions(activeSubscriptions);
    }
    return subscriberInfo;
};
const removeSubscriptionTypeFromPlanCode = (planCode) => {
    const planParts = planCode.split('-');
    if ((planParts === null || planParts === void 0 ? void 0 : planParts.length) === 6) {
        return `${planParts.slice(0, 4).join('-')}-${planParts.slice(-1)}`;
    }
};
const getInternalTaigaBase = (taigaPublicBase) => {
    return taigaPublicBase.replace('taiga', 'taiga-int');
};
const getDefaultTermsAndConditions = (siteKeyword, planCode, planName) => {
    const { tstText } = offerText;
    const termsAndConditions = [];
    termsAndConditions.push(DEFAULT_TERMS_AND_CONDITIONS[0]);
    switch (siteKeyword) {
        case 'thestreet':
            termsAndConditions.push({
                title: {
                    text: DEFAULT_TERMS_AND_CONDITIONS[1].title.text,
                    decoration: 'none',
                    isBold: true
                },
                contentText: tstText.disclaimers.renewal.text.replace('subscription', planName || 'subscription'),
                link: {
                    text: DEFAULT_TERMS_AND_CONDITIONS[1].link.text,
                    value: 'mailto:tstpaymentpage@thestreet.com'
                }
            });
            break;
        default:
            termsAndConditions.push(DEFAULT_TERMS_AND_CONDITIONS[1]);
            break;
    }
    return termsAndConditions;
};

const loadScript = (id, src, async = true, type = 'text/javascript') => {
    return new Promise((resolve, reject) => {
        try {
            const el = document.createElement('script');
            const container = document.head || document.body;
            el.type = type;
            el.async = async;
            el.src = src;
            el.id = id;
            el.addEventListener('load', () => {
                resolve({ status: true });
            });
            el.addEventListener('error', () => {
                reject({
                    status: false,
                    message: `Failed to load the script ${src}`
                });
            });
            container.appendChild(el);
        }
        catch (err) {
            reject(err);
        }
    });
};
const loadRecaptcha = (key) => __awaiter(void 0, void 0, void 0, function* () {
    loadScript('recaptcha-key', `https://www.google.com/recaptcha/api.js?render=${key}&badge=bottomleft`);
});
const getReCaptchaToken = (key) => __awaiter(void 0, void 0, void 0, function* () {
    return typeof window === 'undefined' || !(window === null || window === void 0 ? void 0 : window.grecaptcha)
        ? undefined
        : new Promise((res, rej) => {
            var _a;
            (_a = window === null || window === void 0 ? void 0 : window.grecaptcha) === null || _a === void 0 ? void 0 : _a.ready(() => {
                return window.grecaptcha.execute(key, { action: 'submit' }).then((token) => {
                    return res(token);
                });
            });
        });
});

const newsletterJsonData = {
    termsOfUseUrl,
    privacyPolicyUrl,
    SiData,
    TstData
};
const selfServicePortalJsonData = {
    caProvinces,
    usStates,
    countryList,
    eligibleShippingCountries,
    smsCountries
};
const whitepaperJsonData = {
    privacyPolicyUrl,
    termsOfUseUrl,
    ctaHeadline,
    ctaMessage,
    ctaUrl
};

export { Account, AlertList, AltVideo, ArrowUpAndDown, AuthCodeInputView$1 as AuthCodeInputView, BUTTON_DEFAULT_STATUS_TIMEOUT, BasketballLogo, Bell, BellIcon, BronzeMedal, ButtonGroupToggle, CheckMark, Checkmark, ChevronDown, ChevronLeft, ChevronRight, ChevronUp, ClassicInputView$1 as ClassicInputView, CloseIcon, CommentIcon, DeactiveClock, Delete, DownArrow, EAlertMedium, EAlertTriggerType, EProductItemType, EditIcon, EmailInputView$1 as EmailInputView, ErrorIcon, FacebookIcon, FilledQuoteIcon, FontWeight, FootBallLogo, GeneralAttachment, GoldMedal, InstagramIcon, KeyIcon, LikeIcon, LinkButton, LinkOpen, LinkVariant, LinkedinIcon, LoadingButton$1 as LoadingButton, LoadingView, Login, LoginDialog$1 as LoginDialog, LoginStep, LoginUsernameCollectionBehavior, MESSAGE_DEFAULT_STATUS_TIMEOUT, MavenFullLogo, MavenLogo, MenuIcon, MessageIcon, Minus, MoreHoriz, NEWSLETTER_SIGNUP_EVENT, NewsletterContext, Observable, ObserveAmount, PaymentInfoFillType, PermutiveAction, PermutiveEventCategory, PermutiveTrackingType, PhoneIcon, PinIcon, Plus, ProfileIcon, QuoteIcon, RedClock, RelativeSize, RepliesIcon, RepliesNewIcon, Search, SearchBarCloseIcon, SearchBarSearchIcon, SearchIcon, SilverMedal, SmallMusicIcon, SmallPhotoIcon, SmallVideoIcon, SspAppContext, SyncLogin, THE_STREET_PROPERTIES, TheArenaGroupLogo, TheStreetLogo, TwitterIcon, Type, UserContext, UserContextProvider, Video, WarningIcon, WhiteClock, YoutubeIcon, addDays, addMonths, createAlertApi, createProductItemApi, emptyUserLogin, extractPropertiesFromPlanCode, formatDate, formatIsoDate, getDefaultTermsAndConditions, getInternalTaigaBase, getPageUrlByPlanCode, getReCaptchaToken, getSiteCodeFromPlanCode, getSubscriberInfoFromSubscriptions, isValidEmail, isValidUrl, loadRecaptcha, newsletterJsonData, permutiveTrack, removeSubscriptionTypeFromPlanCode, selfServicePortalJsonData, sendAddToCartToDL, sendCheckoutToDL, sendNewsletterSignupInfoToDL, sendNewsletterSignupInfoWithProductItemIdsToDL, sendPaymentInfoFillToDL, sendProductClickToDL, sendProductImpressionToDL, sendRemoveFromCartToDL, sendSubscriberInfoToDL, sendTransactionToDL, selfServicePortalUserProfile as sspUserProfile, translateNewslettersFromApi, useAlertService, useDesktopOrHD, useLoginFlow$1 as useLoginFlow, useMobile, useNewsletterService, useSnackbar$1 as useSnackbar, useTablet, useToggle, userProfileService, validateUsername, whitepaperJsonData, windowExists };
